/* GENERATED by scripts/sync-to-store.mjs from local/src/js/. Do not edit here; edit the source in local/ and re-run the sync. */

(function () {
  var els = document.querySelectorAll('.reveal');
  if (!els.length) return;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion || !('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('is-visible'); });
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });

  els.forEach(function (el) { io.observe(el); });
})();

// Search overlay — opens from the header's search icon (any screen size — see data-search-trigger
// in header.html/header.liquid), shows live results as you type via Shopify's own predictive search
// endpoint. Results come from sections/predictive-search-results.liquid, fetched and injected here
// exactly the way product-recommendations.js and cart-page.js already fetch+inject their own
// sections — nothing new to learn about that part, just a new place it's used.
//
// Deliberately separate from cart-drawer.js (its own, differently-named scroll-lock/inert data
// attributes below), the same way video-modal.js and lightbox.js stay separate from each other —
// two of these could, at least in principle, end up open at once otherwise.
(function () {
  'use strict';

  var root = document.getElementById('search-overlay');
  if (!root) return;

  var panel = root.querySelector('.search-overlay__panel');
  var form = root.querySelector('[data-search-form]');
  var input = root.querySelector('[data-search-input]');
  var idleEl = root.querySelector('[data-search-idle]');
  var loadingEl = root.querySelector('[data-search-loading]');
  var resultsEl = root.querySelector('[data-search-results]');
  var errorEl = root.querySelector('[data-search-error]');
  var viewAllEl = root.querySelector('[data-search-viewall]');
  var viewAllTermEl = root.querySelector('[data-search-viewall-term]');
  var recentWrapEl = root.querySelector('[data-search-recent]');
  var recentListEl = root.querySelector('[data-search-recent-list]');
  var recentClearEl = root.querySelector('[data-search-recent-clear]');
  if (!panel || !form || !input || !resultsEl) return;

  // ---- recent searches (localStorage, same degrade-gracefully pattern wishlist.js uses - a blocked
  // or full storage just means recent searches silently don't persist, never a broken overlay) -------
  var RECENT_KEY = 'hm-recent-searches';
  var RECENT_MAX = 6;
  var recentMemoryCache = null;

  function readRecent() {
    try {
      var raw = window.localStorage.getItem(RECENT_KEY);
      var parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (err) {
      return recentMemoryCache || [];
    }
  }

  function writeRecent(list) {
    try {
      window.localStorage.setItem(RECENT_KEY, JSON.stringify(list));
      recentMemoryCache = null;
    } catch (err) {
      recentMemoryCache = list;
    }
  }

  // Called whenever someone actually commits to a search - clicking a result, hitting "view all", or
  // submitting the form - never on every debounced keystroke, which would fill this list with
  // half-typed fragments nobody would ever want to revisit.
  function commitRecent() {
    var term = input.value.trim();
    if (!term) return;
    var list = readRecent().filter(function (t) { return t.toLowerCase() !== term.toLowerCase(); });
    list.unshift(term);
    if (list.length > RECENT_MAX) list.length = RECENT_MAX;
    writeRecent(list);
  }

  var recentClockIcon = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 3"/></svg>';

  function renderRecent() {
    if (!recentWrapEl || !recentListEl) return;
    var list = readRecent();
    recentWrapEl.hidden = list.length === 0;
    recentListEl.innerHTML = '';
    list.forEach(function (term) {
      var chip = document.createElement('button');
      chip.type = 'button';
      chip.className = 'search-recent-chip';
      chip.setAttribute('data-search-recent-term', term);
      chip.innerHTML = recentClockIcon; // fixed, trusted markup - never built from the (untrusted) term
      var label = document.createElement('span');
      label.textContent = term; // textContent, not innerHTML - term is whatever someone typed
      chip.appendChild(label);
      recentListEl.appendChild(chip);
    });
  }

  if (recentClearEl) {
    recentClearEl.addEventListener('click', function () {
      writeRecent([]);
      renderRecent();
    });
  }

  if (recentListEl) {
    recentListEl.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-search-recent-term]');
      if (!chip) return;
      var term = chip.getAttribute('data-search-recent-term');
      input.value = term;
      input.focus();
      runSearch(term);
    });
  }

  // minChars: 1 - search starts from the very first keystroke rather than waiting for a second one.
  // A single letter can obviously match broadly (expected, same as any type-ahead search), but that's
  // exactly what the debounce + "view all results" link downstream are for - showing *something*
  // immediately reads as more responsive than making someone type twice before anything happens.
  var config = { searchUrl: '/search', suggestUrl: '/search/suggest', sectionId: 'predictive-search-results', minChars: 1, debounceMs: 250 };
  var configEl = root.querySelector('[data-search-config]');
  if (configEl) {
    try {
      var parsed = JSON.parse(configEl.textContent);
      for (var k in parsed) if (Object.prototype.hasOwnProperty.call(parsed, k)) config[k] = parsed[k];
    } catch (err) { /* keep the defaults above */ }
  }

  var reduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };

  var isOpen = false;
  var lastFocus = null;
  var debounceTimer = null;
  var activeController = null; // aborted on every new keystroke, so a slow older request can't land after a newer one
  var activeQuery = null; // belt-and-braces alongside AbortController - see runSearch()
  var highlightedIndex = -1;
  var currentItems = [];

  // ---- which pane is showing -----------------------------------------------------------------
  function showPane(name) {
    idleEl.hidden = name !== 'idle';
    loadingEl.hidden = name !== 'loading';
    resultsEl.hidden = name !== 'results';
    errorEl.hidden = name !== 'error';
  }

  // ---- open / close (inert + scroll-lock + focus-trap, same approach as cart-drawer.js) -------
  function focusable() {
    return Array.prototype.filter.call(
      panel.querySelectorAll('a[href], button, input, textarea, [tabindex]:not([tabindex="-1"])'),
      function (n) { return !n.disabled && !n.hidden && n.offsetParent !== null; }
    );
  }

  function lockPage(on) {
    var doc = document.documentElement;
    if (on) {
      doc.style.setProperty('--hm-search-sbw', (window.innerWidth - doc.clientWidth) + 'px');
      doc.classList.add('hm-search-lock');
      Array.prototype.forEach.call(document.body.children, function (n) {
        if (n !== root && !n.contains(root) && !n.hasAttribute('inert') && n.tagName !== 'SCRIPT') {
          n.setAttribute('inert', '');
          n.setAttribute('data-search-inert', '');
        }
      });
    } else {
      doc.classList.remove('hm-search-lock');
      Array.prototype.forEach.call(document.querySelectorAll('[data-search-inert]'), function (n) {
        n.removeAttribute('inert');
        n.removeAttribute('data-search-inert');
      });
    }
  }

  function open() {
    if (isOpen) return;
    isOpen = true;
    lastFocus = document.activeElement;
    root.hidden = false;
    lockPage(true);
    void root.offsetWidth; // let the closed styles apply before the open class changes them
    root.classList.add('is-open');
    input.value = '';
    activeQuery = null;
    highlightedIndex = -1;
    currentItems = [];
    showPane('idle');
    viewAllEl.hidden = true;
    input.setAttribute('aria-expanded', 'false');
    renderRecent(); // refreshed on every open, not just once at page load - picks up a search made
    // a moment ago, or a "Clear" from another tab (storage event, below).
    // A brief delay reads as deliberate rather than a focus "fighting" the opening transition on
    // touch, where the keyboard sliding up at the exact same instant as the panel animates in can
    // otherwise visibly stutter.
    setTimeout(function () { input.focus({ preventScroll: true }); }, reduce.matches ? 0 : 60);
  }

  function close() {
    if (!isOpen) return;
    isOpen = false;
    root.classList.remove('is-open');
    if (activeController) activeController.abort();
    clearTimeout(debounceTimer);
    var finish = function () {
      if (isOpen) return;
      root.hidden = true;
      lockPage(false);
      if (lastFocus && lastFocus.focus && document.contains(lastFocus)) lastFocus.focus({ preventScroll: true });
      lastFocus = null;
    };
    if (reduce.matches) finish();
    else setTimeout(finish, 260); // matches the CSS close transition
  }

  // ---- keyboard highlight through the results list ----------------------------------------------
  function setHighlight(index) {
    for (var i = 0; i < currentItems.length; i++) currentItems[i].classList.toggle('is-highlighted', i === index);
    if (currentItems[index]) currentItems[index].scrollIntoView({ block: 'nearest' });
    highlightedIndex = index;
  }

  // ---- fetching live results ----------------------------------------------------------------
  function runSearch(query) {
    activeQuery = query;
    if (activeController) activeController.abort();
    highlightedIndex = -1;

    if (!query || query.length < config.minChars) {
      showPane('idle');
      viewAllEl.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      return;
    }

    viewAllEl.hidden = false;
    viewAllEl.href = config.searchUrl + '?q=' + encodeURIComponent(query);
    if (viewAllTermEl) viewAllTermEl.textContent = query;

    showPane('loading');
    input.setAttribute('aria-expanded', 'true');

    var controller = window.AbortController ? new AbortController() : null;
    activeController = controller;
    // Deliberately *not* the .json endpoint - /search/suggest.json only ever returns the raw
    // {resources:{...}} data, never a rendered section, no matter what section_id is passed (confirmed
    // against Shopify's own docs after first building this against .json and getting an empty result
    // every time - an easy mistake, since .json otherwise looks like the obvious choice here). Getting
    // actual rendered HTML back requires the plain (non-.json) /search/suggest endpoint instead, whose
    // response is a full HTML fragment to parse and pluck the section out of - the exact same
    // DOMParser + querySelector technique product-recommendations.js and cart-page.js already use for
    // their own section fetches, just against this endpoint instead of a normal page URL.
    // resources[type] defaults to query,product,collection,page if omitted - deliberately listed out
    // in full here anyway, specifically to also add article (NOT included in that default), so a
    // search also surfaces matching journal posts, not just products/collections/pages. limit_scope
    // =each makes the limit apply *per type* rather than split across all four combined - otherwise a
    // query matching several products could crowd out collections/pages/articles entirely rather than
    // each type getting its own fair share. predictive-search-results.liquid (the section this
    // populates) trims each type down further still for display - this limit is just the fetch ceiling.
    // resources[options][fields] - pages/articles default to matching body+author+title (collections
    // are title-only regardless), which on a short query turns up matches that have nothing to do with
    // what someone's actually looking for (a word that happens to appear mid-paragraph in a page's
    // body copy, say). Restricted to title here so every non-product match is one the person can see
    // *why* it matched. Products ignore this param entirely either way - Shopify always searches every
    // product field (title, body, type, tag, vendor, sku, barcode) and that can't be narrowed down.
    var url = config.suggestUrl + '?q=' + encodeURIComponent(query) +
      '&section_id=' + encodeURIComponent(config.sectionId) +
      '&resources[type]=product,collection,page,article&resources[limit]=5&resources[limit_scope]=each' +
      '&resources[options][unavailable_products]=last&resources[options][fields]=title';

    fetch(url, controller ? { signal: controller.signal } : {})
      .then(function (res) { if (!res.ok) throw new Error('search ' + res.status); return res.text(); })
      .then(function (text) {
        if (query !== activeQuery) return; // a newer keystroke already moved on — this response is stale
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var section = doc.getElementById('shopify-section-' + config.sectionId);
        resultsEl.innerHTML = section ? section.innerHTML : '';
        currentItems = Array.prototype.slice.call(resultsEl.querySelectorAll('.predictive-search-item'));
        showPane('results');
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return; // expected — a newer keystroke cancelled this one
        if (query !== activeQuery) return;
        showPane('error');
      });
  }

  input.addEventListener('input', function () {
    clearTimeout(debounceTimer);
    var query = input.value.trim();
    debounceTimer = setTimeout(function () { runSearch(query); }, config.debounceMs);
  });

  // Enter submits the form natively (the full-page fallback this already works as, with zero JS —
  // action="{{ routes.search_url }}" method="get") UNLESS a result is currently keyboard-highlighted,
  // in which case Enter should go *there* instead — the standard combobox/autocomplete convention.
  form.addEventListener('submit', function (e) {
    commitRecent();
    if (highlightedIndex >= 0 && currentItems[highlightedIndex]) {
      e.preventDefault();
      window.location.href = currentItems[highlightedIndex].href;
    }
  });

  // Clicking any result row or "view all" is someone committing to this search, same as submitting the
  // form - both are plain <a> links so the browser's own default navigation still does the actual work
  // here, this just remembers the term on the way out.
  resultsEl.addEventListener('click', function (e) {
    if (e.target.closest('.predictive-search-item')) commitRecent();
  });
  if (viewAllEl) viewAllEl.addEventListener('click', commitRecent);

  input.addEventListener('keydown', function (e) {
    if (!currentItems.length) return;
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      setHighlight(highlightedIndex < currentItems.length - 1 ? highlightedIndex + 1 : 0);
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      setHighlight(highlightedIndex > 0 ? highlightedIndex - 1 : currentItems.length - 1);
    }
  });

  // ---- triggers + close (delegated — data-search-trigger can be more than one element, and
  // data-search-close lives on both the backdrop and the explicit close button) -------------------
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-search-trigger]');
    if (trigger) { e.preventDefault(); open(); return; }
    var closer = e.target.closest('[data-search-close]');
    if (closer && root.contains(closer)) close();
  });

  document.addEventListener('keydown', function (e) {
    if (!isOpen) return;
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') return;
    var items = focusable();
    if (!items.length) { e.preventDefault(); panel.focus(); return; }
    var first = items[0];
    var last = items[items.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    else if (!panel.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
  });

  // Fires in *other* tabs/windows when localStorage changes here (never in the same tab that made the
  // change) - same cross-tab sync wishlist.js already relies on. Only worth re-rendering while actually
  // open and idle; if results are showing, the recent list isn't even visible right now anyway.
  window.addEventListener('storage', function (e) {
    if (e.key === RECENT_KEY && isOpen) renderRecent();
  });
})();

// Wishlist — a simple, fully client-side "save for later" list, kept in localStorage. There's no
// native Shopify wishlist, and this doesn't need a customer account or an app to be genuinely useful.
//
// The one job here: wiring every .wishlist-btn on the page — and there can be many; the same
// product's card can appear in bestsellers, a collection grid, search results and "you may also
// like" all at once — so they all toggle, animate and stay in sync with each other and with
// localStorage. (The header icon is a plain, static link - no count badge - so there's nothing for
// this file to update there.)
//
// The wishlist *page* itself (fetching and rendering the saved products from Shopify) is store-only
// and lives in wishlist-page.js — this file has no product-catalogue dependency at all, so it's
// exactly as useful, and exactly as testable, on the static local prototype as on the real store.
(function () {
  'use strict';

  var STORAGE_KEY = 'hm-wishlist';
  var EVENT = 'hm:wishlist-change';
  var reduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };

  // ---- storage ------------------------------------------------------------------------------
  // Never lets a storage failure (private browsing with storage disabled, a full quota, a browser
  // that blocks it outright) break the button itself — it just silently stops persisting, degrading
  // the same way the rest of this theme already treats localStorage as unreliable. memoryCache is
  // what actually makes that degrade gracefully rather than brokenly: without it, every read goes
  // straight back to the (still-blocked) real storage and comes back empty, so a toggle would look
  // like it worked for a moment and then silently un-toggle itself the instant anything re-checked
  // the state — which, since every toggle itself immediately triggers exactly that re-check (see
  // refresh(), below), would in practice mean every single click.
  var memoryCache = null;

  function readAll() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      var parsed = raw ? JSON.parse(raw) : {};
      return parsed && typeof parsed === 'object' ? parsed : {};
    } catch (err) {
      return memoryCache || {};
    }
  }

  function writeAll(map) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
      memoryCache = null; // storage worked - nothing to fall back to, and no stale copy left to drift
    } catch (err) {
      memoryCache = map; // storage refused it - keep this page view self-consistent anyway
    }
  }

  function isWishlisted(id) {
    if (!id) return false;
    return Object.prototype.hasOwnProperty.call(readAll(), String(id));
  }

  function toggle(id, handle) {
    if (!id) return false;
    id = String(id);
    var all = readAll();
    var nowLiked;
    if (Object.prototype.hasOwnProperty.call(all, id)) {
      delete all[id];
      nowLiked = false;
    } else {
      all[id] = { handle: handle || '', savedAt: Date.now() };
      nowLiked = true;
    }
    writeAll(all);
    document.dispatchEvent(new CustomEvent(EVENT, { detail: { id: id, liked: nowLiked } }));
    return nowLiked;
  }

  // For removing a stale entry (the product behind it no longer resolves - deleted, unpublished, a
  // changed handle) rather than a person actively un-saving it - see wishlist-page.js, the only
  // current caller. Goes through the same event/storage path as toggle() so every button and badge
  // stays correctly in sync either way, without wishlist-page.js needing to know anything about how
  // this is actually persisted.
  function remove(id) {
    if (!id) return;
    id = String(id);
    var all = readAll();
    if (!Object.prototype.hasOwnProperty.call(all, id)) return;
    delete all[id];
    writeAll(all);
    document.dispatchEvent(new CustomEvent(EVENT, { detail: { id: id, liked: false } }));
  }

  function count() {
    return Object.keys(readAll()).length;
  }

  // ---- applying visual state to every matching button on the page ---------------------------
  function applyState(btn) {
    var id = btn.dataset.productId;
    if (!id) return;
    var liked = isWishlisted(id);
    btn.classList.toggle('is-active', liked);
    btn.setAttribute('aria-pressed', liked ? 'true' : 'false');
    btn.setAttribute('aria-label', liked ? 'Remove from wishlist' : 'Add to wishlist');
  }

  function applyAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var buttons = scope.querySelectorAll('.wishlist-btn[data-product-id]');
    for (var i = 0; i < buttons.length; i++) applyState(buttons[i]);
  }

  function refresh(root) {
    applyAll(root);
  }

  // A small pop — never on *removing* from the wishlist (see the click handler below), only on
  // adding; undoing something isn't usually a moment worth celebrating the same way. Timer lives on
  // the button itself rather than one shared variable, so rapid repeat clicks on different buttons
  // (or the same one) each clean up correctly instead of one click's timeout cancelling a different
  // click's still-running animation. 320ms matches the (deliberately brief) CSS animation itself
  // (.wishlist-btn.is-animating .wishlist-btn__icon, product-card.css) with a small margin.
  function pulse(btn) {
    if (reduce.matches) return;
    btn.classList.remove('is-animating');
    void btn.offsetWidth; // restart the animation even on rapid repeated clicks
    btn.classList.add('is-animating');
    if (btn._wishlistAnimTimer) clearTimeout(btn._wishlistAnimTimer);
    btn._wishlistAnimTimer = setTimeout(function () {
      btn.classList.remove('is-animating');
      btn._wishlistAnimTimer = null;
    }, 320);
  }

  // ---- click handling (event delegation) -----------------------------------------------------
  // Delegated on document, not wired per-button: product-card grids get rebuilt wholesale more than
  // once after the page first loads (product-recommendations.js and cart-page.js both replace a whole
  // section's innerHTML with freshly-fetched markup once Shopify's own recommendation engine
  // responds), and a per-button listener would simply be gone the instant that happens. One delegated
  // listener needs wiring exactly once and keeps working regardless of how or when new buttons appear.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.wishlist-btn[data-product-id]');
    if (!btn) return;
    e.preventDefault(); // this button is never inside a <form>, but belt-and-braces
    var liked = toggle(btn.dataset.productId, btn.dataset.productHandle || '');
    if (liked) pulse(btn);
  });

  // Every button re-syncs off this one event, rather than each call site (the click handler above,
  // wishlist-page.js's own cleanup of stale entries, anything else later) having to remember to call
  // refresh() itself - toggle()/remove() already dispatch it unconditionally, so this is the one
  // place that actually has to.
  document.addEventListener(EVENT, function () { refresh(); });

  // ---- staying in sync with content that shows up after the initial page load -----------------
  // Covers the same two dynamic-replace cases mentioned above, plus anything else that might ever
  // inject a product card later — intentionally general rather than hard-coded to those two specific
  // call sites, so a future section doing the same thing doesn't silently need its own fix here too.
  if (window.MutationObserver) {
    var mo = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if (node.matches && node.matches('.wishlist-btn[data-product-id]')) applyState(node);
          if (node.querySelectorAll) applyAll(node);
        }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  // ---- staying in sync across browser tabs -----------------------------------------------------
  // Fires in *other* tabs/windows when localStorage changes here (never in the same tab that made the
  // change — that one already updated itself directly above) — without this, wishlisting something in
  // one tab and switching to another tab already showing that same product would leave it looking
  // stale there until a manual reload.
  window.addEventListener('storage', function (e) {
    if (e.key === STORAGE_KEY) refresh();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { refresh(); });
  } else {
    refresh();
  }

  // Exposed for wishlist-page.js (and anything else that genuinely needs the raw list, rather than
  // just toggling/displaying one button) — a deliberately small surface, not a general pub/sub bus.
  window.HMWishlist = {
    isWishlisted: isWishlisted,
    toggle: toggle,
    remove: remove,
    count: count,
    getAll: readAll,
    refresh: refresh,
    EVENT: EVENT,
  };
})();

// Wishlist page — store only (needs real Shopify product data, which the static local prototype has
// none of; the guard below makes this a no-op everywhere else, including there). Renders the saved
// products by fetching each one's /products/{handle}.js — Shopify's built-in AJAX product JSON
// endpoint, no app or backend needed — and building a card that matches snippets/product-card.liquid's
// own markup/classes closely enough to share every bit of its CSS, just assembled in JS instead of
// Liquid: there's no way to know *which* products a given visitor has saved until this script actually
// runs in their browser and reads localStorage, and Liquid only ever runs once, server-side, before
// any of that exists.
(function () {
  'use strict';

  var page = document.querySelector('[data-wishlist-page]');
  if (!page || !window.HMWishlist || !window.fetch) return;

  var grid = page.querySelector('[data-wishlist-grid]');
  var emptyState = page.querySelector('[data-wishlist-empty]');
  var loading = page.querySelector('[data-wishlist-loading]');
  var errorState = page.querySelector('[data-wishlist-error]');
  var countLabel = page.querySelector('[data-wishlist-count-label]');
  if (!grid || !emptyState || !loading) return;

  var HEART_PATH = 'M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z';

  function money(cents) {
    // Shopify's AJAX product JSON always prices in the shop's smallest currency unit (cents, or
    // paise for INR) - formatting it with Intl directly here (rather than trying to replicate
    // money_without_trailing_zeros' own Liquid logic by hand) gets the same "no decimals unless there
    // actually are any" behaviour for free, and stays correct if the store's currency ever changes.
    var amount = cents / 100;
    var hasFraction = Math.round(amount * 100) % 100 !== 0;
    try {
      return amount.toLocaleString('en-IN', {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'INR',
        minimumFractionDigits: hasFraction ? 2 : 0,
        maximumFractionDigits: 2,
      });
    } catch (err) {
      return '₹' + amount.toLocaleString('en-IN', { minimumFractionDigits: hasFraction ? 2 : 0, maximumFractionDigits: 2 });
    }
  }

  function heartIconHtml() {
    return (
      '<span class="wishlist-btn__icon">' +
      '<svg class="wishlist-btn__outline" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="' + HEART_PATH + '"/></svg>' +
      '<svg class="wishlist-btn__filled" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="' + HEART_PATH + '"/></svg>' +
      '</span>'
    );
  }

  function buildCard(product) {
    var soldOut = !product.available;
    var article = document.createElement('article');
    article.className = 'product-card' + (soldOut ? ' is-sold-out' : '');

    var media = document.createElement('div');
    media.className = 'product-media';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'wishlist-btn is-active';
    btn.setAttribute('data-product-id', product.id);
    btn.setAttribute('data-product-handle', product.handle);
    btn.setAttribute('aria-pressed', 'true');
    btn.setAttribute('aria-label', 'Remove from wishlist');
    btn.innerHTML = heartIconHtml();
    media.appendChild(btn);

    if (soldOut) {
      var tag = document.createElement('span');
      tag.className = 'sold-out-tag';
      tag.textContent = 'Sold out';
      media.appendChild(tag);
    }

    var link = document.createElement('a');
    link.href = product.url;
    if (product.featured_image) {
      var img = document.createElement('img');
      img.src = product.featured_image;
      img.loading = 'lazy';
      img.alt = product.title;
      img.width = 600;
      link.appendChild(img);
    } else {
      link.setAttribute('aria-label', product.title);
    }
    media.appendChild(link);
    article.appendChild(media);

    var info = document.createElement('div');
    info.className = 'product-info';

    var h3 = document.createElement('h3');
    var titleLink = document.createElement('a');
    titleLink.href = product.url;
    titleLink.textContent = product.title;
    h3.appendChild(titleLink);
    info.appendChild(h3);

    var sub = document.createElement('p');
    sub.className = 'product-sub';
    sub.textContent = product.type || '';
    info.appendChild(sub);

    var footer = document.createElement('div');
    footer.className = 'product-footer';
    var priceSpan = document.createElement('span');
    var varies = !!product.price_varies;
    priceSpan.className = 'price' + (varies ? ' price-from' : '');
    priceSpan.appendChild(document.createTextNode((varies ? 'From ' : '') + money(product.price)));
    if (product.compare_at_price > product.price && !varies) {
      var s = document.createElement('s');
      s.className = 'price-compare';
      s.textContent = money(product.compare_at_price);
      priceSpan.appendChild(document.createTextNode(' '));
      priceSpan.appendChild(s);
    }
    footer.appendChild(priceSpan);
    info.appendChild(footer);

    article.appendChild(info);
    return article;
  }

  function setCountLabel(n) {
    if (!countLabel) return;
    countLabel.textContent = n === 0 ? '' : n === 1 ? '1 item' : n + ' items';
  }

  function showEmpty() {
    loading.hidden = true;
    grid.hidden = true;
    if (errorState) errorState.hidden = true;
    emptyState.hidden = false;
    setCountLabel(0);
  }

  function render() {
    var saved = window.HMWishlist.getAll();
    var ids = Object.keys(saved);

    if (ids.length === 0) {
      showEmpty();
      return;
    }

    emptyState.hidden = true;
    if (errorState) errorState.hidden = true;
    loading.hidden = false;
    grid.hidden = true;

    var fetchesFailed = false;
    Promise.all(
      ids.map(function (id) {
        var handle = saved[id].handle;
        if (!handle) return null;
        return fetch('/products/' + handle + '.js')
          .then(function (res) { return res.ok ? res.json() : null; })
          .catch(function () { fetchesFailed = true; return undefined; }); // undefined: a real network
          // failure, kept apart from null (resolved fine, product genuinely doesn't exist) below -
          // only the latter should ever cause a saved item to be forgotten.
      })
    ).then(function (results) {
      var valid = [];
      var staleIds = [];
      ids.forEach(function (id, i) {
        var product = results[i];
        if (product) valid.push(product);
        else if (product === null) staleIds.push(id); // resolved: genuinely gone, not just offline
      });

      staleIds.forEach(function (id) { window.HMWishlist.remove(id); });

      loading.hidden = true;

      if (valid.length === 0) {
        if (fetchesFailed && window.HMWishlist.count() > 0) {
          // Nothing rendered, but not because the wishlist is actually empty - a real fetch failure
          // (offline, the store's API briefly unreachable) shouldn't quietly look identical to "you
          // have no saved items", which would otherwise read as this page having silently thrown them
          // all away.
          grid.hidden = true;
          if (errorState) errorState.hidden = false;
          setCountLabel(0);
          return;
        }
        showEmpty();
        return;
      }

      grid.innerHTML = '';
      valid.forEach(function (p) { grid.appendChild(buildCard(p)); });
      grid.hidden = false;
      setCountLabel(valid.length);
      window.HMWishlist.refresh(grid); // belt-and-braces - every card above is already built "liked"
    });
  }

  // Un-liking a card from within the wishlist page itself removes it from view right away, rather
  // than just un-filling its heart and leaving a now-irrelevant card still sitting there.
  document.addEventListener(window.HMWishlist.EVENT, function (e) {
    if (e.detail.liked) return;
    var btn = grid.querySelector('.wishlist-btn[data-product-id="' + e.detail.id + '"]');
    var article = btn && btn.closest('.product-card');
    if (!article) return;
    article.style.transition = 'opacity 0.25s ease, transform 0.25s ease';
    article.style.opacity = '0';
    article.style.transform = 'scale(0.96)';
    setTimeout(function () {
      article.remove();
      if (!grid.children.length) showEmpty();
    }, 250);
  });

  render();
})();

(function () {
  var toggle = document.querySelector('.menu-toggle');
  var nav = document.getElementById('mobile-nav');
  var panel = nav ? nav.querySelector('.mobile-nav-panel') : null;
  var closeBtn = document.querySelector('.mobile-nav-close');
  if (!toggle || !nav || !panel) return;

  var lastFocus = null;

  // Same inert+focus-trap+Escape pattern as every other overlay in this theme (cart-drawer.js,
  // search-overlay.js) - distinctly named lock class/inert marker so it never collides with theirs.
  function focusable() {
    return Array.prototype.filter.call(
      panel.querySelectorAll('a[href], button, input, textarea, [tabindex]:not([tabindex="-1"])'),
      function (n) { return !n.disabled && !n.hidden && n.offsetParent !== null; }
    );
  }

  // Unlike the cart drawer/search overlay (each its own top-level sibling of <body>), #mobile-nav
  // lives nested inside <header> (next to the logo, search/wishlist/cart icons, the toggle itself).
  // A single body.children pass that just skips "whatever contains nav" would leave that whole
  // header - every icon beside the toggle - still reachable, not just visually behind the drawer but
  // genuinely inert-free: a keyboard Tab is already stopped by the trap below, but a screen reader's
  // own swipe/virtual-cursor navigation doesn't go through Tab at all and would still land on them.
  // Walking up from nav and inerting every *other* sibling at each level (not just at the top) covers
  // that properly - the header's own icon row ends up just as inert as the rest of the page.
  function lockPage(on) {
    var doc = document.documentElement;
    if (on) {
      doc.style.setProperty('--hm-mobile-nav-sbw', (window.innerWidth - doc.clientWidth) + 'px');
      doc.classList.add('hm-mobile-nav-lock');
      var el = nav;
      while (el && el !== document.body) {
        var parent = el.parentElement;
        if (parent) {
          Array.prototype.forEach.call(parent.children, function (sib) {
            if (sib !== el && !sib.hasAttribute('inert') && sib.tagName !== 'SCRIPT') {
              sib.setAttribute('inert', '');
              sib.setAttribute('data-mobile-nav-inert', '');
            }
          });
        }
        el = parent;
      }
    } else {
      doc.classList.remove('hm-mobile-nav-lock');
      Array.prototype.forEach.call(document.querySelectorAll('[data-mobile-nav-inert]'), function (n) {
        n.removeAttribute('inert');
        n.removeAttribute('data-mobile-nav-inert');
      });
    }
  }

  function closeMenu() {
    if (!nav.classList.contains('is-open')) return;
    toggle.classList.remove('is-active');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-label', 'Open menu');
    nav.classList.remove('is-open');
    lockPage(false);
    if (lastFocus && lastFocus.focus && document.contains(lastFocus)) lastFocus.focus({ preventScroll: true });
    lastFocus = null;
  }

  function openMenu() {
    if (nav.classList.contains('is-open')) return;
    lastFocus = document.activeElement;
    toggle.classList.add('is-active');
    toggle.setAttribute('aria-expanded', 'true');
    toggle.setAttribute('aria-label', 'Close menu');
    nav.classList.add('is-open');
    lockPage(true);
    panel.focus({ preventScroll: true });
  }

  toggle.addEventListener('click', function () {
    if (nav.classList.contains('is-open')) closeMenu(); else openMenu();
  });

  if (closeBtn) closeBtn.addEventListener('click', closeMenu);

  nav.addEventListener('click', function (e) {
    if (e.target === nav) closeMenu();
  });

  nav.querySelectorAll('.mobile-nav-links a').forEach(function (link) {
    link.addEventListener('click', closeMenu);
  });

  document.addEventListener('keydown', function (e) {
    if (!nav.classList.contains('is-open')) return;
    if (e.key === 'Escape') { e.preventDefault(); closeMenu(); return; }
    if (e.key !== 'Tab') return;
    var items = focusable();
    if (!items.length) { e.preventDefault(); panel.focus(); return; }
    var first = items[0];
    var last = items[items.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    else if (!panel.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
  });

  window.addEventListener('resize', function () {
    if (window.innerWidth > 1080) closeMenu();
  });
})();

(function () {
  var grid = document.querySelector('.testimonial-grid');
  var prev = document.querySelector('.testimonial-prev');
  var next = document.querySelector('.testimonial-next');
  var dots = document.querySelectorAll('.testimonial-dots .dot');
  if (!grid || !prev || !next || !dots.length) return;

  function cardWidth() {
    var card = grid.querySelector('.testimonial-card');
    return card ? card.getBoundingClientRect().width : grid.clientWidth;
  }

  prev.addEventListener('click', function () {
    grid.scrollBy({ left: -cardWidth(), behavior: 'smooth' });
  });

  next.addEventListener('click', function () {
    grid.scrollBy({ left: cardWidth(), behavior: 'smooth' });
  });

  var ticking = false;
  grid.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      var index = Math.round(grid.scrollLeft / cardWidth());
      index = Math.max(0, Math.min(dots.length - 1, index));
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
      ticking = false;
    });
  });
})();

(function () {
  var toggles = document.querySelectorAll('.footer-toggle');
  if (!toggles.length) return;

  toggles.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!expanded));
      btn.closest('.footer-accordion').classList.toggle('is-open', !expanded);
    });
  });
})();

// Full-screen image viewer.
//
//   HimMoolLightbox.open({
//     items:  [{ src, alt, preview? }],   src = large image, preview = an already-loaded version to show first
//     index:  number,                      photo to open on
//     getOriginRect: () => DOMRect,        where the photo sits on the page (for the open / close motion)
//     onChange: (index) => void,           called when the viewer moves to another photo
//     onClose:  () => void,
//   })
//
// Circular navigation, click-to-zoom with pan, keyboard, swipe, focus trap. All motion respects
// prefers-reduced-motion. The markup is built here, so nothing needs adding to the page templates.
//
// Photo-to-photo swiping is a native CSS scroll-snap track (see .hm-lb-stage in lightbox.css) - the
// same mechanism the homepage testimonials carousel uses (testimonial-slider.js / testimonials.css).
// The browser handles the swipe itself: momentum, rubber-band snap-back if released before the
// threshold, settling on release. This file only reacts once a swipe has *settled* on a different
// page, the same way testimonial-slider.js's scroll listener only reacts once scrolling has moved
// past a card boundary. Everything that native scrolling can't do on its own - pinch-to-zoom, pan
// while zoomed, double-tap, swipe-down-to-close, the phone back button closing the viewer - stays as
// this file's own pointer/keyboard handling, layered on top and left alone by this rewrite.
//
// Every photo gets its own real, permanent page in the track (see buildPages()) - not a small
// recycled window rewritten on every navigation. That matters for a fast run of several swipes in a
// row: the browser merges a new swipe into the previous one's still-settling momentum whenever it
// starts before that has fully stopped (well within normal fast-swiping speed), so a design that only
// ever has "one more page" to reach at the edge of a recycled window caps a whole flurry of quick
// swipes at a single step forward. With every photo already a real page, that same merged scroll can
// freely carry on across as many of them as the cumulative motion reaches. Circular wrap-around is
// still there, via one cloned page at each end (a copy of the last photo before the first real one, a
// copy of the first after the last) - swiping past either end lands on its clone, which looks
// identical to the real thing, then gets instantly re-centred onto the real page it's a stand-in for.
// That's the *only* place left that still needs the recentring trick the old recycled-window design
// needed on every single transition.
(function () {
  var EASE = 'cubic-bezier(0.22, 1, 0.36, 1)';
  var ZOOM_MS = 460;
  var reduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var ICONS = {
    close: '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18" /></svg>',
    prev: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M15 5l-7 7 7 7" /></svg>',
    next: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M9 5l7 7-7 7" /></svg>',
  };

  var root, stage, btnClose, btnPrev, btnNext, counter, live;
  // Every page currently in the track. For a single-photo gallery, just that one page. Otherwise:
  // [clone-of-last, item 0, item 1, ..., item N-1, clone-of-first] - see buildPages(). Rebuilt fresh
  // on every open() (the item count varies by product, so these can't be built once and reused the
  // way root/stage/buttons are).
  var pages = [];
  var s = null; // state while open
  var cache = {};
  // Whether a history entry is currently sitting on the stack for the open viewer (see open()) -
  // module-level, not on s, because it needs to survive being read from the popstate handler even
  // in the instant *between* a user's real back-button press and s finally becoming null.
  var historyState = false;

  function ms(n) { return reduce.matches ? 0 : n; }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function wait(n) { return new Promise(function (r) { setTimeout(r, n); }); }
  // Where a given item index sits in the pages array - 0 for a single-photo gallery (no clones), or
  // index+1 otherwise (position 0 is reserved for the leading clone-of-last).
  function pagePos(itemIndex) { return s.items.length < 2 ? 0 : itemIndex + 1; }
  function current() { return pages[pagePos(s.index)]; }

  // ---- image loading ------------------------------------------------------------------------
  function preload(src) {
    if (cache[src]) return cache[src];
    cache[src] = new Promise(function (resolve, reject) {
      var img = new Image();
      img.onload = function () {
        (img.decode ? img.decode().catch(function () {}) : Promise.resolve()).then(function () { resolve(img); });
      };
      img.onerror = function () { delete cache[src]; reject(new Error('image failed: ' + src)); };
      img.src = src;
    });
    return cache[src];
  }

  // ---- markup -------------------------------------------------------------------------------
  function build() {
    if (root) return;
    root = document.createElement('div');
    root.className = 'hm-lightbox';
    root.hidden = true;
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-modal', 'true');
    root.tabIndex = -1; // focus lands on the viewer itself, so mouse users see no ring; Tab then reaches the buttons
    root.setAttribute('aria-label', 'Image viewer');
    root.innerHTML =
      '<div class="hm-lb-backdrop"></div>' +
      '<div class="hm-lb-stage"></div>' +
      '<button type="button" class="hm-lb-btn hm-lb-close" aria-label="Close image viewer">' + ICONS.close + '</button>' +
      '<button type="button" class="hm-lb-btn hm-lb-prev" aria-label="Previous image">' + ICONS.prev + '</button>' +
      '<button type="button" class="hm-lb-btn hm-lb-next" aria-label="Next image">' + ICONS.next + '</button>' +
      '<div class="hm-lb-counter" aria-hidden="true"></div>' +
      '<div class="hm-lb-spinner" aria-hidden="true"></div>' +
      '<div class="hm-lb-live" aria-live="polite"></div>';
    document.body.appendChild(root);
    stage = root.querySelector('.hm-lb-stage');
    btnClose = root.querySelector('.hm-lb-close');
    btnPrev = root.querySelector('.hm-lb-prev');
    btnNext = root.querySelector('.hm-lb-next');
    counter = root.querySelector('.hm-lb-counter');
    live = root.querySelector('.hm-lb-live');

    btnClose.addEventListener('click', function () { close(); });
    btnPrev.addEventListener('click', function () { go(-1); });
    btnNext.addEventListener('click', function () { go(1); });
    root.querySelector('.hm-lb-backdrop').addEventListener('click', function () { close(); });
    stage.addEventListener('click', onStageClick);
    stage.addEventListener('pointerdown', onPointerDown);
    window.addEventListener('pointermove', onPointerMove);
    window.addEventListener('pointerup', onPointerUp);
    window.addEventListener('pointercancel', onPointerUp);
    // 'scroll' is the cross-browser fallback (debounced below); 'scrollend' is the precise modern
    // event - where both fire for the same settle, handleSettle() is idempotent (see there).
    stage.addEventListener('scroll', onScroll, { passive: true });
    stage.addEventListener('scrollend', onScrollEnd, { passive: true });
    document.addEventListener('keydown', onKeyDown);
    window.addEventListener('resize', onResize);
    // A phone/tablet's back button (or gesture) should close the viewer, not navigate the page
    // away - see open()'s history.pushState for the other half of this. Guarded by `!s.closing` so
    // this never double-fires close(): whether the back press itself triggered this popstate, or a
    // UI close (X/Escape/backdrop/swipe) triggered its own history.back() to clean up after itself,
    // only one of the two ever finds s still open and not already closing.
    window.addEventListener('popstate', function () {
      if (s && !s.closing) { historyState = false; close(); }
    });
  }

  // ---- layout -------------------------------------------------------------------------------
  function available() {
    var narrow = window.innerWidth <= 760;
    return {
      w: window.innerWidth - (narrow ? 24 : 200),
      h: window.innerHeight - (narrow ? 140 : 150),
    };
  }

  // .hm-lb-stage is deliberately taller than the viewport (see the CSS) so that wherever a browser
  // still insists on rendering the track's scrollbar, it lands in that extra strip and gets clipped
  // away rather than shown. .hm-lb-page pins to this instead of stretching to match - window.innerHeight
  // (not a plain CSS 100%/100vh) so it stays correct even where the two disagree, e.g. a mobile
  // browser whose address bar is currently showing.
  function updatePageHeight() {
    root.style.setProperty('--hm-lb-page-h', window.innerHeight + 'px');
  }

  // Size a page's photo to fit the screen ("contain"), without blowing small images up much.
  function fit(page) {
    var a = available();
    var nw = page.nw;
    var nh = page.nh;
    if (!nw || !nh) return;
    var scale = Math.min(a.w / nw, a.h / nh, 1.5);
    page.w = Math.round(nw * scale);
    page.h = Math.round(nh * scale);
    page.el.style.width = page.w + 'px';
    page.el.style.height = page.h + 'px';
    page.zoomScale = clamp(nw / page.w, 2, 3.2);
  }

  function makePage(item, itemIndex) {
    var pageEl = document.createElement('div');
    pageEl.className = 'hm-lb-page';
    var slideEl = document.createElement('div');
    slideEl.className = 'hm-lb-slide';
    var img = document.createElement('img');
    img.className = 'hm-lb-img';
    img.alt = item.alt || '';
    img.draggable = false;
    slideEl.appendChild(img);
    pageEl.appendChild(slideEl);
    return { pageEl: pageEl, el: slideEl, img: img, itemIndex: itemIndex, nw: 0, nh: 0, w: 0, h: 0,
      zoomed: false, zoomScale: 2, scale: 1, tx: 0, ty: 0, ttx: 0, tty: 0, animating: false };
  }

  // Builds the whole track fresh for this open() - one real page per photo, plus (for a gallery of 2
  // or more) a cloned page at each end for the wrap-around seam. See the file header for why this is
  // every photo up front rather than a small recycled window.
  function buildPages(items) {
    stage.innerHTML = '';
    var n = items.length;
    var order = n < 2 ? [0] : [n - 1].concat(items.map(function (_, i) { return i; }), [0]);
    pages = order.map(function (itemIndex) { return makePage(items[itemIndex], itemIndex); });
    pages.forEach(function (p) { stage.appendChild(p.pageEl); });
  }

  // Loads one page's photo independently, off the shared preload() cache - reopening a gallery the
  // viewer has already shown resolves this instantly, off an already-decoded image. There's no token
  // to guard here the way an earlier, recycled-window version of this file needed: a page's itemIndex
  // never changes after it's created (see buildPages()), so a slow load finishing late just updates
  // the one page it was always meant for, even if the viewer has since moved on or closed entirely
  // (updating a detached, no-longer-visible element is harmless).
  function loadPage(page) {
    var item = s.items[page.itemIndex];
    preload(item.src).then(function (img) {
      page.img.src = img.currentSrc || img.src;
      page.img.alt = item.alt || '';
      page.nw = img.naturalWidth;
      page.nh = img.naturalHeight;
      fit(page);
    }).catch(function () {}); // that one page just shows nothing - the rest of the viewer still works
  }

  // ---- open / close -------------------------------------------------------------------------
  function open(opts) {
    if (s) return;
    build();
    var items = opts.items || [];
    if (!items.length) return;
    var index = clamp(opts.index || 0, 0, items.length - 1);
    var item = items[index];
    var first = opts.preview ? preload(opts.preview) : preload(item.src);

    s = { items: items, index: index, opts: opts, busy: true, opener: document.activeElement,
      pointer: null, suppressClick: false, raf: 0, closing: false, recentering: false, scrollSettleTimer: 0,
      touchPoints: {}, pinchStartDist: 0, pinchStartScale: 1, lastTap: null, lastPointerType: null };

    buildPages(items);

    // Lock the page behind, without the layout jumping when the scrollbar disappears.
    var sbw = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.setProperty('--hm-lb-sbw', sbw + 'px');
    document.documentElement.classList.add('hm-lb-lock');
    Array.prototype.forEach.call(document.body.children, function (el) {
      if (el !== root && !el.hasAttribute('inert')) { el.setAttribute('inert', ''); el.dataset.lbInert = '1'; }
    });

    root.hidden = false;
    root.classList.toggle('is-single', items.length < 2);
    updatePageHeight();
    updateChrome();

    var spinnerTimer = setTimeout(function () { root.classList.add('is-loading'); }, 150);
    first.then(function (img) {
      clearTimeout(spinnerTimer);
      root.classList.remove('is-loading');
      if (!s) return;
      var page = current();
      page.img.src = img.currentSrc || img.src;
      page.img.alt = item.alt || '';
      page.nw = img.naturalWidth;
      page.nh = img.naturalHeight;
      fit(page);
      // Put the opened photo's page under the viewport *before* anything becomes visible - direct
      // scrollLeft assignment is always instant (unlike scrollTo/scrollBy, it never respects CSS
      // scroll-behavior), so this never itself produces a visible slide-in.
      stage.scrollLeft = pagePos(index) * stage.clientWidth;
      root.getBoundingClientRect(); // make sure the starting styles are applied before the classes change
      root.classList.add('is-open');
      // Pushed only once the viewer has genuinely opened (not earlier, e.g. before the image is
      // even confirmed to load) - if the image fails and open() bails out via its own catch below,
      // nothing was ever pushed, so there's nothing to clean up on that path either.
      historyState = true;
      history.pushState({ hmLightbox: true }, '', location.href);
      animateFromOrigin(page, false).then(function () { s && (s.busy = false); });
      root.focus({ preventScroll: true });
      announce();
      // Swap in the large version once it has arrived (the preview is already on screen).
      if (opts.preview && item.src !== opts.preview) {
        preload(item.src).then(function (big) {
          if (!s || current() !== page) return;
          page.nw = big.naturalWidth; // the large version decides how far the photo can zoom
          page.nh = big.naturalHeight;
          page.zoomScale = clamp(page.nw / page.w, 2, 3.2);
          page.img.src = item.src;
        }).catch(function () {});
      }
      // Every other page (both the immediate neighbours and everything further out, including the
      // two wrap-around clones) loads independently and in parallel from here - no gating, no
      // priority queue, just each one showing up whenever its own load finishes, same as any plain
      // native image. That's deliberately simple: with every photo already a real, permanent page
      // (see buildPages()), there's no "was the right neighbour ready in time" race left to manage.
      pages.forEach(function (p) { if (p !== page) loadPage(p); });
    }).catch(function () {
      clearTimeout(spinnerTimer);
      teardown(); // the image would not load: nothing sensible to show
    });
  }

  // Move a slide between the photo's place on the page and its place in the viewer.
  function originRect() {
    var r = s.opts.getOriginRect && s.opts.getOriginRect();
    return r && r.width && r.height ? r : null;
  }

  function animateFromOrigin(slide, reverse) {
    var from = originRect();
    var to = slide.el.getBoundingClientRect();
    var keyframes;
    if (from && from.bottom > 0 && from.top < window.innerHeight) {
      var t = 'translate(' + (from.left + from.width / 2 - (to.left + to.width / 2)) + 'px,' +
        (from.top + from.height / 2 - (to.top + to.height / 2)) + 'px) scale(' + (from.width / to.width) + ',' + (from.height / to.height) + ')';
      keyframes = [{ transform: t, opacity: 0.6 }, { transform: 'none', opacity: 1 }];
    } else {
      keyframes = [{ transform: 'scale(0.94)', opacity: 0 }, { transform: 'none', opacity: 1 }];
    }
    if (reverse) keyframes.reverse();
    if (!ms(1)) return Promise.resolve();
    var anim = slide.el.animate(keyframes, { duration: ms(reverse ? 420 : 520), easing: EASE, fill: 'both' });
    return anim.finished.catch(function () {});
  }

  function close() {
    if (!s || s.closing) return;
    // A fast run of swipes debounces handleSettle() (see onScroll) - closing mid-swipe, before that
    // debounce fires, used to just clearTimeout it below and drop the final photo's onChange
    // entirely, leaving the page behind the viewer on whatever was last *fully* settled rather than
    // the photo actually on screen when closed. Forcing one last settle check first (safe to call
    // unconditionally - it no-ops if the index is already current) commits that final photo before
    // s.closing blocks handleSettle from running at all.
    if (s.scrollSettleTimer) {
      clearTimeout(s.scrollSettleTimer);
      s.scrollSettleTimer = 0;
      handleSettle();
    }
    s.closing = true;
    stopLoop();
    clearTimeout(s.scrollSettleTimer);
    // Closing any other way than the back button itself (X, Escape, backdrop tap, swipe down) still
    // leaves that pushState()'d entry sitting on the stack - go back to remove it, so the browser's
    // back button returns to the real previous page immediately afterwards rather than needing a
    // second press to get past a now-pointless entry. historyState is already false when close() is
    // reached *from* the popstate handler itself (that back press is what consumed the entry), so
    // this never calls history.back() twice for one pushState().
    if (historyState) { historyState = false; history.back(); }
    var page = current();
    var wasOpen = root.classList.contains('is-open'); // only added once the first photo genuinely showed
    root.classList.remove('is-open', 'is-zoomed', 'is-ready');
    var done = Promise.resolve();
    if (wasOpen) {
      resetZoom(page, true);
      done = animateFromOrigin(page, true);
    }
    Promise.all([done, wait(ms(380))]).then(teardown);
  }

  function teardown() {
    if (!s) return;
    var opener = s.opener;
    var onClose = s.opts.onClose;
    root.hidden = true;
    root.classList.remove('is-open', 'is-zoomed', 'is-loading', 'is-ready');
    document.documentElement.classList.remove('hm-lb-lock');
    Array.prototype.forEach.call(document.body.children, function (el) {
      if (el.dataset.lbInert) { el.removeAttribute('inert'); delete el.dataset.lbInert; }
    });
    s = null;
    if (opener && opener.focus) opener.focus({ preventScroll: true });
    if (onClose) onClose();
  }

  // ---- chrome (counter, arrows, announcements) ---------------------------------------------
  function updateChrome() {
    counter.textContent = (s.index + 1) + ' / ' + s.items.length;
    root.classList.add('is-ready');
  }
  function announce() {
    live.textContent = 'Image ' + (s.index + 1) + ' of ' + s.items.length + (s.items[s.index].alt ? ': ' + s.items[s.index].alt : '');
  }

  // ---- navigation -----------------------------------------------------------------------------
  // Keyboard and the prev/next buttons just ask the track to scroll by one page, exactly like the
  // testimonials carousel's own arrow buttons (grid.scrollBy in testimonial-slider.js) - the resulting
  // scroll settles through the same onScrollEnd -> handleSettle path a real swipe does, so there's
  // only ever one place that decides what "having navigated" actually means.
  function go(dir) {
    if (!s || s.closing || s.items.length < 2) return;
    stage.scrollBy({ left: dir * stage.clientWidth, behavior: ms(1) ? 'smooth' : 'auto' });
  }

  // Fires (possibly twice, harmlessly - see onScroll/onScrollEnd) once the track has stopped moving,
  // whether that was a user's swipe, a released-but-under-threshold swipe snapping back, or a go()
  // call's programmatic scroll.
  function handleSettle() {
    if (!s || s.closing || s.recentering) return;
    var n = s.items.length;
    if (n < 2) return;
    var w = stage.clientWidth;
    if (!w) return;
    var pos = clamp(Math.round(stage.scrollLeft / w), 0, n + 1);
    if (pos === 0) { jumpTo(n - 1, n); return; } // wrapped backward onto the trailing clone-of-last
    if (pos === n + 1) { jumpTo(0, 1); return; } // wrapped forward onto the leading clone-of-first
    var newIndex = pos - 1;
    if (newIndex === s.index) return; // settled right back where it started - the snap engine's own
                                       // rubber-band already did all the work, nothing left to commit
    commitTo(newIndex);
  }

  function commitTo(newIndex) {
    var old = current();
    s.index = newIndex;
    if (old.zoomed) resetZoom(old, true);
    s.lastTap = null; // a double-tap should never span two different photos
    updateChrome();
    announce();
    if (s.opts.onChange) s.opts.onChange(newIndex);
  }

  // Jumps the track to a given page position, instantly (direct scrollLeft assignment, unlike
  // scrollTo/scrollBy, never respects CSS scroll-behavior, so this is always truly immediate). Used
  // only for the two wrap-around seams: the clone page a swipe just settled on is visually identical
  // to the real photo at pagePosition, so the jump lands on pixels identical to what's already on
  // screen. s.recentering guards handleSettle from mistaking this jump for a further navigation.
  function jumpTo(newIndex, pagePosition) {
    commitTo(newIndex);
    s.recentering = true;
    stage.scrollLeft = pagePosition * stage.clientWidth;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { if (s) s.recentering = false; });
    });
  }

  function onScroll() {
    if (!s || s.recentering) return;
    clearTimeout(s.scrollSettleTimer);
    // Fallback for engines without 'scrollend' (or in case it doesn't fire for some scroll interaction) -
    // fires shortly after the last scroll sample. Harmless if 'scrollend' also fires: whichever comes
    // second just finds nothing left to do (see handleSettle).
    s.scrollSettleTimer = setTimeout(handleSettle, 120);
  }
  function onScrollEnd() {
    if (!s || s.recentering) return;
    clearTimeout(s.scrollSettleTimer);
    handleSettle();
  }

  // ---- zoom ----------------------------------------------------------------------------------
  // page.zoomScale is the *ceiling* - clamped in fit() to the real image resolution, so it also
  // doubles as "how far can this photo zoom before it visibly pixelates." page.scale is the *live*
  // current zoom (1 = unzoomed, up to zoomScale) - a tap/click jumps straight to the ceiling, a
  // pinch tracks it continuously and can stop anywhere in between, same as any real photo viewer.
  function paint(page) {
    page.img.style.transform = 'translate3d(' + page.tx + 'px,' + page.ty + 'px,0) scale(' + page.scale + ')';
  }

  // Pan target for a point at (clientX, clientY), at a given zoom level: the spot under that point
  // stays under it as the photo scales up, and moving towards an edge brings that edge into view.
  // Used both for a tap (scale is always the fixed ceiling) and continuously during a pinch (scale
  // changes on every frame) - the same anchoring math applies either way.
  function targetFor(page, clientX, clientY, scale) {
    if (scale == null) scale = page.zoomScale;
    var nx = clamp((clientX - window.innerWidth / 2) / (page.w / 2), -1, 1);
    var ny = clamp((clientY - window.innerHeight / 2) / (page.h / 2), -1, 1);
    var range = scale - 1;
    page.ttx = -nx * range * page.w / 2;
    page.tty = -ny * range * page.h / 2;
  }

  function panBounds(page) {
    return { rx: (page.scale - 1) * page.w / 2, ry: (page.scale - 1) * page.h / 2 };
  }

  function zoomIn(page, x, y) {
    page.zoomed = true;
    targetFor(page, x, y, page.zoomScale);
    page.scale = page.zoomScale;
    page.tx = page.ttx;
    page.ty = page.tty;
    page.animating = true;
    page.img.classList.add('is-animating');
    paint(page);
    root.classList.add('is-zoomed');
    setTimeout(function () { page.animating = false; page.img.classList.remove('is-animating'); startLoop(); }, ms(ZOOM_MS));
  }

  function resetZoom(page, instant) {
    if (!page.zoomed && page.scale <= 1) return;
    page.zoomed = false;
    page.scale = 1;
    page.tx = page.ty = page.ttx = page.tty = 0;
    stopLoop();
    root.classList.remove('is-zoomed');
    if (instant) { page.img.classList.remove('is-animating'); paint(page); return; }
    page.animating = true;
    page.img.classList.add('is-animating');
    paint(page);
    setTimeout(function () { page.animating = false; page.img.classList.remove('is-animating'); }, ms(ZOOM_MS));
  }

  function toggleZoom(x, y) {
    if (!s || s.busy || s.closing) return;
    var page = current();
    if (page.animating) return;
    if (page.zoomed) resetZoom(page, false);
    else zoomIn(page, x, y);
  }

  // ---- pinch (continuous, tracks the fingers 1:1) --------------------------------------------
  var PINCH_SNAP_BACK = 1.06; // released at or below this scale -> treat it as "let go of the zoom"

  function applyPinchScale(page, newScale, midX, midY) {
    newScale = clamp(newScale, 1, page.zoomScale);
    targetFor(page, midX, midY, newScale); // computes ttx/tty anchored to the pinch midpoint, for this new scale
    page.scale = newScale;
    var b = panBounds(page); // reads page.scale, so only valid to call after setting it above
    page.tx = clamp(page.ttx, -b.rx, b.rx);
    page.ty = clamp(page.tty, -b.ry, b.ry);
    page.ttx = page.tx;
    page.tty = page.ty;
    page.zoomed = newScale > 1;
    root.classList.toggle('is-zoomed', page.zoomed);
    paint(page);
  }

  function endPinch(page) {
    if (page.scale <= PINCH_SNAP_BACK) {
      resetZoom(page, false); // let go near 1x - treat it as "done zooming", ease fully back out
    } else {
      page.zoomed = true; // stays exactly where the fingers left it, like any real photo viewer
      startLoop();
    }
  }

  // Smooth follow while zoomed (mouse): ease the photo towards the pan target.
  function startLoop() {
    if (!s || s.raf) return;
    var step = function () {
      s.raf = 0;
      var page = s && current();
      if (!page || !page.zoomed || page.animating) return;
      var dx = page.ttx - page.tx;
      var dy = page.tty - page.ty;
      if (Math.abs(dx) > 0.1 || Math.abs(dy) > 0.1) {
        page.tx += dx * 0.16;
        page.ty += dy * 0.16;
        paint(page);
        s.raf = requestAnimationFrame(step);
      }
    };
    s.raf = requestAnimationFrame(step);
  }
  function stopLoop() {
    if (s && s.raf) { cancelAnimationFrame(s.raf); s.raf = 0; }
  }

  // ---- pointer / keyboard ------------------------------------------------------------------
  // Touch and mouse deliberately behave differently here: a mouse click zooms immediately (that's
  // the only gesture a mouse has to offer), but on touch a single tap is reserved for closing on
  // the backdrop / doing nothing on the photo - zooming needs a genuine double-tap, matching every
  // photo viewer this is likely to be compared to. A real tap (no drag) always produces a native
  // 'click' event regardless of input type, so onStageClick alone handles both mouse click-to-zoom
  // and touch double-tap-to-zoom by timing successive clicks - there's no need to hand-detect "was
  // this a tap" the way the old drag-based swipe code had to, since horizontal movement is no longer
  // something this file tracks at all (the browser's own tap-vs-drag distinction already governs
  // whether a 'click' fires). onPointerDown/Move/Up are left owning only: a second simultaneous touch
  // (pinch), panning while zoomed, and the vertical swipe-to-close gesture.
  var DOUBLE_TAP_MS = 350;
  var DOUBLE_TAP_DIST = 40;
  var SWIPE_Y_PX = 110;
  var CLOSE_AXIS_PX = 12; // how far a touch must move before deciding "this is a vertical close-drag"

  // Eases a live vertical drag-preview back to neutral when it's released without crossing the
  // close threshold, instead of the photo just vanishing back into place.
  function snapBack(slide) {
    var from = slide.el.style.transform;
    var fromOpacity = slide.el.style.opacity;
    slide.el.style.transform = '';
    slide.el.style.opacity = '';
    if (!from && !fromOpacity) return; // was never dragged - nothing to animate
    if (!ms(1)) return;
    slide.el.animate(
      [{ transform: from || 'none', opacity: fromOpacity || '1' }, { transform: 'none', opacity: 1 }],
      { duration: 260, easing: EASE }
    );
  }

  function onStageClick(e) {
    if (!s) return;
    if (s.suppressClick) { s.suppressClick = false; return; }
    var onImage = e.target.classList && e.target.classList.contains('hm-lb-img');
    if (!onImage) { close(); return; } // empty space around the photo - single tap/click either way
    if (s.lastPointerType !== 'touch') { toggleZoom(e.clientX, e.clientY); return; } // mouse: a single click zooms
    // touch: only a genuine double-tap zooms; the first tap just arms the window for a second one.
    var now = Date.now();
    var last = s.lastTap;
    var isDouble = last && now - last.t < DOUBLE_TAP_MS &&
      Math.abs(e.clientX - last.x) < DOUBLE_TAP_DIST && Math.abs(e.clientY - last.y) < DOUBLE_TAP_DIST;
    if (isDouble) { s.lastTap = null; toggleZoom(e.clientX, e.clientY); }
    else s.lastTap = { t: now, x: e.clientX, y: e.clientY };
  }

  function pinchDist() {
    var ids = Object.keys(s.touchPoints);
    if (ids.length < 2) return 0;
    var a = s.touchPoints[ids[0]], b = s.touchPoints[ids[1]];
    return Math.hypot(a.x - b.x, a.y - b.y);
  }
  function pinchMid() {
    var ids = Object.keys(s.touchPoints);
    var a = s.touchPoints[ids[0]], b = s.touchPoints[ids[1]];
    return { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 };
  }

  function onPointerDown(e) {
    if (!s || s.closing) return;
    s.lastPointerType = e.pointerType;
    // touchPoints only ever gets a first entry here once a *second* simultaneous finger genuinely
    // arrives (s.pointer already tracking one) - the ordinary single-touch case never touches it at
    // all, so onPointerUp can tell "this was a real pinch" apart from anything else by whether
    // touchPoints has anything in it for this pointer, not by pointerType alone.
    if (e.pointerType === 'touch' && Object.keys(s.touchPoints).length >= 2) {
      // A third (or later) finger while already pinching: track it for cleanup bookkeeping only,
      // don't restart the pinch baseline or touch s.pointer - two-finger pinch math keeps owning
      // the gesture until fingers drop back down to two or fewer.
      s.touchPoints[e.pointerId] = { x: e.clientX, y: e.clientY };
      return;
    }
    if (e.pointerType === 'touch' && s.pointer) {
      s.touchPoints[s.pointer.id] = { x: s.pointer.lx, y: s.pointer.ly };
      s.touchPoints[e.pointerId] = { x: e.clientX, y: e.clientY };
      s.pointer = null;
      s.pinchStartDist = pinchDist();
      // Pinching starts from whatever scale the photo is *already* at (1 if unzoomed, or wherever a
      // previous pinch/tap left it) - not always from scratch - so pinching further from a partial
      // zoom continues smoothly instead of jumping.
      s.pinchStartScale = current().scale;
      return;
    }
    s.suppressClick = false;
    s.pointer = { id: e.pointerId, type: e.pointerType, x: e.clientX, y: e.clientY, lx: e.clientX, ly: e.clientY, moved: false, axis: null, t: Date.now() };
  }

  function onPointerMove(e) {
    if (!s || s.closing) return;
    var page = current();
    if (!page) return;

    if (e.pointerType === 'touch' && s.touchPoints[e.pointerId] !== undefined) {
      s.touchPoints[e.pointerId] = { x: e.clientX, y: e.clientY };
      if (Object.keys(s.touchPoints).length >= 2 && s.pinchStartDist && !page.animating) {
        // Continuous, 1:1 with the fingers - however far apart they've moved relative to where the
        // pinch started is exactly how zoomed in the photo now is, clamped to the same ceiling a
        // tap/click jumps straight to.
        var ratio = pinchDist() / s.pinchStartDist;
        var mid = pinchMid();
        applyPinchScale(page, s.pinchStartScale * ratio, mid.x, mid.y);
      }
      return; // a pinch-tracked point never also drives the single-pointer pan/close logic below
    }

    var p = s.pointer;
    if (e.pointerType === 'mouse') {
      if (page.zoomed && !page.animating) { targetFor(page, e.clientX, e.clientY); startLoop(); }
      return; // mouse never drives the touch-only vertical close-drag below
    }
    if (!p || p.id !== e.pointerId) return;
    var dx = e.clientX - p.lx;
    var dy = e.clientY - p.ly;
    p.lx = e.clientX;
    p.ly = e.clientY;
    var totalDx = e.clientX - p.x;
    var totalDy = e.clientY - p.y;
    var totalMove = Math.abs(totalDx) + Math.abs(totalDy);
    if (!p.moved && totalMove > 8) p.moved = true;

    if (page.zoomed && !page.animating) { // drag to pan
      var b = panBounds(page); // bounds match wherever the pinch actually left it, not the ceiling
      page.tx = clamp(page.tx + dx, -b.rx, b.rx);
      page.ty = clamp(page.ty + dy, -b.ry, b.ry);
      page.ttx = page.tx;
      page.tty = page.ty;
      paint(page);
      return;
    }
    if (page.animating) return;
    // Not zoomed: figure out, once there's enough movement to tell, whether this touch is a genuine
    // downward vertical drag (close-preview, handled entirely by this file) or anything else -
    // horizontal, upward, or still too small to say - which is left alone entirely: horizontal
    // swiping between photos is the browser's own native scroll-snap track (touch-action: pan-x in
    // lightbox.css already hands it that axis), and there's nothing left for this handler to do for
    // it. This is the one piece of axis-guessing this file still needs, and it only ever decides
    // "mine" or "not mine" - none of the old per-pixel swipe/carousel math survives this rewrite.
    if (p.axis === null && totalMove > CLOSE_AXIS_PX) {
      p.axis = (totalDy > 0 && totalDy > Math.abs(totalDx)) ? 'y' : 'x';
    }
    if (p.axis === 'y') {
      page.el.style.transform = 'translateY(' + totalDy + 'px)';
      page.el.style.opacity = String(1 - Math.min(totalDy / 400, 0.6));
    }
  }

  function onPointerUp(e) {
    if (!s) return;

    if (e.pointerType === 'touch' && s.touchPoints[e.pointerId] !== undefined) {
      delete s.touchPoints[e.pointerId];
      var remaining = Object.keys(s.touchPoints);
      if (remaining.length === 1) {
        // Pinch ended with one finger still down - hand off to normal single-touch tracking (in
        // practice, panning) instead of that finger just going dead until it's lifted too. Removing
        // its entry from touchPoints here is what makes *its own* eventual pointerup take the
        // normal single-pointer path below instead of re-entering this pinch-cleanup branch and
        // leaving s.pointer dangling.
        var handoffId = remaining[0];
        var last = s.touchPoints[handoffId];
        delete s.touchPoints[handoffId];
        s.pointer = { id: parseInt(handoffId, 10), type: 'touch', x: last.x, y: last.y, lx: last.x, ly: last.y, moved: true, axis: null, t: Date.now() };
      }
      if (Object.keys(s.touchPoints).length < 2) {
        s.pinchStartDist = 0;
        endPinch(current()); // decide: snap fully back out, or hold at the released scale
      }
      return;
    }

    var p = s.pointer;
    s.pointer = null;
    // Mouse has nothing left to do here: zoom-toggling is a click (onStageClick), and panning while
    // zoomed is fully handled in onPointerMove above. Browsers don't synthesize a click after the
    // mouse has genuinely moved a real distance between down and up, so a pan-drag release doesn't
    // need an explicit suppressClick guard the way a touch tap does below.
    if (!p || p.id !== e.pointerId || p.type === 'mouse') return;
    var page = current();
    if (!page) return;
    if (p.moved) s.suppressClick = true; // belt-and-suspenders: a touch that moved should never also register as a tap-click

    if (p.axis === 'y') {
      var totalDy = e.clientY - p.y;
      if (totalDy > SWIPE_Y_PX) {
        page.el.style.transform = '';
        page.el.style.opacity = '';
        close();
      } else {
        snapBack(page); // didn't cross the threshold - ease back to neutral instead of vanishing
      }
    }
    // p.axis === 'x': that movement was the native scroll-snap track's to handle, and it already did.
    // p.axis === null: never moved enough to decide anything - a genuine tap, left to the native
    // 'click' this same touch produces (onStageClick).
  }

  function onKeyDown(e) {
    if (!s || s.closing) return;
    if (e.key === 'Escape') { e.preventDefault(); close(); }
    else if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
    else if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
    else if (e.key === '+' || e.key === '=' || e.key === '-' || e.key === '_' || e.key === 'z' || e.key === 'Z') {
      var zoomed = current() && current().zoomed;
      if (e.key === '-' || e.key === '_') { if (zoomed) toggleZoom(0, 0); } // zoom out
      else if (e.key === 'z' || e.key === 'Z' || !zoomed) toggleZoom(window.innerWidth / 2, window.innerHeight / 2);
    } else if (e.key === 'Tab') trapFocus(e);
  }

  function trapFocus(e) {
    var els = Array.prototype.filter.call(root.querySelectorAll('button'), function (b) { return b.offsetParent !== null && !b.disabled; });
    if (!els.length) return;
    var first = els[0];
    var last = els[els.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    else if (!root.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
  }

  function onResize() {
    if (!s) return;
    updatePageHeight();
    pages.forEach(function (p) {
      resetZoom(p, true);
      fit(p);
    });
    if (s.items.length < 2) return;
    s.recentering = true;
    stage.scrollLeft = pagePos(s.index) * stage.clientWidth;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { if (s) s.recentering = false; });
    });
  }

  window.HimMoolLightbox = { open: open, close: close };
})();

// Cart drawer: a bag that slides in from the right.
//
//  - On Shopify it talks to the real cart (cart.js, cart/add.js, cart/change.js, cart/update.js).
//  - Locally (when the page has a [data-cart-mock] element) a small in-browser mock cart stands in,
//    with the same JSON shape and the same kinds of errors, so the drawer can be built and tested
//    without a store.
//
// Rules the code follows:
//  - Every cart request goes through one queue, so a slow response can never overwrite a newer one.
//  - Quantity clicks are batched: five quick clicks on "+" send one request.
//  - Text from the store (product names, notes, error messages) is only ever set as text, never as HTML.
//  - The item list is updated in place (not rebuilt), so animations, focus and typing are not disturbed.
(function () {
  'use strict';

  var root = document.getElementById('cart-drawer');
  if (!root) return;
  var configEl = root.querySelector('[data-cart-config]');
  var cfg;
  try { cfg = JSON.parse(configEl.textContent); } catch (e) { return; }
  var mockEl = root.querySelector('[data-cart-mock]');

  var reduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var q = function (sel) { return root.querySelector(sel); };
  var panel = q('.cart-drawer__panel');
  var elShipping = q('[data-cart-shipping]');
  var elScroll = q('[data-cart-scroll]');
  var elStatus = q('[data-cart-status]');
  var elItems = q('[data-cart-items]');
  var elEmpty = q('[data-cart-empty]');
  var elNoteSheet = q('[data-cart-note-sheet]');
  var elNoteSheetPanel = q('.cart-note-sheet__panel');
  var elNoteInput = q('[data-cart-note-input]');
  var elFooter = q('[data-cart-footer]');
  var elToast = q('[data-cart-toast]');
  var elLive = q('[data-cart-live]');
  var elCountLabel = q('[data-cart-count-label]');
  var elTitle = q('[data-cart-title]');

  var cart = null; // last cart the store told us about
  var isOpen = false;
  var lastFocus = null;
  var closeTimer = 0;
  var checkingOut = false;
  var lastRemoved = null;
  var pendingQty = {}; // key -> quantity the shopper has asked for, not yet sent
  var qtyTimers = {};
  var lineErrors = {}; // key -> message shown under the line
  var noteTimer = 0;
  var noteSheetOpen = false;
  var noteLastFocus = null;
  var lastSync = 0;

  function ms(n) { return reduce.matches ? 0 : n; }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function tpl(str, vars) {
    return String(str == null ? '' : str).replace(/\{(\w+)\}/g, function (m, k) { return vars && vars[k] != null ? vars[k] : m; });
  }

  // ---- DOM helpers -----------------------------------------------------------------------------
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function icon(html) { // only ever called with the fixed icon strings below
    var s = document.createElement('span');
    s.className = 'cart-icon';
    s.setAttribute('aria-hidden', 'true');
    s.innerHTML = html;
    return s;
  }
  var ICONS = {
    bag: '<svg width="56" height="56" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"><path d="M3.98 9.84A2 2 0 0 1 5.97 8h12.06a2 2 0 0 1 1.99 1.84l.8 10a2 2 0 0 1-1.99 2.16H5.17a2 2 0 0 1-1.99-2.16l.8-10Z" /><path d="M16 11V6a4 4 0 0 0-8 0v5" /></svg>',
    trash: '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7h16M10 11v6M14 11v6M6 7l1 12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2l1-12M9 7V4h6v3" /></svg>',
    minus: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M5 12h14" /></svg>',
    plus: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M12 5v14M5 12h14" /></svg>',
    truck: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M2.5 6.5h10v9h-10zM12.5 10h3.2l3.3 3v2.5h-2" /><circle cx="6.5" cy="17.5" r="1.6" /><circle cx="16" cy="17.5" r="1.6" /></svg>',
    check: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M5 13l4 4L19 7" /></svg>',
    note: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M5 4h14v16H5zM8 9h8M8 13h8M8 17h5" /></svg>',
    arrow: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6" /></svg>',
  };

  // ---- money (follows the store's own money format, like Shopify's formatMoney) ----------------
  function delimit(number, precision, thousands, decimal) {
    thousands = thousands || ',';
    decimal = decimal || '.';
    var n = (Number(number) / 100).toFixed(precision);
    if (isNaN(n)) return '0';
    var parts = n.split('.');
    var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    return whole + (parts[1] ? decimal + parts[1] : '');
  }
  function money(cents) {
    var format = cfg.moneyFormat || '{{amount}}';
    var re = /\{\{\s*(\w+)\s*\}\}/;
    var m = format.match(re);
    var value;
    switch (m && m[1]) {
      case 'amount_no_decimals': value = delimit(cents, 0); break;
      case 'amount_with_comma_separator': value = delimit(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = delimit(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = delimit(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': value = delimit(cents, 0, ' '); break;
      case 'amount_with_space_separator': value = delimit(cents, 2, ' ', ','); break;
      case 'amount_with_period_and_space_separator': value = delimit(cents, 2, ' ', '.'); break;
      default: value = delimit(cents, 2);
    }
    return format.replace(re, value);
  }

  function imageUrl(url, width) {
    if (!url) return '';
    if (/cdn\.shopify\.com|\/cdn\/shop\//.test(url)) return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
    return url;
  }

  // ---- cart API: real store or local mock -----------------------------------------------------
  function shopApi() {
    function request(url, options) {
      options = options || {};
      var ctrl = window.AbortController ? new AbortController() : null;
      var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, 20000) : 0;
      var init = { method: options.method || 'GET', headers: { Accept: 'application/json' }, credentials: 'same-origin', cache: 'no-store' };
      if (options.json) { init.headers['Content-Type'] = 'application/json'; init.body = JSON.stringify(options.json); }
      if (options.formData) init.body = options.formData;
      if (ctrl) init.signal = ctrl.signal;
      return fetch(url, init).then(function (res) {
        clearTimeout(timer);
        return res.text().then(function (text) {
          var data = null;
          try { data = text ? JSON.parse(text) : null; } catch (e) { /* not JSON */ }
          if (!res.ok) {
            var err = new Error((data && (data.description || data.message)) || cfg.errorGeneric);
            err.status = res.status;
            throw err;
          }
          return data;
        });
      }, function () {
        clearTimeout(timer);
        var err = new Error(cfg.errorNetwork);
        err.network = true;
        throw err;
      });
    }
    return {
      get: function () { return request(cfg.routes.cart + '.js'); },
      add: function (body) {
        return body instanceof FormData
          ? request(cfg.routes.add + '.js', { method: 'POST', formData: body })
          : request(cfg.routes.add + '.js', { method: 'POST', json: body });
      },
      change: function (key, quantity) { return request(cfg.routes.change + '.js', { method: 'POST', json: { id: key, quantity: quantity } }); },
      note: function (text) { return request(cfg.routes.update + '.js', { method: 'POST', json: { note: text } }); },
    };
  }

  function mockApi() {
    var KEY = 'hm-mock-cart';
    var settings = {};
    try { settings = JSON.parse(mockEl.textContent) || {}; } catch (e) { /* defaults */ }
    var MAX = settings.maxPerItem || 5;
    function read() {
      try { return JSON.parse(localStorage.getItem(KEY)) || { items: [], note: '' }; } catch (e) { return { items: [], note: '' }; }
    }
    function write(state) { try { localStorage.setItem(KEY, JSON.stringify(state)); } catch (e) { /* private mode */ } }
    function later(fn) { return new Promise(function (resolve, reject) { setTimeout(function () { try { resolve(fn()); } catch (e) { reject(e); } }, 220); }); }
    function fail(message) { var e = new Error(message); e.status = 422; return e; }
    function shape(state) {
      var items = state.items.map(function (i) {
        var line = i.price * i.quantity;
        return {
          key: i.key, id: i.id, variant_id: i.id, quantity: i.quantity, title: i.title + (i.variant ? ' - ' + i.variant : ''),
          product_title: i.title, variant_title: i.variant || null, url: i.url, image: i.image,
          featured_image: i.image ? { url: i.image, alt: i.title } : null, price: i.price, original_price: i.price, final_price: i.price,
          line_price: line, original_line_price: line, final_line_price: line, discounts: [], properties: i.properties || {},
          selling_plan_allocation: null, unit_price_measurement: null, quantity_rule: { min: 1, max: null, increment: 1 },
        };
      });
      var total = items.reduce(function (s, i) { return s + i.final_line_price; }, 0);
      return {
        token: 'mock', note: state.note || null, item_count: items.reduce(function (s, i) { return s + i.quantity; }, 0), items: items,
        total_price: total, original_total_price: total, total_discount: 0, cart_level_discount_applications: [],
        currency: 'INR', requires_shipping: true,
      };
    }
    function field(body, name) { return body instanceof FormData ? body.get(name) : body[name]; }
    return {
      get: function () { return later(function () { return shape(read()); }); },
      add: function (body, meta) {
        return later(function () {
          var state = read();
          var id = String(field(body, 'id'));
          var qty = Math.max(1, parseInt(field(body, 'quantity'), 10) || 1);
          var line = state.items.filter(function (i) { return String(i.id) === id; })[0];
          var title = (line && line.title) || (meta && meta.title) || 'this item';
          if (line && line.quantity >= MAX) throw fail('All ' + MAX + ' ' + title + ' are in your cart.');
          if ((line ? line.quantity : 0) + qty > MAX) throw fail('You can only add ' + MAX + ' ' + title + ' to your cart.');
          if (!line) {
            line = { key: id + ':' + Date.now(), id: id, quantity: 0, price: meta.price, title: meta.title, variant: meta.variant || '',
              url: meta.url || '#', image: meta.image || '', properties: {} };
            state.items.unshift(line);
          }
          line.quantity += qty;
          write(state);
          return { key: line.key, id: line.id, quantity: line.quantity, product_title: line.title };
        });
      },
      change: function (key, quantity) {
        return later(function () {
          var state = read();
          var line = state.items.filter(function (i) { return i.key === key; })[0];
          if (!line) return shape(state);
          if (quantity > MAX) throw fail('You can only add ' + MAX + ' ' + line.title + ' to your cart.');
          if (quantity <= 0) state.items = state.items.filter(function (i) { return i.key !== key; });
          else line.quantity = quantity;
          write(state);
          return shape(state);
        });
      },
      note: function (text) { return later(function () { var state = read(); state.note = text; write(state); return shape(state); }); },
    };
  }

  var api = mockEl ? mockApi() : shopApi();

  // ---- the request queue --------------------------------------------------------------------------
  var chain = Promise.resolve();
  var inflight = 0;
  function enqueue(task) {
    inflight++;
    root.classList.add('is-busy');
    var run = chain.then(task);
    chain = run.catch(function () { /* the caller handles it */ }).then(function () {
      inflight--;
      if (!inflight) root.classList.remove('is-busy');
    });
    return run;
  }

  function refresh() {
    return enqueue(function () { return api.get(); }).then(function (next) {
      lastSync = Date.now();
      applyCart(next);
      return next;
    });
  }

  // Several things ask for the cart at the same moment (pointer, focus and the open itself). Share one request.
  var loading = null;
  function loadCart() {
    if (loading) return loading;
    loading = refresh().then(function (c) { loading = null; return c; }, function (e) { loading = null; throw e; });
    return loading;
  }

  // ---- errors and messages ---------------------------------------------------------------------
  function errorText(err) {
    if (err && err.network) return cfg.errorNetwork;
    if (err && err.status === 422 && err.message) return err.message; // the store's own words ("You can only add 3 ...")
    if (err && err.status === 429) return cfg.errorGeneric;
    return (err && err.message && err.status && err.status < 500 ? err.message : '') || cfg.errorGeneric;
  }

  function announce(text) {
    elLive.textContent = '';
    setTimeout(function () { elLive.textContent = text; }, 40);
  }

  var toastTimer = 0;
  function toast(message, action) {
    clearTimeout(toastTimer);
    elToast.textContent = '';
    elToast.appendChild(el('span', 'cart-toast__text', message));
    if (action) {
      var b = el('button', 'cart-toast__action', action.label);
      b.type = 'button';
      b.addEventListener('click', function () { hideToast(); action.run(); });
      elToast.appendChild(b);
    }
    elToast.hidden = false;
    requestAnimationFrame(function () { elToast.classList.add('is-visible'); });
    toastTimer = setTimeout(hideToast, 7000);
  }
  function hideToast() {
    clearTimeout(toastTimer);
    elToast.classList.remove('is-visible');
    setTimeout(function () { if (!elToast.classList.contains('is-visible')) elToast.hidden = true; }, ms(300));
  }

  var pageToast = null;
  var pageToastTimer = 0;
  function showPageToast(message) {
    if (!pageToast) {
      pageToast = el('div', 'cart-page-toast');
      pageToast.setAttribute('role', 'alert');
      document.body.appendChild(pageToast);
    }
    clearTimeout(pageToastTimer);
    pageToast.textContent = message;
    pageToast.hidden = false;
    requestAnimationFrame(function () { pageToast.classList.add('is-visible'); });
    pageToastTimer = setTimeout(function () {
      pageToast.classList.remove('is-visible');
      setTimeout(function () { pageToast.hidden = true; }, ms(300));
    }, 6500);
  }

  function showStatus(message, retry) {
    elStatus.textContent = '';
    elStatus.appendChild(el('span', '', message));
    if (retry) {
      var b = el('button', 'cart-status__retry', cfg.retry);
      b.type = 'button';
      b.addEventListener('click', function () { hideStatus(); loadCart().catch(function (e) { showStatus(errorText(e), true); }); });
      elStatus.appendChild(b);
    }
    elStatus.hidden = false;
  }
  function hideStatus() { elStatus.hidden = true; elStatus.textContent = ''; }

  // ---- rendering -------------------------------------------------------------------------------------
  function findItem(key) {
    if (!cart) return null;
    for (var i = 0; i < cart.items.length; i++) if (cart.items[i].key === key) return cart.items[i];
    return null;
  }
  function itemEl(key) {
    var nodes = elItems.children;
    for (var i = 0; i < nodes.length; i++) if (nodes[i].getAttribute('data-key') === key) return nodes[i];
    return null;
  }
  function displayTitle(item) { return item.product_title || item.title || ''; }

  function metaLines(item) {
    var lines = [];
    if (item.variant_title && item.variant_title !== 'Default Title') lines.push(item.variant_title);
    var props = item.properties;
    if (props && typeof props === 'object') {
      Object.keys(props).forEach(function (k) {
        if (k.charAt(0) === '_') return; // hidden properties
        var v = props[k];
        if (Array.isArray(v)) v = v.join(', ');
        if (v == null || String(v).trim() === '') return;
        lines.push(k + ': ' + v);
      });
    }
    var plan = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan;
    if (plan && plan.name) lines.push(plan.name);
    return lines;
  }

  function unitPriceText(item) {
    var m = item.unit_price_measurement;
    if (!m || !item.unit_price) return '';
    return money(item.unit_price) + ' / ' + (m.reference_value !== 1 ? m.reference_value + ' ' : '') + m.reference_unit;
  }

  function buildItem(item) {
    var li = el('li', 'cart-item');
    li.setAttribute('data-key', item.key);

    var media = el('a', 'cart-item__media');
    var img = el('img');
    img.alt = '';
    img.width = 88;
    img.height = 96;
    img.decoding = 'async';
    media.appendChild(img);
    li.appendChild(media);

    var info = el('div', 'cart-item__info');
    var top = el('div', 'cart-item__top');
    var title = el('a', 'cart-item__title');
    var remove = el('button', 'cart-item__remove');
    remove.type = 'button';
    remove.appendChild(icon(ICONS.trash));
    top.appendChild(title);
    top.appendChild(remove);
    info.appendChild(top);
    info.appendChild(el('ul', 'cart-item__meta'));
    info.appendChild(el('div', 'cart-item__chips'));

    var bottom = el('div', 'cart-item__bottom');
    var qty = el('div', 'cart-qty');
    var minus = el('button', 'cart-qty__btn cart-qty__minus');
    minus.type = 'button';
    minus.appendChild(icon(ICONS.minus));
    var input = el('input', 'cart-qty__input');
    input.type = 'text';
    input.inputMode = 'numeric';
    input.autocomplete = 'off';
    var plus = el('button', 'cart-qty__btn cart-qty__plus');
    plus.type = 'button';
    plus.appendChild(icon(ICONS.plus));
    qty.appendChild(minus);
    qty.appendChild(input);
    qty.appendChild(plus);

    var price = el('div', 'cart-item__price');
    price.appendChild(el('s', 'cart-item__was'));
    price.appendChild(el('span', 'cart-item__now'));
    price.appendChild(el('small', 'cart-item__each'));
    bottom.appendChild(qty);
    bottom.appendChild(price);
    info.appendChild(bottom);

    var error = el('p', 'cart-item__error');
    error.setAttribute('role', 'alert');
    error.hidden = true;
    info.appendChild(error);
    li.appendChild(info);
    return li;
  }

  function updateItem(li, item) {
    var t = displayTitle(item);
    var href = item.url || '#';
    var media = li.querySelector('.cart-item__media');
    media.href = href;
    media.setAttribute('aria-label', t);
    media.tabIndex = -1;
    var img = media.querySelector('img');
    var src = item.featured_image ? item.featured_image.url : item.image;
    if (src) {
      var next = imageUrl(src, 176);
      if (img.getAttribute('src') !== next) {
        img.src = next;
        img.srcset = imageUrl(src, 176) + ' 1x, ' + imageUrl(src, 264) + ' 1.5x';
      }
      img.alt = (item.featured_image && item.featured_image.alt) || t;
      media.classList.remove('is-empty');
    } else {
      img.removeAttribute('src');
      img.removeAttribute('srcset');
      media.classList.add('is-empty'); // no photo: show a quiet placeholder
    }

    var title = li.querySelector('.cart-item__title');
    title.href = href;
    title.textContent = t;
    var remove = li.querySelector('.cart-item__remove');
    remove.setAttribute('aria-label', tpl(cfg.removeLabel, { title: t }));
    remove.title = cfg.remove;

    // The small lines under the title (variant, options, subscription). Only rebuilt if they changed.
    var meta = li.querySelector('.cart-item__meta');
    var lines = metaLines(item);
    var sig = lines.join('\u0001');
    if (meta.getAttribute('data-sig') !== sig) {
      meta.setAttribute('data-sig', sig);
      meta.textContent = '';
      lines.forEach(function (l) { meta.appendChild(el('li', '', l)); });
    }
    meta.hidden = !lines.length;

    // Discounts applied to this line.
    var chips = li.querySelector('.cart-item__chips');
    var discounts = (item.discounts || []).filter(function (d) { return d && d.amount > 0; });
    var chipSig = discounts.map(function (d) { return d.title + d.amount; }).join('|');
    if (chips.getAttribute('data-sig') !== chipSig) {
      chips.setAttribute('data-sig', chipSig);
      chips.textContent = '';
      discounts.forEach(function (d) { chips.appendChild(el('span', 'cart-chip', d.title + ' −' + money(d.amount))); });
    }
    chips.hidden = !discounts.length;

    // Quantity (what the shopper asked for wins over what the store last said, until it is sent).
    var rule = item.quantity_rule || {};
    var step = rule.increment > 1 ? rule.increment : 1;
    var max = rule.max || 0;
    var shown = pendingQty[item.key] != null ? pendingQty[item.key] : item.quantity;
    var input = li.querySelector('.cart-qty__input');
    if (document.activeElement !== input) input.value = shown;
    input.setAttribute('aria-label', tpl(cfg.quantityLabel, { title: t }));
    var minus = li.querySelector('.cart-qty__minus');
    var plus = li.querySelector('.cart-qty__plus');
    minus.setAttribute('aria-label', tpl(cfg.decreaseLabel, { title: t }));
    plus.setAttribute('aria-label', tpl(cfg.increaseLabel, { title: t }));
    plus.disabled = !!max && shown + step > max;
    li.setAttribute('data-step', step);
    li.setAttribute('data-max', max);

    // Prices: what it costs now, what it would have cost, and the price of one when there are several.
    var was = li.querySelector('.cart-item__was');
    var now = li.querySelector('.cart-item__now');
    var each = li.querySelector('.cart-item__each');
    now.textContent = money(item.final_line_price);
    var reduced = item.original_line_price > item.final_line_price;
    was.textContent = reduced ? money(item.original_line_price) : '';
    was.hidden = !reduced;
    var unit = unitPriceText(item);
    var eachText = item.quantity > 1 ? money(item.final_price) + ' each' : '';
    each.textContent = [eachText, unit].filter(Boolean).join(' · ');
    each.hidden = !each.textContent;

    // The message under the line, if this line has one.
    var error = li.querySelector('.cart-item__error');
    var message = lineErrors[item.key] || '';
    error.textContent = message;
    error.hidden = !message;
  }

  // Keep the list of lines in step with the cart: add new lines, update kept ones, remove gone ones.
  function syncItems(items, opts) {
    var wanted = {};
    items.forEach(function (i) { wanted[i.key] = true; });
    Array.prototype.slice.call(elItems.children).forEach(function (li) {
      if (!wanted[li.getAttribute('data-key')] && !li.classList.contains('is-removing')) collapse(li);
    });
    var anchor = null;
    for (var i = items.length - 1; i >= 0; i--) {
      var item = items[i];
      var li = itemEl(item.key);
      var fresh = false;
      if (!li) { li = buildItem(item); fresh = true; }
      updateItem(li, item);
      if (fresh || li.nextElementSibling !== anchor) {
        // Insert before the line that should follow it (skipping lines that are animating out).
        var ref = anchor;
        elItems.insertBefore(li, ref);
      }
      if (fresh && opts && opts.animate) {
        li.style.setProperty('--i', String(Math.min(items.length - 1 - i, 8)));
        li.classList.add('is-new');
      }
      anchor = li;
    }
    if (opts && opts.highlight) {
      var hl = itemEl(opts.highlight);
      if (hl) {
        hl.classList.remove('is-flash');
        void hl.offsetWidth;
        hl.classList.add('is-flash');
        if (isOpen) setTimeout(function () { hl.scrollIntoView({ block: 'nearest', behavior: reduce.matches ? 'auto' : 'smooth' }); }, 60);
      }
    }
  }

  function collapse(li) {
    li.classList.add('is-removing');
    if (!ms(1)) { li.remove(); return; }
    li.style.height = li.offsetHeight + 'px';
    void li.offsetHeight;
    li.style.height = '0px';
    var done = false;
    var finish = function () { if (!done) { done = true; li.remove(); updateScrollShadows(); } };
    li.addEventListener('transitionend', function (e) { if (e.target === li && e.propertyName === 'height') finish(); });
    setTimeout(finish, 520);
  }

  function renderShipping() {
    var threshold = Number(cfg.shippingThreshold) || 0;
    if (!threshold || !cart || !cart.items.length) { elShipping.hidden = true; return; }
    var rate = 1;
    if (window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate) > 0) rate = parseFloat(Shopify.currency.rate);
    var target = Math.round(threshold * 100 * rate);
    var remaining = Math.max(0, target - cart.total_price);
    var unlocked = remaining === 0;
    if (!elShipping.firstChild) {
      var text = el('p', 'cart-ship__text');
      text.appendChild(icon(ICONS.truck));
      text.appendChild(el('span', 'cart-ship__msg'));
      var bar = el('div', 'cart-ship__bar');
      bar.setAttribute('role', 'progressbar');
      bar.setAttribute('aria-valuemin', '0');
      bar.setAttribute('aria-valuemax', '100');
      bar.appendChild(el('span', 'cart-ship__fill'));
      elShipping.appendChild(text);
      elShipping.appendChild(bar);
    }
    var msg = elShipping.querySelector('.cart-ship__msg');
    var nextText = unlocked ? cfg.shippingUnlocked : tpl(cfg.shippingProgress, { amount: money(remaining) });
    if (msg.textContent !== nextText) msg.textContent = nextText;
    var pct = clamp(Math.round((cart.total_price / target) * 100), 0, 100);
    var bar2 = elShipping.querySelector('.cart-ship__bar');
    bar2.setAttribute('aria-valuenow', String(pct));
    bar2.setAttribute('aria-label', nextText);
    elShipping.querySelector('.cart-ship__fill').style.width = pct + '%';
    var wasUnlocked = elShipping.classList.contains('is-unlocked');
    elShipping.classList.toggle('is-unlocked', unlocked);
    if (unlocked && !wasUnlocked && isOpen) announce(cfg.shippingUnlocked);
    elShipping.hidden = false;
  }

  function buildEmpty() {
    elEmpty.textContent = '';
    var wrap = el('div', 'cart-empty__inner');
    wrap.appendChild(icon(ICONS.bag));
    wrap.appendChild(el('h3', 'cart-empty__title', cfg.emptyTitle));
    wrap.appendChild(el('p', 'cart-empty__text', cfg.emptyText));
    var cta = el('a', 'cart-empty__cta');
    cta.href = cfg.emptyUrl || '/';
    cta.appendChild(el('span', '', cfg.emptyCta));
    cta.appendChild(icon(ICONS.arrow));
    wrap.appendChild(cta);
    elEmpty.appendChild(wrap);
  }

  // ---- note sheet: static chrome (title/label/placeholder/save label), filled once at init - see
  // "start" below. The sheet's own open/close is a separate, nested focus-trap from the drawer's own
  // (below), since Tab/Escape need to stay scoped to whichever of the two is actually on top. ------
  function initNoteSheet() {
    if (!cfg.noteEnabled || !elNoteSheet) return;
    q('[data-cart-note-label]').textContent = cfg.noteLabel;
    elNoteInput.placeholder = cfg.notePlaceholder;
    q('[data-cart-note-save]').textContent = cfg.noteSave;
    elNoteInput.addEventListener('input', function () {
      clearTimeout(noteTimer);
      noteTimer = setTimeout(saveNote, 700);
    });
    elNoteInput.addEventListener('blur', saveNote);
  }

  function noteFocusable() {
    return Array.prototype.filter.call(elNoteSheetPanel.querySelectorAll('a[href], button, input, textarea, [tabindex]:not([tabindex="-1"])'), function (n) {
      return !n.disabled && !n.hidden && n.offsetParent !== null && n.tabIndex !== -1;
    });
  }

  function openNoteSheet() {
    if (!elNoteSheet || noteSheetOpen) return;
    noteSheetOpen = true;
    noteLastFocus = document.activeElement;
    q('[data-cart-note-title]').textContent = cart && cart.note ? cfg.noteEdit : cfg.noteToggle;
    elNoteInput.value = (cart && cart.note) || '';
    elNoteSheet.hidden = false;
    void elNoteSheet.offsetWidth; // let the closed styles apply before the open class changes them
    elNoteSheet.classList.add('is-open');
    setTimeout(function () { elNoteInput.focus({ preventScroll: true }); }, ms(300));
  }

  function closeNoteSheet() {
    if (!noteSheetOpen) return;
    noteSheetOpen = false;
    elNoteSheet.classList.remove('is-open');
    saveNote(); // closing is "done writing" - flush immediately rather than waiting for blur/debounce
    setTimeout(function () {
      if (noteSheetOpen) return;
      elNoteSheet.hidden = true;
      if (noteLastFocus && noteLastFocus.focus && document.contains(noteLastFocus)) noteLastFocus.focus({ preventScroll: true });
      noteLastFocus = null;
    }, ms(350));
  }

  function saveNote() {
    clearTimeout(noteTimer);
    noteTimer = 0;
    if (!elNoteInput || !cart) return Promise.resolve();
    var text = elNoteInput.value;
    if ((cart.note || '') === text) return Promise.resolve();
    return enqueue(function () { return api.note(text); }).then(function (next) {
      cart.note = next.note;
      renderFooter(); // the footer's own trigger button shows a preview of the saved note - see buildFooter()
    }, function (err) {
      toast(errorText(err));
    });
  }

  function buildFooter() {
    elFooter.textContent = '';
    var summary = el('div', 'cart-summary');
    summary.appendChild(el('div', 'cart-summary__discounts'));
    // Just above the subtotal row, so it's always visible in the (already fixed-in-place) footer,
    // rather than scrolling away with the items above it the way the old inline note field did.
    if (cfg.noteEnabled && elNoteSheet) {
      var noteBtn = el('button', 'cart-footer-note-btn');
      noteBtn.type = 'button';
      noteBtn.setAttribute('data-cart-note-trigger', '');
      var noteIcon = icon(ICONS.note);
      noteIcon.classList.add('cart-footer-note-btn__icon');
      noteBtn.appendChild(noteIcon);
      noteBtn.appendChild(el('span', 'cart-footer-note-btn__label', cfg.noteToggle));
      var noteArrow = icon(ICONS.arrow);
      noteArrow.classList.add('cart-footer-note-btn__chevron');
      noteBtn.appendChild(noteArrow);
      noteBtn.addEventListener('click', openNoteSheet);
      summary.appendChild(noteBtn);
    }
    var row = el('div', 'cart-summary__row');
    row.appendChild(el('span', 'cart-summary__label', cfg.subtotal));
    row.appendChild(el('span', 'cart-summary__total'));
    summary.appendChild(row);
    summary.appendChild(el('p', 'cart-summary__saved'));
    summary.appendChild(el('p', 'cart-summary__note', cfg.taxNote));
    var checkout = el('button', 'cart-checkout');
    checkout.type = 'button';
    checkout.setAttribute('data-cart-checkout', '');
    checkout.appendChild(el('span', 'cart-checkout__label', cfg.checkout));
    summary.appendChild(checkout);
    if (cfg.showViewCart) {
      var view = el('a', 'cart-viewcart', cfg.viewCart);
      view.href = cfg.routes.cart;
      summary.appendChild(view);
    }
    elFooter.appendChild(summary);
  }

  function renderFooter() {
    var has = cart && cart.items.length > 0;
    elFooter.hidden = !has;
    if (!has) return;
    elFooter.querySelector('.cart-summary__total').textContent = money(cart.total_price);
    // Discounts that apply to the whole cart (not one line).
    var box = elFooter.querySelector('.cart-summary__discounts');
    var apps = (cart.cart_level_discount_applications || []).filter(function (d) { return d && d.total_allocated_amount > 0; });
    var sig = apps.map(function (d) { return d.title + d.total_allocated_amount; }).join('|');
    if (box.getAttribute('data-sig') !== sig) {
      box.setAttribute('data-sig', sig);
      box.textContent = '';
      apps.forEach(function (d) {
        var r = el('div', 'cart-summary__row cart-summary__row--discount');
        r.appendChild(el('span', 'cart-summary__label', d.title));
        r.appendChild(el('span', '', '−' + money(d.total_allocated_amount)));
        box.appendChild(r);
      });
    }
    var saved = elFooter.querySelector('.cart-summary__saved');
    saved.textContent = cart.total_discount > 0 ? tpl(cfg.saved, { amount: money(cart.total_discount) }) : '';
    saved.hidden = !saved.textContent;
    var checkout = elFooter.querySelector('[data-cart-checkout]');
    if (!checkingOut) checkout.disabled = false;
    var noteBtn = elFooter.querySelector('[data-cart-note-trigger]');
    if (noteBtn) {
      var hasNote = !!(cart.note && cart.note.trim());
      noteBtn.classList.toggle('has-note', hasNote);
      noteBtn.querySelector('.cart-footer-note-btn__label').textContent = hasNote ? cart.note : cfg.noteToggle;
    }
    // Keep the sheet's own textarea in sync too (e.g. the cart refreshed elsewhere) - but never while
    // someone's actively typing in it, which this same render cycle would otherwise fight with.
    if (elNoteInput && document.activeElement !== elNoteInput && elNoteInput.value !== (cart.note || '')) {
      elNoteInput.value = cart.note || '';
    }
  }

  function countLabel(n) { return n + ' ' + (n === 1 ? cfg.itemOne : cfg.itemMany); }

  function updateHeaderCount() {
    var n = cart ? cart.item_count : 0;
    var shown = n > 99 ? '99+' : String(n);
    Array.prototype.forEach.call(document.querySelectorAll('.cart-count'), function (badge) {
      var changed = badge.textContent !== shown;
      badge.textContent = shown;
      badge.hidden = n === 0;
      if (changed && n > 0 && !reduce.matches) {
        badge.classList.remove('is-bumped');
        void badge.offsetWidth;
        badge.classList.add('is-bumped');
      }
    });
    Array.prototype.forEach.call(document.querySelectorAll('.cart-btn'), function (btn) {
      btn.setAttribute('aria-label', 'Cart, ' + countLabel(n));
    });
  }

  function applyCart(next, opts) {
    var previousCount = cart ? cart.item_count : null;
    cart = next;
    // Any pending edit for a line that no longer exists is moot.
    Object.keys(pendingQty).forEach(function (k) { if (!findItem(k)) { delete pendingQty[k]; clearTimeout(qtyTimers[k]); delete qtyTimers[k]; } });
    var has = cart.items.length > 0;
    elCountLabel.textContent = has ? '(' + cart.item_count + ')' : '';
    elCountLabel.hidden = !has;
    var wasEmpty = elEmpty.hidden === false;
    elEmpty.hidden = has;
    elItems.hidden = !has;
    if (!has && !elEmpty.firstChild) buildEmpty();
    if (!has && wasEmpty === false && isOpen) elEmpty.classList.add('is-entering');
    if (has) elEmpty.classList.remove('is-entering');
    if (!has && noteSheetOpen) closeNoteSheet(); // nothing left to attach a note to
    syncItems(cart.items, { animate: opts && opts.animate !== false && (previousCount === null || previousCount === 0 || (opts && opts.freshOpen)), highlight: opts && opts.highlight });
    renderShipping();
    renderFooter(); // also keeps the note trigger/sheet in sync with cart.note - see renderFooter()
    updateHeaderCount();
    updateScrollShadows();
    hideStatus();
    document.dispatchEvent(new CustomEvent('hm:cart-sync', { detail: cart }));
  }
  // The full cart page (if the site has one) mutates the same cart; take its word for it without
  // asking the store again. Ignore an event that is just our own applyCart() bouncing back.
  document.addEventListener('hm:cart-sync', function (e) {
    if (!e.detail || e.detail === cart) return;
    lastSync = Date.now();
    applyCart(e.detail, { animate: false });
  });

  // ---- quantity, remove, undo ------------------------------------------------------------------------------------
  function reflectLine(key) {
    var item = findItem(key);
    var li = itemEl(key);
    if (item && li) updateItem(li, item);
  }

  function requestQty(key, qty, now) {
    var item = findItem(key);
    if (!item) return;
    var rule = item.quantity_rule || {};
    var step = rule.increment > 1 ? rule.increment : 1;
    var min = rule.min > 1 ? rule.min : 1;
    if (qty > 0 && qty < min) qty = 0; // below the minimum means "remove"
    if (qty > 0 && step > 1) qty = Math.round(qty / step) * step;
    if (rule.max && qty > rule.max) qty = rule.max;
    if (qty === 0) { removeItem(key); return; }
    delete lineErrors[key];
    pendingQty[key] = qty;
    reflectLine(key);
    var li = itemEl(key);
    if (li) li.classList.add('is-updating');
    clearTimeout(qtyTimers[key]);
    qtyTimers[key] = setTimeout(function () { commitQty(key); }, now ? 0 : 320);
  }

  function commitQty(key) {
    var qty = pendingQty[key];
    clearTimeout(qtyTimers[key]);
    delete qtyTimers[key];
    if (qty == null) return Promise.resolve();
    var item = findItem(key);
    if (item && item.quantity === qty) { delete pendingQty[key]; reflectLine(key); var l = itemEl(key); if (l) l.classList.remove('is-updating'); return Promise.resolve(); }
    return enqueue(function () { return api.change(key, qty); }).then(function (next) {
      delete pendingQty[key];
      var a = findItem(key);
      applyCart(next);
      var t = itemEl(key);
      if (t) t.classList.remove('is-updating');
      if (a) announce(tpl(cfg.quantityLabel, { title: displayTitle(a) }) + ' ' + qty);
    }, function (err) {
      delete pendingQty[key];
      lineErrors[key] = errorText(err);
      setTimeout(function () { delete lineErrors[key]; reflectLine(key); }, 7000);
      return refresh().catch(function () { /* the message under the line is enough */ }).then(function () {
        var t = itemEl(key);
        if (t) t.classList.remove('is-updating');
        reflectLine(key);
      });
    });
  }

  function removeItem(key) {
    var item = findItem(key);
    if (!item) return;
    var plan = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan;
    lastRemoved = {
      body: { id: item.variant_id || item.id, quantity: item.quantity, properties: item.properties || undefined, selling_plan: plan ? plan.id : undefined },
      meta: { title: displayTitle(item), price: item.final_price, variant: item.variant_title, url: item.url, image: item.featured_image ? item.featured_image.url : item.image },
      title: displayTitle(item),
    };
    clearTimeout(qtyTimers[key]);
    delete pendingQty[key];
    delete qtyTimers[key];
    var li = itemEl(key);
    if (li) collapse(li); // it leaves right away; if the store refuses, the next render puts it back
    return enqueue(function () { return api.change(key, 0); }).then(function (next) {
      applyCart(next);
      var removed = lastRemoved;
      toast(tpl(cfg.removed, { title: removed.title }), { label: cfg.undo, run: undoRemove });
      announce(tpl(cfg.removed, { title: removed.title }));
    }, function (err) {
      lastRemoved = null;
      lineErrors[key] = errorText(err);
      return refresh().catch(function () { showStatus(errorText(err), true); });
    });
  }

  function undoRemove() {
    var removed = lastRemoved;
    if (!removed) return;
    lastRemoved = null;
    enqueue(function () { return api.add(removed.body, removed.meta).then(function (added) { return api.get().then(function (next) { return { added: added, next: next }; }); }); })
      .then(function (res) { applyCart(res.next, { highlight: res.added && res.added.key, animate: true }); announce(tpl(cfg.added, { title: removed.title })); })
      .catch(function (err) { toast(errorText(err)); refresh().catch(function () {}); });
  }

  // ---- adding from the page ------------------------------------------------------------------------------------------------
  function isCartAddForm(form) {
    var action = (form.getAttribute('action') || '').split('?')[0].replace(/\/+$/, '');
    return action === cfg.routes.add || /\/cart\/add$/.test(action);
  }

  function setLoading(btn, on) {
    if (!btn) return;
    btn.classList.toggle('is-loading', on);
    btn.setAttribute('aria-busy', on ? 'true' : 'false');
    if (on) { btn.dataset.wasDisabled = btn.disabled ? '1' : ''; btn.disabled = true; }
    else { btn.disabled = btn.dataset.wasDisabled === '1'; delete btn.dataset.wasDisabled; }
  }

  function readMeta(form) { // mock only: the local pages describe the product on the form itself
    var checked = form.querySelector('.option-pill input:checked');
    var priceText = (checked && checked.dataset.price) || form.dataset.price || '';
    var digits = String(priceText).replace(/[^\d]/g, '');
    return {
      title: form.dataset.title || 'Product',
      price: digits ? parseInt(digits, 10) * 100 : 0,
      variant: checked ? checked.value : '',
      url: form.dataset.url || '#',
      image: form.dataset.image || '',
    };
  }

  function formError(form, message) {
    var slot = form.querySelector('.cart-add-error');
    if (slot) { slot.textContent = message; slot.hidden = false; return; }
    showPageToast(message);
  }
  function clearFormError(form) {
    var slot = form.querySelector('.cart-add-error');
    if (slot) { slot.textContent = ''; slot.hidden = true; }
  }

  function addFromForm(form, submitter) {
    if (form.dataset.cartAdding) return;
    form.dataset.cartAdding = '1';
    var btn = submitter || form.querySelector('[type="submit"], button:not([type])');
    setLoading(btn, true);
    clearFormError(form);
    var body = new FormData(form);
    var meta = mockEl ? readMeta(form) : null;
    enqueue(function () {
      return api.add(body, meta).then(function (added) {
        return api.get().then(function (next) { return { added: added, next: next }; });
      });
    }).then(function (res) {
      lastSync = Date.now();
      var title = (res.added && (res.added.product_title || res.added.title)) || (meta && meta.title) || '';
      // The cart page (if open, or opened next) uses this to show recommendations genuinely
      // related to what was just added, not a fixed list.
      if (!mockEl && res.added && res.added.product_id) {
        try { sessionStorage.setItem('hm-last-added-product', res.added.product_id); } catch (e) { /* private mode */ }
      }
      applyCart(res.next, { highlight: res.added && res.added.key, animate: true, freshOpen: true });
      announce(tpl(cfg.added, { title: title }));
      if (cfg.autoOpen) open();
      else showPageToast(tpl(cfg.added, { title: title }));
    }).catch(function (err) {
      formError(form, errorText(err));
      // If the shopper had asked for more than the store allows, make sure the header count is still true.
      refresh().catch(function () {});
    }).then(function () {
      delete form.dataset.cartAdding;
      setLoading(btn, false);
    });
  }

  // ---- opening and closing --------------------------------------------------------------------------------------------------
  function focusable() {
    return Array.prototype.filter.call(panel.querySelectorAll('a[href], button, input, textarea, [tabindex]:not([tabindex="-1"])'), function (n) {
      // closest('[hidden]') matters specifically because of .cart-note-sheet[hidden] (cart-drawer.css)
      // - that rule deliberately keeps display:block (not none) on the hidden sheet so its own opacity
      // transition has something to animate from, which also means offsetParent alone doesn't reliably
      // say "not in the layout" for its children the way it does for an ordinary [hidden] element.
      return !n.disabled && !n.hidden && n.offsetParent !== null && n.tabIndex !== -1 && !n.closest('[hidden]');
    });
  }

  function lockPage(on) {
    var doc = document.documentElement;
    if (on) {
      doc.style.setProperty('--hm-drawer-sbw', (window.innerWidth - doc.clientWidth) + 'px');
      doc.classList.add('hm-drawer-lock');
      Array.prototype.forEach.call(document.body.children, function (n) {
        // Skip the drawer and anything that contains it (Shopify wraps every section in an extra element).
        if (n !== root && !n.contains(root) && !n.hasAttribute('inert') && n.tagName !== 'SCRIPT') { n.setAttribute('inert', ''); n.setAttribute('data-cart-inert', ''); }
      });
    } else {
      doc.classList.remove('hm-drawer-lock');
      Array.prototype.forEach.call(document.querySelectorAll('[data-cart-inert]'), function (n) { n.removeAttribute('inert'); n.removeAttribute('data-cart-inert'); });
    }
  }

  function open() {
    if (isOpen) return;
    clearTimeout(closeTimer);
    isOpen = true;
    lastFocus = document.activeElement;
    root.hidden = false;
    lockPage(true);
    void root.offsetWidth; // let the closed styles apply before the open class changes them
    root.classList.add('is-open');
    updateScrollShadows();
    panel.focus({ preventScroll: true });
    if (!cart) {
      showStatus(cfg.loading);
      loadCart().then(function () { hideStatus(); }, function (err) { showStatus(errorText(err), true); });
    } else if (Date.now() - lastSync > 15000) {
      loadCart().catch(function () { /* what we have is still fine to show */ });
    }
    if (cart) syncItems(cart.items, { animate: true });
  }

  function close() {
    if (!isOpen) return;
    isOpen = false;
    root.classList.remove('is-open');
    hideToast();
    closeTimer = setTimeout(function () {
      if (isOpen) return;
      root.hidden = true;
      lockPage(false);
      Array.prototype.forEach.call(elItems.children, function (li) { li.classList.remove('is-new'); });
      if (lastFocus && lastFocus.focus && document.contains(lastFocus)) lastFocus.focus({ preventScroll: true });
      lastFocus = null;
    }, ms(520));
    // Anything half-typed or half-sent must not be lost by closing.
    Object.keys(qtyTimers).forEach(function (k) { commitQty(k); });
    saveNote();
  }

  function updateScrollShadows() {
    var top = elScroll.scrollTop > 4;
    var bottom = elScroll.scrollHeight - elScroll.clientHeight - elScroll.scrollTop > 4;
    panel.classList.toggle('has-scroll-top', top);
    panel.classList.toggle('has-scroll-bottom', bottom);
  }

  function checkout(btn) {
    if (checkingOut || !cart || !cart.items.length) return;
    checkingOut = true;
    btn.disabled = true;
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');
    Object.keys(qtyTimers).forEach(function (k) { commitQty(k); });
    saveNote();
    var go = function () { window.location.href = cfg.routes.checkout; };
    // Wait for every pending change to reach the store before leaving, so checkout sees the final cart.
    chain.then(go, go);
  }

  // ---- events ---------------------------------------------------------------------------------------------------------------------------------
  root.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-cart-close]')) { close(); return; }
    var remove = t.closest('.cart-item__remove');
    if (remove) { removeItem(remove.closest('.cart-item').getAttribute('data-key')); return; }
    var minus = t.closest('.cart-qty__minus');
    var plus = t.closest('.cart-qty__plus');
    if (minus || plus) {
      var li = (minus || plus).closest('.cart-item');
      var key = li.getAttribute('data-key');
      var step = parseInt(li.getAttribute('data-step'), 10) || 1;
      var current = pendingQty[key] != null ? pendingQty[key] : (findItem(key) || {}).quantity;
      if (current == null) return;
      requestQty(key, current + (plus ? step : -step));
      return;
    }
    var co = t.closest('[data-cart-checkout]');
    if (co) { checkout(co); return; }
    var cta = t.closest('.cart-empty__cta');
    if (cta) { close(); }
  });

  function commitInput(input) {
    var li = input.closest('.cart-item');
    if (!li) return;
    var key = li.getAttribute('data-key');
    var item = findItem(key);
    if (!item) return;
    var value = parseInt(String(input.value).replace(/[^\d]/g, ''), 10);
    if (isNaN(value)) { input.value = pendingQty[key] != null ? pendingQty[key] : item.quantity; return; }
    requestQty(key, value, true);
  }
  root.addEventListener('change', function (e) { if (e.target.classList.contains('cart-qty__input')) commitInput(e.target); });
  root.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.classList && e.target.classList.contains('cart-qty__input')) { e.preventDefault(); commitInput(e.target); }
  });
  root.addEventListener('input', function (e) {
    if (e.target.classList && e.target.classList.contains('cart-qty__input')) e.target.value = e.target.value.replace(/[^\d]/g, '').slice(0, 4);
  });
  elScroll.addEventListener('scroll', updateScrollShadows, { passive: true });
  window.addEventListener('resize', updateScrollShadows);

  document.addEventListener('keydown', function (e) {
    if (!isOpen) return;
    if (e.key === 'Escape') {
      e.preventDefault();
      // The sheet is "on top" of the drawer while open - Escape closes just that first, the same
      // way it would close a single modal rather than everything behind it at once.
      if (noteSheetOpen) { closeNoteSheet(); return; }
      close();
      return;
    }
    if (e.key !== 'Tab') return;
    var trapRoot = noteSheetOpen ? elNoteSheetPanel : panel;
    var items = noteSheetOpen ? noteFocusable() : focusable();
    if (!items.length) { e.preventDefault(); trapRoot.focus(); return; }
    var first = items[0];
    var last = items[items.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === trapRoot)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    else if (!trapRoot.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
  });

  if (elNoteSheet) {
    elNoteSheet.addEventListener('click', function (e) {
      // Same action either way - the save button is just a more explicit, reassuring way to say
      // "I'm done", not a functionally different path from the X or the backdrop.
      if (e.target.closest('[data-cart-note-close], [data-cart-note-save]')) closeNoteSheet();
    });
  }

  // The header bag opens the drawer (a plain click only, so "open in a new tab" still works).
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.cart-btn');
    if (!btn || !cfg.interceptCartLink) return;
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault();
    open();
  });
  // Warm the cart up as soon as someone reaches for the bag, so it opens with content already there.
  ['pointerenter', 'focusin', 'touchstart'].forEach(function (evt) {
    document.addEventListener(evt, function (e) {
      if (!cart && e.target.closest && e.target.closest('.cart-btn')) loadCart().catch(function () {});
    }, { passive: true, capture: true });
  });

  // Every "add to bag" form on the page, including ones added later (recommendations, quick views).
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement) || !isCartAddForm(form)) return;
    var submitter = e.submitter;
    if (submitter && submitter.name === 'checkout') { // "Buy now" goes straight to checkout
      if (mockEl) { e.preventDefault(); showPageToast('Checkout is not part of the local prototype.'); }
      return;
    }
    e.preventDefault();
    addFromForm(form, submitter);
  });

  // Stay true when the cart changes somewhere else: another tab, or coming back to this page.
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden && cart && Date.now() - lastSync > 5000) loadCart().catch(function () {});
  });
  window.addEventListener('pageshow', function (e) {
    if (checkingOut) { // came back from checkout
      checkingOut = false;
      var co = elFooter.querySelector('[data-cart-checkout]');
      if (co) { co.disabled = false; co.classList.remove('is-loading'); co.removeAttribute('aria-busy'); }
    }
    if (e.persisted) refresh().catch(function () {});
  });
  window.addEventListener('storage', function (e) { if (mockEl && e.key === 'hm-mock-cart') refresh().catch(function () {}); });

  // Swipe the bag to the right to put it away (touch screens).
  var drag = null;
  panel.addEventListener('pointerdown', function (e) {
    if (e.pointerType !== 'touch') return;
    drag = { x: e.clientX, y: e.clientY, dx: 0, axis: null, t: Date.now() };
  });
  panel.addEventListener('pointermove', function (e) {
    if (!drag) return;
    var dx = e.clientX - drag.x;
    var dy = e.clientY - drag.y;
    if (!drag.axis && (Math.abs(dx) > 10 || Math.abs(dy) > 10)) drag.axis = Math.abs(dx) > Math.abs(dy) * 1.3 ? 'x' : 'y';
    if (drag.axis === 'x' && dx > 0) {
      drag.dx = dx;
      panel.classList.add('is-dragging');
      panel.style.transform = 'translate3d(' + dx + 'px,0,0)';
    }
  });
  function endDrag() {
    if (!drag) return;
    var d = drag;
    drag = null;
    if (d.axis === 'x' && d.dx > 0) {
      var fast = d.dx / Math.max(1, Date.now() - d.t) > 0.6;
      panel.classList.remove('is-dragging');
      panel.style.transform = '';
      if (d.dx > 110 || fast) close();
    }
  }
  panel.addEventListener('pointerup', endDrag);
  panel.addEventListener('pointercancel', endDrag);

  // ---- start ----------------------------------------------------------------------------------------------------------------------------------
  elTitle.textContent = cfg.title;
  buildFooter();
  initNoteSheet();
  buildEmpty();
  elEmpty.hidden = true;

  if (mockEl) refresh().catch(function () {}); // the mock is instant, so show its saved count straight away

  window.HimMoolCart = {
    open: open,
    close: close,
    refresh: refresh,
    getCart: function () { return cart; },
  };
})();

// Cart page: the full "/cart" page (as opposed to the drawer, which is a quick-look overlay).
//
// It shares its logic and visual language with cart-drawer.js (same item rendering, quantity rules,
// discounts, errors) but is not modal: nothing here traps focus or locks the page, and the two stay
// in step through a small "hm:cart-sync" event so adding something from the drawer updates this page
// and vice versa, without either one re-fetching the cart from the store.
//
//  - On Shopify it talks to the real cart (cart.js, cart/add.js, cart/change.js, cart/update.js). The
//    page starts from the cart Shopify already rendered server-side (embedded as JSON), so there is no
//    loading flash on a normal visit; a fetch only happens if that is missing, or later goes stale.
//  - Locally (when the page has a [data-cart-mock] element) the same in-browser mock cart that the
//    drawer uses stands in, sharing its storage key so items added on the product page show up here.
//  - Text from the store (names, notes, errors) is only ever set as text, never as HTML.
(function () {
  'use strict';

  var root = document.getElementById('cart-page');
  if (!root) return;
  var configEl = root.querySelector('[data-cart-page-config]');
  var cfg;
  try { cfg = JSON.parse(configEl.textContent); } catch (e) { return; }
  var mockEl = root.querySelector('[data-cart-mock]');
  var seedEl = root.querySelector('[data-cart-json]');
  // Populated from the real server-rendered cart lines just before they're cleared (see below) -
  // the one place this page ever has a real answer for stock text/quantity max, since neither the
  // JSON seed nor any later AJAX response carries those fields. Keyed by item.key.
  var ssrFallback = {};

  var reduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var q = function (sel) { return root.querySelector(sel); };
  var elLayout = q('[data-cart-layout]');
  var elShipping = q('[data-cart-shipping]');
  var elStatus = q('[data-cart-status]');
  var elItems = q('[data-cart-items]');
  var elEmpty = q('[data-cart-empty]');
  var elBelow = q('[data-cart-below]');
  var elNoteSheet = q('[data-cart-note-sheet]');
  var elNoteSheetPanel = q('.cart-note-sheet__panel');
  var elNoteInput = q('[data-cart-note-input]');
  var elDiscount = q('[data-cart-discount]');
  var elContinue = q('[data-cart-continue]');
  var elAside = q('[data-cart-aside]');
  var elFooter = q('[data-cart-footer]');
  var elToast = q('[data-cart-toast]');
  var elLive = q('[data-cart-live]');
  var elCountLabel = q('[data-cart-count-label]');

  var cart = null;
  var lastRemoved = null;
  var pendingQty = {};
  var qtyTimers = {};
  var lineErrors = {};
  var noteTimer = 0;
  var noteSheetOpen = false;
  var noteLastFocus = null;
  var lastSync = 0;
  var checkingOut = false;

  function ms(n) { return reduce.matches ? 0 : n; }
  function tpl(str, vars) {
    return String(str == null ? '' : str).replace(/\{(\w+)\}/g, function (m, k) { return vars && vars[k] != null ? vars[k] : m; });
  }

  // ---- DOM helpers -----------------------------------------------------------------------------
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function icon(html) { // only ever called with the fixed icon strings below
    var s = document.createElement('span');
    s.className = 'cart-icon';
    s.setAttribute('aria-hidden', 'true');
    s.innerHTML = html;
    return s;
  }
  var ICONS = {
    bag: '<svg width="56" height="56" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"><path d="M3.98 9.84A2 2 0 0 1 5.97 8h12.06a2 2 0 0 1 1.99 1.84l.8 10a2 2 0 0 1-1.99 2.16H5.17a2 2 0 0 1-1.99-2.16l.8-10Z" /><path d="M16 11V6a4 4 0 0 0-8 0v5" /></svg>',
    trash: '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7h16M10 11v6M14 11v6M6 7l1 12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2l1-12M9 7V4h6v3" /></svg>',
    minus: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M5 12h14" /></svg>',
    plus: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M12 5v14M5 12h14" /></svg>',
    truck: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M2.5 6.5h10v9h-10zM12.5 10h3.2l3.3 3v2.5h-2" /><circle cx="6.5" cy="17.5" r="1.6" /><circle cx="16" cy="17.5" r="1.6" /></svg>',
    truckBadge: '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M2.5 6.5h10v9h-10zM12.5 10h3.2l3.3 3v2.5h-2" /><circle cx="6.5" cy="17.5" r="1.6" /><circle cx="16" cy="17.5" r="1.6" /></svg>',
    note: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M5 4h14v16H5zM8 9h8M8 13h8M8 17h5" /></svg>',
    arrow: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6" /></svg>',
    check: '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M5 13l4 4L19 7" /></svg>',
    x: '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M6 6l12 12M18 6L6 18" /></svg>',
  };

  // Real per-line stock state, not a static label: Sold Out (variant.available is Shopify's own
  // computed flag), Only X left (tracked and at/below 5 units), or In Stock - matches the logic in
  // main-cart.liquid so the server-rendered page and this client-side re-render never disagree.
  //
  // Neither Shopify's cart AJAX responses NOR the `{{ cart | json }}` seed this page starts from
  // include the line item's variant.available/inventory_management/inventory_quantity at all
  // (confirmed empirically, not assumed) - only a Liquid-rendered page (main-cart.liquid) has real
  // access to those fields. This page normally *replaces* that server-rendered markup with this
  // JS-built version immediately on load (see the init code below), which would silently throw the
  // real answer away every single time, not just on later updates. ssrFallback (populated from the
  // server-rendered <li>s right before they're cleared) is what keeps that first-load answer alive;
  // stockState() prefers it whenever the JSON itself has nothing to say. A later add/quantity-change
  // response genuinely has no fresher source of truth than that initial snapshot, so it's reused
  // rather than regressing to a blind "In Stock" guess.
  function stockState(item) {
    var v = item.variant || {};
    if (v.available === false) {
      return { cls: 'is-oos', icon: ICONS.x, text: cfg.soldOut || 'Sold Out' };
    }
    if (v.available === true) {
      var tracked = v.inventory_management === 'shopify';
      var q = v.inventory_quantity;
      if (tracked && typeof q === 'number' && q > 0 && q <= 5) {
        return { cls: 'is-low', icon: ICONS.check, text: tpl(cfg.lowStock || 'Only {n} left', { n: q }) };
      }
      return { cls: '', icon: ICONS.check, text: cfg.inStock };
    }
    var fallback = ssrFallback[item.key];
    if (fallback) return fallback;
    return { cls: '', icon: ICONS.check, text: cfg.inStock };
  }

  // ---- money (follows the store's own money format, like Shopify's formatMoney) ----------------
  function delimit(number, precision, thousands, decimal) {
    thousands = thousands || ',';
    decimal = decimal || '.';
    var n = (Number(number) / 100).toFixed(precision);
    if (isNaN(n)) return '0';
    var parts = n.split('.');
    var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    return whole + (parts[1] ? decimal + parts[1] : '');
  }
  function money(cents) {
    var format = cfg.moneyFormat || '{{amount}}';
    var re = /\{\{\s*(\w+)\s*\}\}/;
    var m = format.match(re);
    var value;
    switch (m && m[1]) {
      case 'amount_no_decimals': value = delimit(cents, 0); break;
      case 'amount_with_comma_separator': value = delimit(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = delimit(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = delimit(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': value = delimit(cents, 0, ' '); break;
      case 'amount_with_space_separator': value = delimit(cents, 2, ' ', ','); break;
      case 'amount_with_period_and_space_separator': value = delimit(cents, 2, ' ', '.'); break;
      default: value = delimit(cents, 2);
    }
    return format.replace(re, value);
  }

  function imageUrl(url, width) {
    if (!url) return '';
    if (/cdn\.shopify\.com|\/cdn\/shop\//.test(url)) return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
    return url;
  }

  // ---- cart API: real store or local mock (same shape and storage key as the drawer) ------------
  function shopApi() {
    function request(url, options) {
      options = options || {};
      var ctrl = window.AbortController ? new AbortController() : null;
      var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, 20000) : 0;
      var init = { method: options.method || 'GET', headers: { Accept: 'application/json' }, credentials: 'same-origin', cache: 'no-store' };
      if (options.json) { init.headers['Content-Type'] = 'application/json'; init.body = JSON.stringify(options.json); }
      if (options.formData) init.body = options.formData;
      if (ctrl) init.signal = ctrl.signal;
      return fetch(url, init).then(function (res) {
        clearTimeout(timer);
        return res.text().then(function (text) {
          var data = null;
          try { data = text ? JSON.parse(text) : null; } catch (e) { /* not JSON */ }
          if (!res.ok) {
            var err = new Error((data && (data.description || data.message)) || cfg.errorGeneric);
            err.status = res.status;
            throw err;
          }
          return data;
        });
      }, function () {
        clearTimeout(timer);
        var err = new Error(cfg.errorNetwork);
        err.network = true;
        throw err;
      });
    }
    return {
      get: function () { return request(cfg.routes.cart + '.js'); },
      add: function (body) {
        return body instanceof FormData
          ? request(cfg.routes.add + '.js', { method: 'POST', formData: body })
          : request(cfg.routes.add + '.js', { method: 'POST', json: body });
      },
      change: function (key, quantity) { return request(cfg.routes.change + '.js', { method: 'POST', json: { id: key, quantity: quantity } }); },
      note: function (text) { return request(cfg.routes.update + '.js', { method: 'POST', json: { note: text } }); },
    };
  }

  function mockApi() {
    var KEY = 'hm-mock-cart'; // same key the drawer uses, so the two prototypes share one cart
    var settings = {};
    try { settings = JSON.parse(mockEl.textContent) || {}; } catch (e) { /* defaults */ }
    var MAX = settings.maxPerItem || 5;
    function read() {
      try { return JSON.parse(localStorage.getItem(KEY)) || { items: [], note: '' }; } catch (e) { return { items: [], note: '' }; }
    }
    function write(state) { try { localStorage.setItem(KEY, JSON.stringify(state)); } catch (e) { /* private mode */ } }
    function later(fn) { return new Promise(function (resolve, reject) { setTimeout(function () { try { resolve(fn()); } catch (e) { reject(e); } }, 220); }); }
    function fail(message) { var e = new Error(message); e.status = 422; return e; }
    function shape(state) {
      var items = state.items.map(function (i) {
        var line = i.price * i.quantity;
        return {
          key: i.key, id: i.id, variant_id: i.id, quantity: i.quantity, title: i.title + (i.variant ? ' - ' + i.variant : ''),
          product_title: i.title, variant_title: i.variant || null, url: i.url, image: i.image,
          featured_image: i.image ? { url: i.image, alt: i.title } : null, price: i.price, original_price: i.price, final_price: i.price,
          line_price: line, original_line_price: line, final_line_price: line, discounts: [], properties: i.properties || {},
          selling_plan_allocation: null, unit_price_measurement: null, quantity_rule: { min: 1, max: null, increment: 1 },
        };
      });
      var total = items.reduce(function (s, i) { return s + i.final_line_price; }, 0);
      return {
        token: 'mock', note: state.note || null, item_count: items.reduce(function (s, i) { return s + i.quantity; }, 0), items: items,
        total_price: total, original_total_price: total, total_discount: 0, cart_level_discount_applications: [],
        currency: 'INR', requires_shipping: true,
      };
    }
    function field(body, name) { return body instanceof FormData ? body.get(name) : body[name]; }
    return {
      get: function () { return later(function () { return shape(read()); }); },
      add: function (body, meta) {
        return later(function () {
          var state = read();
          var id = String(field(body, 'id'));
          var qty = Math.max(1, parseInt(field(body, 'quantity'), 10) || 1);
          var line = state.items.filter(function (i) { return String(i.id) === id; })[0];
          var title = (line && line.title) || (meta && meta.title) || 'this item';
          if (line && line.quantity >= MAX) throw fail('All ' + MAX + ' ' + title + ' are in your cart.');
          if ((line ? line.quantity : 0) + qty > MAX) throw fail('You can only add ' + MAX + ' ' + title + ' to your cart.');
          if (!line) {
            line = { key: id + ':' + Date.now(), id: id, quantity: 0, price: meta.price, title: meta.title, variant: meta.variant || '',
              url: meta.url || '#', image: meta.image || '', properties: {} };
            state.items.unshift(line);
          }
          line.quantity += qty;
          write(state);
          return { key: line.key, id: line.id, quantity: line.quantity, product_title: line.title };
        });
      },
      change: function (key, quantity) {
        return later(function () {
          var state = read();
          var line = state.items.filter(function (i) { return i.key === key; })[0];
          if (!line) return shape(state);
          if (quantity > MAX) throw fail('You can only add ' + MAX + ' ' + line.title + ' to your cart.');
          if (quantity <= 0) state.items = state.items.filter(function (i) { return i.key !== key; });
          else line.quantity = quantity;
          write(state);
          return shape(state);
        });
      },
      note: function (text) { return later(function () { var state = read(); state.note = text; write(state); return shape(state); }); },
    };
  }

  var api = mockEl ? mockApi() : shopApi();

  // ---- the request queue --------------------------------------------------------------------------
  var chain = Promise.resolve();
  var inflight = 0;
  function enqueue(task) {
    inflight++;
    root.classList.add('is-busy');
    var run = chain.then(task);
    chain = run.catch(function () { /* the caller handles it */ }).then(function () {
      inflight--;
      if (!inflight) root.classList.remove('is-busy');
    });
    return run;
  }

  function refresh() {
    return enqueue(function () { return api.get(); }).then(function (next) {
      lastSync = Date.now();
      applyCart(next);
      return next;
    });
  }
  var loading = null;
  function loadCart() {
    if (loading) return loading;
    loading = refresh().then(function (c) { loading = null; return c; }, function (e) { loading = null; throw e; });
    return loading;
  }

  // ---- errors and messages ---------------------------------------------------------------------
  function errorText(err) {
    if (err && err.network) return cfg.errorNetwork;
    if (err && err.status === 422 && err.message) return err.message;
    if (err && err.status === 429) return cfg.errorGeneric;
    return (err && err.message && err.status && err.status < 500 ? err.message : '') || cfg.errorGeneric;
  }
  function announce(text) {
    elLive.textContent = '';
    setTimeout(function () { elLive.textContent = text; }, 40);
  }

  var toastTimer = 0;
  function toast(message, action) {
    clearTimeout(toastTimer);
    elToast.textContent = '';
    elToast.appendChild(el('span', 'cart-toast__text', message));
    if (action) {
      var b = el('button', 'cart-toast__action', action.label);
      b.type = 'button';
      b.addEventListener('click', function () { hideToast(); action.run(); });
      elToast.appendChild(b);
    }
    elToast.hidden = false;
    requestAnimationFrame(function () { elToast.classList.add('is-visible'); });
    toastTimer = setTimeout(hideToast, 7000);
  }
  function hideToast() {
    clearTimeout(toastTimer);
    elToast.classList.remove('is-visible');
    setTimeout(function () { if (!elToast.classList.contains('is-visible')) elToast.hidden = true; }, ms(300));
  }

  function showStatus(message, retry) {
    elStatus.textContent = '';
    elStatus.appendChild(el('span', '', message));
    if (retry) {
      var b = el('button', 'cart-status__retry', cfg.retry);
      b.type = 'button';
      b.addEventListener('click', function () { hideStatus(); loadCart().catch(function (e) { showStatus(errorText(e), true); }); });
      elStatus.appendChild(b);
    }
    elStatus.hidden = false;
    elLayout.hidden = true;
  }
  function hideStatus() { elStatus.hidden = true; elStatus.textContent = ''; elLayout.hidden = false; }

  // ---- rendering -------------------------------------------------------------------------------------
  function findItem(key) {
    if (!cart) return null;
    for (var i = 0; i < cart.items.length; i++) if (cart.items[i].key === key) return cart.items[i];
    return null;
  }
  function itemEl(key) {
    var nodes = elItems.children;
    for (var i = 0; i < nodes.length; i++) if (nodes[i].getAttribute('data-key') === key) return nodes[i];
    return null;
  }
  function displayTitle(item) { return item.product_title || item.title || ''; }

  function metaLines(item) {
    var lines = [];
    if (item.variant_title && item.variant_title !== 'Default Title') lines.push(item.variant_title);
    var props = item.properties;
    if (props && typeof props === 'object') {
      Object.keys(props).forEach(function (k) {
        if (k.charAt(0) === '_') return;
        var v = props[k];
        if (Array.isArray(v)) v = v.join(', ');
        if (v == null || String(v).trim() === '') return;
        lines.push(k + ': ' + v);
      });
    }
    var plan = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan;
    if (plan && plan.name) lines.push(plan.name);
    return lines;
  }
  function unitPriceText(item) {
    var m = item.unit_price_measurement;
    if (!m || !item.unit_price) return '';
    return money(item.unit_price) + ' / ' + (m.reference_value !== 1 ? m.reference_value + ' ' : '') + m.reference_unit;
  }

  function buildItem(item) {
    var li = el('li', 'cart-item');
    li.setAttribute('data-key', item.key);

    var media = el('a', 'cart-item__media');
    var img = el('img');
    img.alt = '';
    img.width = 108;
    img.height = 120;
    img.decoding = 'async';
    media.appendChild(img);
    li.appendChild(media);

    var info = el('div', 'cart-item__info');
    var top = el('div', 'cart-item__top');
    var title = el('a', 'cart-item__title');
    var remove = el('button', 'cart-item__remove');
    remove.type = 'button';
    remove.appendChild(icon(ICONS.trash));
    top.appendChild(title);
    top.appendChild(remove);
    info.appendChild(top);
    info.appendChild(el('ul', 'cart-item__meta'));
    info.appendChild(el('div', 'cart-item__chips'));
    var stock = el('span', 'cart-item__stock');
    stock.appendChild(icon(ICONS.check));
    stock.appendChild(el('span'));
    info.appendChild(stock);

    var bottom = el('div', 'cart-item__bottom');
    var qty = el('div', 'cart-qty');
    var minus = el('button', 'cart-qty__btn cart-qty__minus');
    minus.type = 'button';
    minus.appendChild(icon(ICONS.minus));
    var input = el('input', 'cart-qty__input');
    input.type = 'text';
    input.inputMode = 'numeric';
    input.autocomplete = 'off';
    var plus = el('button', 'cart-qty__btn cart-qty__plus');
    plus.type = 'button';
    plus.appendChild(icon(ICONS.plus));
    qty.appendChild(minus);
    qty.appendChild(input);
    qty.appendChild(plus);

    var price = el('div', 'cart-item__price');
    var unitCol = el('div', 'cart-item__price-col cart-item__price-col--unit');
    unitCol.appendChild(el('span', 'cart-item__unit-value'));
    unitCol.appendChild(el('small', 'cart-item__unit-measure'));
    unitCol.appendChild(el('span', 'cart-item__price-label', cfg.unitPrice));
    var totalCol = el('div', 'cart-item__price-col cart-item__price-col--total');
    totalCol.appendChild(el('s', 'cart-item__was'));
    totalCol.appendChild(el('span', 'cart-item__now'));
    totalCol.appendChild(el('span', 'cart-item__price-label', cfg.lineTotal));
    price.appendChild(unitCol);
    price.appendChild(totalCol);
    bottom.appendChild(qty);
    bottom.appendChild(price);
    info.appendChild(bottom);

    var error = el('p', 'cart-item__error');
    error.setAttribute('role', 'alert');
    error.hidden = true;
    info.appendChild(error);
    li.appendChild(info);
    return li;
  }

  function updateItem(li, item) {
    var t = displayTitle(item);
    var href = item.url || '#';
    var media = li.querySelector('.cart-item__media');
    media.href = href;
    media.setAttribute('aria-label', t);
    media.tabIndex = -1;
    var img = media.querySelector('img');
    var src = item.featured_image ? item.featured_image.url : item.image;
    if (src) {
      var next = imageUrl(src, 216);
      if (img.getAttribute('src') !== next) {
        img.src = next;
        img.srcset = imageUrl(src, 216) + ' 1x, ' + imageUrl(src, 324) + ' 1.5x';
      }
      img.alt = (item.featured_image && item.featured_image.alt) || t;
      media.classList.remove('is-empty');
    } else {
      img.removeAttribute('src');
      img.removeAttribute('srcset');
      media.classList.add('is-empty');
    }

    var title = li.querySelector('.cart-item__title');
    title.href = href;
    title.textContent = t;
    var remove = li.querySelector('.cart-item__remove');
    remove.setAttribute('aria-label', tpl(cfg.removeLabel, { title: t }));
    remove.title = cfg.remove;

    var meta = li.querySelector('.cart-item__meta');
    var lines = metaLines(item);
    var sig = lines.join('\u0001');
    if (meta.getAttribute('data-sig') !== sig) {
      meta.setAttribute('data-sig', sig);
      meta.textContent = '';
      lines.forEach(function (l) { meta.appendChild(el('li', '', l)); });
    }
    meta.hidden = !lines.length;

    var chips = li.querySelector('.cart-item__chips');
    var discounts = (item.discounts || []).filter(function (d) { return d && d.amount > 0; });
    var chipSig = discounts.map(function (d) { return d.title + d.amount; }).join('|');
    if (chips.getAttribute('data-sig') !== chipSig) {
      chips.setAttribute('data-sig', chipSig);
      chips.textContent = '';
      discounts.forEach(function (d) { chips.appendChild(el('span', 'cart-chip', d.title + ' −' + money(d.amount))); });
    }
    chips.hidden = !discounts.length;

    var stock = li.querySelector('.cart-item__stock');
    if (stock) {
      var state = stockState(item);
      stock.className = 'cart-item__stock' + (state.cls ? ' ' + state.cls : '');
      var stockIcon = stock.querySelector('.cart-icon');
      if (stockIcon) stockIcon.innerHTML = state.icon;
      var stockText = stock.querySelector('span:last-child');
      if (stockText) stockText.textContent = state.text;
    }

    var rule = item.quantity_rule || {};
    var step = rule.increment > 1 ? rule.increment : 1;
    var max = rule.max || 0;
    // quantity_rule.max is a real, documented field on the cart AJAX schema (unlike variant.*), so
    // it's trustworthy on its own - this only layers in the SSR-preserved *stock-based* max (see
    // ssrFallback above) when it's tighter, the same real-stock-vs-purchase-rule minimum
    // main-cart.liquid computes server-side.
    var fallback = ssrFallback[item.key];
    if (fallback && fallback.max) {
      var fbMax = parseInt(fallback.max, 10);
      if (fbMax > 0 && (!max || fbMax < max)) max = fbMax;
    }
    var shown = pendingQty[item.key] != null ? pendingQty[item.key] : item.quantity;
    var input = li.querySelector('.cart-qty__input');
    if (document.activeElement !== input) input.value = shown;
    input.setAttribute('aria-label', tpl(cfg.quantityLabel, { title: t }));
    var minus = li.querySelector('.cart-qty__minus');
    var plus = li.querySelector('.cart-qty__plus');
    minus.setAttribute('aria-label', tpl(cfg.decreaseLabel, { title: t }));
    plus.setAttribute('aria-label', tpl(cfg.increaseLabel, { title: t }));
    plus.disabled = !!max && shown + step > max;
    li.setAttribute('data-step', step);
    li.setAttribute('data-max', max);

    var was = li.querySelector('.cart-item__was');
    var now = li.querySelector('.cart-item__now');
    now.textContent = money(item.final_line_price);
    var reduced = item.original_line_price > item.final_line_price;
    was.textContent = reduced ? money(item.original_line_price) : '';
    was.hidden = !reduced;
    li.querySelector('.cart-item__unit-value').textContent = money(item.final_price);
    var measure = li.querySelector('.cart-item__unit-measure');
    measure.textContent = unitPriceText(item);
    measure.hidden = !measure.textContent;

    var error = li.querySelector('.cart-item__error');
    var message = lineErrors[item.key] || '';
    error.textContent = message;
    error.hidden = !message;
  }

  function syncItems(items, opts) {
    var wanted = {};
    items.forEach(function (i) { wanted[i.key] = true; });
    Array.prototype.slice.call(elItems.children).forEach(function (li) {
      if (!wanted[li.getAttribute('data-key')] && !li.classList.contains('is-removing')) collapse(li);
    });
    var anchor = null;
    for (var i = items.length - 1; i >= 0; i--) {
      var item = items[i];
      var li = itemEl(item.key);
      var fresh = false;
      if (!li) { li = buildItem(item); fresh = true; }
      updateItem(li, item);
      if (fresh || li.nextElementSibling !== anchor) elItems.insertBefore(li, anchor);
      if (fresh && opts && opts.animate) {
        li.style.setProperty('--i', String(Math.min(items.length - 1 - i, 8)));
        li.classList.add('is-new');
      }
      anchor = li;
    }
    if (opts && opts.highlight) {
      var hl = itemEl(opts.highlight);
      if (hl) {
        hl.classList.remove('is-flash');
        void hl.offsetWidth;
        hl.classList.add('is-flash');
        setTimeout(function () { hl.scrollIntoView({ block: 'nearest', behavior: reduce.matches ? 'auto' : 'smooth' }); }, 60);
      }
    }
  }

  function collapse(li) {
    li.classList.add('is-removing');
    if (!ms(1)) { li.remove(); return; }
    li.style.height = li.offsetHeight + 'px';
    void li.offsetHeight;
    li.style.height = '0px';
    var done = false;
    var finish = function () { if (!done) { done = true; li.remove(); } };
    li.addEventListener('transitionend', function (e) { if (e.target === li && e.propertyName === 'height') finish(); });
    setTimeout(finish, 520);
  }

  function renderShipping() {
    var threshold = Number(cfg.shippingThreshold) || 0;
    if (!threshold || !cart || !cart.items.length) { elShipping.hidden = true; return; }
    var rate = 1;
    if (window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate) > 0) rate = parseFloat(Shopify.currency.rate);
    var target = Math.round(threshold * 100 * rate);
    var remaining = Math.max(0, target - cart.total_price);
    var unlocked = remaining === 0;
    if (!elShipping.firstChild) {
      var text = el('p', 'cart-ship__text');
      text.appendChild(icon(ICONS.truck));
      text.appendChild(el('span', 'cart-ship__msg'));
      var bar = el('div', 'cart-ship__bar');
      bar.setAttribute('role', 'progressbar');
      bar.setAttribute('aria-valuemin', '0');
      bar.setAttribute('aria-valuemax', '100');
      bar.appendChild(el('span', 'cart-ship__fill'));
      elShipping.appendChild(text);
      elShipping.appendChild(bar);
    }
    var msg = elShipping.querySelector('.cart-ship__msg');
    var nextText = unlocked ? cfg.shippingUnlocked : tpl(cfg.shippingProgress, { amount: money(remaining) });
    if (msg.textContent !== nextText) msg.textContent = nextText;
    var pct = Math.max(0, Math.min(100, Math.round((cart.total_price / target) * 100)));
    var bar2 = elShipping.querySelector('.cart-ship__bar');
    bar2.setAttribute('aria-valuenow', String(pct));
    bar2.setAttribute('aria-label', nextText);
    elShipping.querySelector('.cart-ship__fill').style.width = pct + '%';
    var wasUnlocked = elShipping.classList.contains('is-unlocked');
    elShipping.classList.toggle('is-unlocked', unlocked);
    if (unlocked && !wasUnlocked) announce(cfg.shippingUnlocked);
    elShipping.hidden = false;
  }

  function buildEmpty() {
    elEmpty.textContent = '';
    var wrap = el('div', 'cart-empty__inner');
    wrap.appendChild(icon(ICONS.bag));
    wrap.appendChild(el('h2', 'cart-empty__title', cfg.emptyTitle));
    wrap.appendChild(el('p', 'cart-empty__text', cfg.emptyText));
    var cta = el('a', 'cart-empty__cta');
    cta.href = cfg.emptyUrl || '/';
    cta.appendChild(el('span', '', cfg.emptyCta));
    cta.appendChild(icon(ICONS.arrow));
    wrap.appendChild(cta);
    elEmpty.appendChild(wrap);
  }

  // ---- note sheet: static chrome (title/label/placeholder/save label), filled once at init - see
  // "start" below. Unlike the drawer's own note sheet, this one is NOT nested inside any
  // already-open overlay (the full page has none), so it manages its own page-level
  // backdrop/inert/scroll-lock, the same way search-overlay.js does for its own overlay. ------------
  function initNoteSheet() {
    if (!cfg.noteEnabled || !elNoteSheet) return;
    q('[data-cart-note-label]').textContent = cfg.noteLabel;
    elNoteInput.placeholder = cfg.notePlaceholder;
    q('[data-cart-note-save]').textContent = cfg.noteSave;
    elNoteInput.addEventListener('input', function () {
      clearTimeout(noteTimer);
      noteTimer = setTimeout(saveNote, 700);
    });
    elNoteInput.addEventListener('blur', saveNote);
  }

  function noteFocusable() {
    return Array.prototype.filter.call(elNoteSheetPanel.querySelectorAll('a[href], button, input, textarea, [tabindex]:not([tabindex="-1"])'), function (n) {
      return !n.disabled && !n.hidden && n.offsetParent !== null && !n.closest('[hidden]') && n.tabIndex !== -1;
    });
  }

  function lockPage(on) {
    var doc = document.documentElement;
    if (on) {
      doc.style.setProperty('--hm-cart-note-sbw', (window.innerWidth - doc.clientWidth) + 'px');
      doc.classList.add('hm-cart-note-lock');
      Array.prototype.forEach.call(document.body.children, function (n) {
        if (n !== elNoteSheet && !n.contains(elNoteSheet) && !n.hasAttribute('inert') && n.tagName !== 'SCRIPT') {
          n.setAttribute('inert', '');
          n.setAttribute('data-cart-note-inert', '');
        }
      });
    } else {
      doc.classList.remove('hm-cart-note-lock');
      Array.prototype.forEach.call(document.querySelectorAll('[data-cart-note-inert]'), function (n) {
        n.removeAttribute('inert');
        n.removeAttribute('data-cart-note-inert');
      });
    }
  }

  function openNoteSheet() {
    if (!elNoteSheet || noteSheetOpen) return;
    noteSheetOpen = true;
    noteLastFocus = document.activeElement;
    q('[data-cart-note-title]').textContent = cart && cart.note ? cfg.noteEdit : cfg.noteToggle;
    elNoteInput.value = (cart && cart.note) || '';
    elNoteSheet.hidden = false;
    lockPage(true);
    void elNoteSheet.offsetWidth; // let the closed styles apply before the open class changes them
    elNoteSheet.classList.add('is-open');
    setTimeout(function () { elNoteInput.focus({ preventScroll: true }); }, ms(300));
  }

  function closeNoteSheet() {
    if (!noteSheetOpen) return;
    noteSheetOpen = false;
    elNoteSheet.classList.remove('is-open');
    saveNote(); // closing is "done writing" - flush immediately rather than waiting for blur/debounce
    setTimeout(function () {
      if (noteSheetOpen) return;
      elNoteSheet.hidden = true;
      lockPage(false);
      if (noteLastFocus && noteLastFocus.focus && document.contains(noteLastFocus)) noteLastFocus.focus({ preventScroll: true });
      noteLastFocus = null;
    }, ms(350));
  }

  function saveNote() {
    clearTimeout(noteTimer);
    noteTimer = 0;
    if (!elNoteInput || !cart) return Promise.resolve();
    var text = elNoteInput.value;
    if ((cart.note || '') === text) return Promise.resolve();
    return enqueue(function () { return api.note(text); }).then(function (next) {
      cart.note = next.note;
      renderFooter(); // the trigger button shows a preview of the saved note - see buildFooter()
    }, function (err) {
      toast(errorText(err));
    });
  }

  function buildFooter() {
    elFooter.textContent = '';
    var summary = el('div', 'cart-summary');
    summary.appendChild(el('div', 'cart-summary__discounts'));

    // Just above the subtotal row, so it's always visible in the summary card, rather than being a
    // separate collapsible field further down the main column (the old inline toggle it replaces).
    if (cfg.noteEnabled && elNoteSheet) {
      var noteBtn = el('button', 'cart-footer-note-btn');
      noteBtn.type = 'button';
      noteBtn.setAttribute('data-cart-note-trigger', '');
      var noteIcon = icon(ICONS.note);
      noteIcon.classList.add('cart-footer-note-btn__icon');
      noteBtn.appendChild(noteIcon);
      noteBtn.appendChild(el('span', 'cart-footer-note-btn__label', cfg.noteToggle));
      var noteArrow = icon(ICONS.arrow);
      noteArrow.classList.add('cart-footer-note-btn__chevron');
      noteBtn.appendChild(noteArrow);
      noteBtn.addEventListener('click', openNoteSheet);
      summary.appendChild(noteBtn);
    }

    var subRow = el('div', 'cart-summary__row cart-summary__row--sub');
    subRow.appendChild(el('span', 'cart-summary__label', cfg.subtotal));
    subRow.appendChild(el('span', 'cart-summary__sub-amount'));
    summary.appendChild(subRow);

    var shipRow = el('div', 'cart-summary__row cart-summary__row--sub');
    shipRow.appendChild(el('span', 'cart-summary__label', cfg.delivery));
    shipRow.appendChild(el('span', 'cart-summary__delivery-amount'));
    summary.appendChild(shipRow);

    summary.appendChild(el('div', 'cart-summary__divider'));

    var row = el('div', 'cart-summary__row cart-summary__row--grand');
    row.appendChild(el('span', 'cart-summary__label', cfg.total));
    row.appendChild(el('span', 'cart-summary__total'));
    summary.appendChild(row);
    summary.appendChild(el('p', 'cart-summary__saved'));
    summary.appendChild(el('p', 'cart-summary__note', cfg.taxNote));
    var checkout = el('button', 'cart-checkout');
    checkout.type = 'button';
    checkout.setAttribute('data-cart-checkout', '');
    checkout.appendChild(el('span', 'cart-checkout__label', cfg.checkout));
    summary.appendChild(checkout);
    elFooter.appendChild(summary);
  }

  function renderFooter() {
    var has = cart && cart.items.length > 0;
    elAside.hidden = !has;
    elBelow.hidden = !has;
    elEmpty.hidden = has;
    if (!has) return;
    elFooter.querySelector('.cart-summary__total').textContent = money(cart.total_price);
    var subLabel = elFooter.querySelector('.cart-summary__row--sub .cart-summary__label');
    if (subLabel) subLabel.textContent = cfg.subtotal + ' (' + countLabel(cart.item_count) + ')';
    var subAmount = elFooter.querySelector('.cart-summary__sub-amount');
    if (subAmount) subAmount.textContent = money(cart.total_price);
    var deliveryAmount = elFooter.querySelector('.cart-summary__delivery-amount');
    if (deliveryAmount) {
      var threshold = Number(cfg.shippingThreshold) || 0;
      var rate = 1;
      if (window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate) > 0) rate = parseFloat(Shopify.currency.rate);
      var unlocked = threshold > 0 && cart.total_price >= Math.round(threshold * 100 * rate);
      deliveryAmount.textContent = unlocked ? cfg.deliveryFree : cfg.deliveryCalculated;
      deliveryAmount.classList.toggle('is-free', unlocked);
    }
    var box = elFooter.querySelector('.cart-summary__discounts');
    var apps = (cart.cart_level_discount_applications || []).filter(function (d) { return d && d.total_allocated_amount > 0; });
    var sig = apps.map(function (d) { return d.title + d.total_allocated_amount; }).join('|');
    if (box.getAttribute('data-sig') !== sig) {
      box.setAttribute('data-sig', sig);
      box.textContent = '';
      apps.forEach(function (d) {
        var r = el('div', 'cart-summary__row cart-summary__row--discount');
        r.appendChild(el('span', 'cart-summary__label', d.title));
        r.appendChild(el('span', '', '−' + money(d.total_allocated_amount)));
        box.appendChild(r);
      });
    }
    var saved = elFooter.querySelector('.cart-summary__saved');
    saved.textContent = cart.total_discount > 0 ? tpl(cfg.saved, { amount: money(cart.total_discount) }) : '';
    saved.hidden = !saved.textContent;
    var checkout = elFooter.querySelector('[data-cart-checkout]');
    if (!checkingOut) checkout.disabled = false;
    var noteBtn = elFooter.querySelector('[data-cart-note-trigger]');
    if (noteBtn) {
      var hasNote = !!(cart.note && cart.note.trim());
      noteBtn.classList.toggle('has-note', hasNote);
      noteBtn.querySelector('.cart-footer-note-btn__label').textContent = hasNote ? cart.note : cfg.noteToggle;
    }
    // Keep the sheet's own textarea in sync too (e.g. the cart refreshed elsewhere) - but never while
    // someone's actively typing in it, which this same render cycle would otherwise fight with.
    if (elNoteInput && document.activeElement !== elNoteInput && elNoteInput.value !== (cart.note || '')) {
      elNoteInput.value = cart.note || '';
    }
  }

  function countLabel(n) { return n + ' ' + (n === 1 ? cfg.itemOne : cfg.itemMany); }

  // ---- syncing with the drawer (and any other tab of the mock) ---------------------------------
  function broadcast() {
    if (cart) document.dispatchEvent(new CustomEvent('hm:cart-sync', { detail: cart }));
  }
  document.addEventListener('hm:cart-sync', function (e) {
    if (!e.detail || e.detail === cart) return; // our own broadcast bouncing back
    applyCart(e.detail);
  });

  function applyCart(next) {
    cart = next;
    Object.keys(pendingQty).forEach(function (k) { if (!findItem(k)) { delete pendingQty[k]; clearTimeout(qtyTimers[k]); delete qtyTimers[k]; } });
    var has = cart.items.length > 0;
    elCountLabel.textContent = has ? '(' + countLabel(cart.item_count) + ')' : '';
    elItems.hidden = !has;
    if (!elEmpty.firstChild) buildEmpty();
    syncItems(cart.items, { animate: true });
    renderShipping();
    renderFooter();
    if (elDiscount) elDiscount.hidden = !cfg.discountEnabled || !has;
    if (!has && noteSheetOpen) closeNoteSheet(); // nothing left to attach a note to
    hideStatus();
    broadcast();
  }

  // ---- quantity, remove, undo ------------------------------------------------------------------------------------
  function reflectLine(key) {
    var item = findItem(key);
    var li = itemEl(key);
    if (item && li) updateItem(li, item);
  }

  function requestQty(key, qty, now) {
    var item = findItem(key);
    if (!item) return;
    var rule = item.quantity_rule || {};
    var step = rule.increment > 1 ? rule.increment : 1;
    var min = rule.min > 1 ? rule.min : 1;
    if (qty > 0 && qty < min) qty = 0;
    if (qty > 0 && step > 1) qty = Math.round(qty / step) * step;
    if (rule.max && qty > rule.max) qty = rule.max;
    if (qty === 0) { removeItem(key); return; }
    delete lineErrors[key];
    pendingQty[key] = qty;
    reflectLine(key);
    var li = itemEl(key);
    if (li) li.classList.add('is-updating');
    clearTimeout(qtyTimers[key]);
    qtyTimers[key] = setTimeout(function () { commitQty(key); }, now ? 0 : 320);
  }

  function commitQty(key) {
    var qty = pendingQty[key];
    clearTimeout(qtyTimers[key]);
    delete qtyTimers[key];
    if (qty == null) return Promise.resolve();
    var item = findItem(key);
    if (item && item.quantity === qty) { delete pendingQty[key]; reflectLine(key); var l = itemEl(key); if (l) l.classList.remove('is-updating'); return Promise.resolve(); }
    return enqueue(function () { return api.change(key, qty); }).then(function (next) {
      delete pendingQty[key];
      var a = findItem(key);
      applyCart(next);
      var t = itemEl(key);
      if (t) t.classList.remove('is-updating');
      if (a) announce(tpl(cfg.quantityLabel, { title: displayTitle(a) }) + ' ' + qty);
    }, function (err) {
      delete pendingQty[key];
      lineErrors[key] = errorText(err);
      setTimeout(function () { delete lineErrors[key]; reflectLine(key); }, 7000);
      return refresh().catch(function () { /* the message under the line is enough */ }).then(function () {
        var t = itemEl(key);
        if (t) t.classList.remove('is-updating');
        reflectLine(key);
      });
    });
  }

  function removeItem(key) {
    var item = findItem(key);
    if (!item) return;
    var plan = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan;
    lastRemoved = {
      body: { id: item.variant_id || item.id, quantity: item.quantity, properties: item.properties || undefined, selling_plan: plan ? plan.id : undefined },
      meta: { title: displayTitle(item), price: item.final_price, variant: item.variant_title, url: item.url, image: item.featured_image ? item.featured_image.url : item.image },
      title: displayTitle(item),
    };
    clearTimeout(qtyTimers[key]);
    delete pendingQty[key];
    delete qtyTimers[key];
    var li = itemEl(key);
    if (li) collapse(li);
    return enqueue(function () { return api.change(key, 0); }).then(function (next) {
      applyCart(next);
      var removed = lastRemoved;
      toast(tpl(cfg.removed, { title: removed.title }), { label: cfg.undo, run: undoRemove });
      announce(tpl(cfg.removed, { title: removed.title }));
    }, function (err) {
      lastRemoved = null;
      lineErrors[key] = errorText(err);
      return refresh().catch(function () { showStatus(errorText(err), true); });
    });
  }

  function undoRemove() {
    var removed = lastRemoved;
    if (!removed) return;
    lastRemoved = null;
    enqueue(function () { return api.add(removed.body, removed.meta).then(function (added) { return api.get().then(function (next) { return { added: added, next: next }; }); }); })
      .then(function (res) { applyCart(res.next); syncItems(res.next.items, { animate: true, highlight: res.added && res.added.key }); announce(tpl(cfg.added, { title: removed.title })); })
      .catch(function (err) { toast(errorText(err)); refresh().catch(function () {}); });
  }

  // ---- discount code (a real navigation: Shopify has no ajax endpoint to apply one to the cart) ---
  function applyDiscount(code) {
    if (!code) { var errEl = elDiscount.querySelector('.cart-discount__error'); errEl.textContent = cfg.discountInvalid; errEl.hidden = false; return; }
    Object.keys(qtyTimers).forEach(function (k) { commitQty(k); });
    var go = function () { window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(cfg.routes.cart); };
    if (mockEl) { toast('Discount codes need a live store to apply.'); return; }
    chain.then(go, go);
  }

  // ---- checkout ------------------------------------------------------------------------------------------------
  function checkout(btn) {
    if (checkingOut || !cart || !cart.items.length) return;
    checkingOut = true;
    btn.disabled = true;
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');
    Object.keys(qtyTimers).forEach(function (k) { commitQty(k); });
    saveNote();
    var go = function () { window.location.href = cfg.routes.checkout; };
    chain.then(go, go);
  }

  // ---- events ---------------------------------------------------------------------------------------------------------------------------------
  root.addEventListener('click', function (e) {
    var t = e.target;
    var remove = t.closest('.cart-item__remove');
    if (remove) { removeItem(remove.closest('.cart-item').getAttribute('data-key')); return; }
    var minus = t.closest('.cart-qty__minus');
    var plus = t.closest('.cart-qty__plus');
    if (minus || plus) {
      var li = (minus || plus).closest('.cart-item');
      var key = li.getAttribute('data-key');
      var step = parseInt(li.getAttribute('data-step'), 10) || 1;
      var current = pendingQty[key] != null ? pendingQty[key] : (findItem(key) || {}).quantity;
      if (current == null) return;
      requestQty(key, current + (plus ? step : -step));
      return;
    }
    var co = t.closest('[data-cart-checkout]');
    if (co) { checkout(co); return; }
  });

  if (elNoteSheet) {
    elNoteSheet.addEventListener('click', function (e) {
      // Same action either way - the save button is just a more explicit, reassuring way to say
      // "I'm done", not a functionally different path from the X or the backdrop.
      if (e.target.closest('[data-cart-note-close], [data-cart-note-save]')) closeNoteSheet();
    });
  }

  document.addEventListener('keydown', function (e) {
    if (!noteSheetOpen) return;
    if (e.key === 'Escape') { e.preventDefault(); closeNoteSheet(); return; }
    if (e.key !== 'Tab') return;
    var items = noteFocusable();
    if (!items.length) { e.preventDefault(); elNoteSheetPanel.focus(); return; }
    var first = items[0];
    var last = items[items.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === elNoteSheetPanel)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    else if (!elNoteSheetPanel.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
  });

  function commitInput(input) {
    var li = input.closest('.cart-item');
    if (!li) return;
    var key = li.getAttribute('data-key');
    var item = findItem(key);
    if (!item) return;
    var value = parseInt(String(input.value).replace(/[^\d]/g, ''), 10);
    if (isNaN(value)) { input.value = pendingQty[key] != null ? pendingQty[key] : item.quantity; return; }
    requestQty(key, value, true);
  }
  root.addEventListener('change', function (e) { if (e.target.classList.contains('cart-qty__input')) commitInput(e.target); });
  root.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.classList && e.target.classList.contains('cart-qty__input')) { e.preventDefault(); commitInput(e.target); }
  });
  root.addEventListener('input', function (e) {
    if (e.target.classList && e.target.classList.contains('cart-qty__input')) e.target.value = e.target.value.replace(/[^\d]/g, '').slice(0, 4);
  });

  if (elDiscount) {
    // A plain div, not a <form>: it lives inside the page's real cart form (for no-JS submits), and
    // HTML does not allow a <form> nested inside another <form>.
    var runApplyDiscount = function () {
      var input = elDiscount.querySelector('.cart-discount__input');
      var errEl = elDiscount.querySelector('.cart-discount__error');
      errEl.hidden = true;
      applyDiscount(input.value.trim());
    };
    elDiscount.querySelector('.cart-discount__apply').addEventListener('click', runApplyDiscount);
    elDiscount.querySelector('.cart-discount__input').addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); runApplyDiscount(); }
    });
  }

  window.addEventListener('pageshow', function (e) {
    if (checkingOut) {
      checkingOut = false;
      var co = elFooter.querySelector('[data-cart-checkout]');
      if (co) { co.disabled = false; co.classList.remove('is-loading'); co.removeAttribute('aria-busy'); }
    }
    if (e.persisted) refresh().catch(function () {});
  });
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden && cart && Date.now() - lastSync > 5000) loadCart().catch(function () {});
  });
  window.addEventListener('storage', function (e) { if (mockEl && e.key === 'hm-mock-cart') refresh().catch(function () {}); });

  // ---- start ----------------------------------------------------------------------------------------------------------------------------------
  if (elContinue) {
    elContinue.href = cfg.continueUrl || '/';
    var label = elContinue.querySelector('[data-cart-continue-label]');
    if (label) label.textContent = cfg.continueShopping;
  }
  buildFooter();
  initNoteSheet();
  buildEmpty();
  elEmpty.hidden = true;
  if (elDiscount) {
    elDiscount.querySelector('.cart-discount__apply').textContent = cfg.discountApply;
    var discountInput = elDiscount.querySelector('.cart-discount__input');
    discountInput.placeholder = cfg.discountPlaceholder;
    discountInput.setAttribute('aria-label', cfg.discountLabel);
  }

  var seed = null;
  if (seedEl) { try { seed = JSON.parse(seedEl.textContent); } catch (e) { /* fall through to a fetch */ } }
  if (seed) {
    // Read the real stock text and stock-aware quantity max straight off the server-rendered lines
    // - the one moment this page has them - before they're discarded below. See ssrFallback's
    // declaration and stockState() for why this is needed at all.
    Array.prototype.forEach.call(elItems.querySelectorAll('.cart-item'), function (li) {
      var key = li.getAttribute('data-key');
      if (!key) return;
      var stock = li.querySelector('.cart-item__stock');
      var entry = { max: li.getAttribute('data-max') };
      if (stock) {
        var cls = stock.className.replace('cart-item__stock', '').trim();
        var text = stock.querySelector('span:last-child');
        entry.cls = cls;
        entry.icon = cls === 'is-oos' ? ICONS.x : ICONS.check;
        entry.text = text ? text.textContent.trim() : cfg.inStock;
      }
      ssrFallback[key] = entry;
    });
    // The server rendered plain, real <li> rows so the page works without JS (a number input, a real
    // remove link — no decorative +/- buttons that would otherwise do nothing). Now that JS is here,
    // clear them so syncItems() builds its own rich rows instead of trying to reuse the plain ones.
    elItems.textContent = '';
    lastSync = Date.now();
    applyCart(seed);
  }
  else {
    showStatus(cfg.loading);
    loadCart().then(function () { hideStatus(); }, function (err) { showStatus(errorText(err), true); });
  }

  // ---- "You may also like": genuinely related to the bag, not a fixed list --------------------
  // Shopify's real recommendations engine needs one anchor product. We use whichever product was
  // most recently added (tracked by cart-drawer.js, so it survives the add → view-bag navigation),
  // falling back to the first line in the bag. The section itself (cart-recommendations.liquid)
  // already renders a sensible fallback without this — this only makes it actually related.
  var elRecs = document.querySelector('[data-cart-recs]');
  var lastRecsAnchor = null;
  function refreshRecs() {
    if (!elRecs || !window.fetch || !window.DOMParser || mockEl) return;
    var base = elRecs.getAttribute('data-recommendations-base-url');
    if (!base) return;
    var anchor = null;
    try { anchor = sessionStorage.getItem('hm-last-added-product'); } catch (e) { /* private mode */ }
    if (!anchor && cart && cart.items.length) anchor = cart.items[0].product_id;
    if (!anchor || anchor === lastRecsAnchor) return;
    lastRecsAnchor = anchor;
    fetch(base + '&product_id=' + encodeURIComponent(anchor))
      .then(function (res) { if (!res.ok) throw new Error('recs ' + res.status); return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-recs]');
        if (!fresh || !fresh.querySelector('.product-card')) return;
        elRecs.innerHTML = fresh.innerHTML;
        elRecs.hidden = false;
        Array.prototype.forEach.call(elRecs.querySelectorAll('.reveal'), function (n) { n.classList.add('is-visible'); });
      })
      .catch(function () { /* the page-load render is still a real, working list */ });
  }
  var lastKnownCount = null;
  document.addEventListener('hm:cart-sync', function (e) {
    var next = e.detail;
    if (!next) return;
    if (lastKnownCount != null && next.item_count > lastKnownCount) refreshRecs();
    lastKnownCount = next.item_count;
  });
  if (cart) lastKnownCount = cart.item_count;
  refreshRecs();

  window.HimMoolCartPage = { refresh: refresh, getCart: function () { return cart; } };
})();

(function () {
  var hero = document.querySelector('.product-hero');
  if (!hero) return;

  // The rating links to the reviews section. If that section is missing or still hidden (for example
  // the reviews app has not loaded), the link does nothing instead of jumping to the top of the page.
  var ratingLink = hero.querySelector('.rating-link');
  if (ratingLink) {
    ratingLink.addEventListener('click', function (e) {
      var target = document.getElementById((ratingLink.getAttribute('href') || '#').slice(1));
      if (!target || target.hidden || !target.offsetParent) e.preventDefault();
    });
  }

  // Gallery: thumbnails and arrows swap the main image.
  var thumbs = hero.querySelectorAll('.gallery-thumb');
  var gallery = hero.querySelector('.gallery-main');
  var mainImg = hero.querySelector('.gallery-main-image');
  var zoom = hero.querySelector('.gallery-zoom');

  // Scroll the thumbnail list (not the page) so the active thumbnail stays visible.
  function reveal(thumb) {
    var list = thumb.closest('.gallery-thumbs');
    if (!list) return;
    var l = list.getBoundingClientRect();
    var t = thumb.getBoundingClientRect();
    if (list.scrollHeight > list.clientHeight) {
      if (t.top < l.top) list.scrollTop -= l.top - t.top;
      else if (t.bottom > l.bottom) list.scrollTop += t.bottom - l.bottom;
    }
    if (list.scrollWidth > list.clientWidth) {
      if (t.left < l.left) list.scrollLeft -= l.left - t.left;
      else if (t.right > l.right) list.scrollLeft += t.right - l.right;
    }
  }

  // Load a gallery photo ahead of time. The off-screen image uses the same srcset and sizes as the
  // main image, so the browser picks the same file and the later swap is served from cache.
  var loaded = {};
  function load(index) {
    if (loaded[index]) return loaded[index];
    var t = thumbs[index];
    var img = new Image();
    if (mainImg.getAttribute('sizes')) img.sizes = mainImg.getAttribute('sizes');
    if (t.dataset.srcset) img.srcset = t.dataset.srcset;
    img.src = t.dataset.full;
    loaded[index] = (img.decode ? img.decode() : new Promise(function (resolve) { img.onload = resolve; })).catch(function () {});
    return loaded[index];
  }

  var selectToken = 0;
  function select(index) {
    if (!thumbs.length) return;
    index = (index + thumbs.length) % thumbs.length;
    var t = thumbs[index];
    var token = ++selectToken;
    thumbs.forEach(function (th, i) { th.classList.toggle('is-active', i === index); });
    if (zoom) zoom.href = t.dataset.full;
    reveal(t);

    // Keep the current photo until the new one is ready; show a loading state only if it is slow.
    var ready = false;
    var slow = setTimeout(function () { if (!ready && token === selectToken) gallery.classList.add('is-loading'); }, 150);
    load(index).then(function () {
      ready = true;
      clearTimeout(slow);
      if (token !== selectToken) return; // a newer click won
      mainImg.src = t.dataset.full;
      if (t.dataset.srcset) mainImg.srcset = t.dataset.srcset;
      else mainImg.removeAttribute('srcset');
      mainImg.alt = t.dataset.alt || '';
      gallery.classList.remove('is-loading');
    });
    // The photos on either side are the likeliest next clicks.
    load((index + 1) % thumbs.length);
    load((index - 1 + thumbs.length) % thumbs.length);
  }
  function current() {
    return Array.prototype.findIndex.call(thumbs, function (t) { return t.classList.contains('is-active'); });
  }
  thumbs.forEach(function (t, i) {
    t.addEventListener('click', function () { select(i); });
    // Start downloading as soon as a pointer or finger reaches a thumbnail.
    ['pointerenter', 'focus', 'touchstart'].forEach(function (evt) {
      t.addEventListener(evt, function () { load(i); }, { passive: true });
    });
  });
  // Full-screen viewer: opens from the main photo (or the magnifier button, which stays a plain link
  // to the large image if the viewer script is not available).
  function shownRect() { // where the photo is actually drawn inside its square frame
    var f = gallery.getBoundingClientRect();
    var nw = mainImg.naturalWidth;
    var nh = mainImg.naturalHeight;
    if (!nw || !nh) return f;
    var k = Math.min(f.width / nw, f.height / nh);
    var w = nw * k;
    var h = nh * k;
    var left = f.left + (f.width - w) / 2;
    var top = f.top + (f.height - h) / 2;
    return { left: left, top: top, width: w, height: h, right: left + w, bottom: top + h };
  }

  function openViewer(e) {
    if (!window.HimMoolLightbox) return;
    if (e) e.preventDefault();
    var items = thumbs.length
      ? Array.prototype.map.call(thumbs, function (t) { return { src: t.dataset.zoom || t.dataset.full, alt: t.dataset.alt || '' }; })
      : [{ src: mainImg.dataset.zoom || (zoom && zoom.getAttribute('href')) || mainImg.currentSrc, alt: mainImg.alt }];
    window.HimMoolLightbox.open({
      items: items,
      index: Math.max(0, current()),
      preview: mainImg.currentSrc || mainImg.src,
      getOriginRect: shownRect,
      onChange: function (i) { if (thumbs.length) select(i); },
    });
  }
  gallery.addEventListener('click', openViewer);

  // While the visitor reads the page, quietly fetch the rest of the photos, one at a time.
  // Skipped on data-saver mode and very slow connections.
  var connection = navigator.connection || {};
  if (thumbs.length > 1 && !connection.saveData && !/(^|-)2g$/.test(connection.effectiveType || '')) {
    var queue = Array.prototype.map.call(thumbs, function (_, i) { return i; }).slice(1);
    var idle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 800); };
    var pump = function () {
      if (!queue.length) return;
      load(queue.shift()).then(function () { idle(pump); });
    };
    if (document.readyState === 'complete') idle(pump);
    else window.addEventListener('load', function () { idle(pump); }, { once: true });
  }

  // Quantity stepper: clamps to whatever the input's own max is (set from the selected variant's
  // real, tracked inventory - see below - or absent entirely for an untracked/unlimited variant).
  var qty = hero.querySelector('.qty-stepper input');
  var minus = hero.querySelector('.qty-minus');
  var plus = hero.querySelector('.qty-plus');
  function qtyMax() {
    var m = qty && qty.getAttribute('max');
    return m ? parseInt(m, 10) : Infinity;
  }
  function setQty(n) {
    if (!qty) return;
    var max = qtyMax();
    var v = Math.max(1, n || 1);
    if (isFinite(max)) v = Math.min(v, Math.max(max, 1));
    qty.value = v;
  }
  if (minus) minus.addEventListener('click', function () { setQty(parseInt(qty.value, 10) - 1); });
  if (plus) plus.addEventListener('click', function () { setQty(parseInt(qty.value, 10) + 1); });
  if (qty) qty.addEventListener('change', function () { setQty(parseInt(qty.value, 10)); });

  // Options: the selected pill decides the price, the variant id, whether it can be bought at all,
  // the quantity stepper's max, and the "Only X left" note - all switching together so a customer
  // never sees stock info for the variant they had selected a moment ago.
  var addBtn = hero.querySelector('.btn-add-to-cart');
  var buyBtn = hero.querySelector('.btn-buy-now');
  var stockNote = hero.querySelector('[data-stock-note]');
  var stockCount = hero.querySelector('[data-stock-count]');
  hero.querySelectorAll('.option-pill input').forEach(function (input) {
    input.addEventListener('change', function () {
      var price = input.dataset.price;
      if (price) hero.querySelectorAll('[data-price-display]').forEach(function (el) { el.textContent = price; });
      var id = hero.querySelector('input[type="hidden"][name="id"]');
      if (id && input.dataset.variantId) id.value = input.dataset.variantId;

      var available = input.dataset.available !== 'false';
      var tracked = input.dataset.inventoryTracked === 'true';
      var quantity = parseInt(input.dataset.inventoryQuantity, 10);
      if (isNaN(quantity)) quantity = 0;

      if (addBtn) {
        addBtn.disabled = !available;
        var label = addBtn.querySelector('[data-button-label]');
        if (label) label.textContent = available ? addBtn.dataset.label : addBtn.dataset.soldOut;
      }
      if (buyBtn) buyBtn.disabled = !available;

      if (qty) {
        qty.disabled = !available;
        if (tracked && quantity > 0) qty.setAttribute('max', quantity);
        else qty.removeAttribute('max');
        setQty(parseInt(qty.value, 10)); // re-clamp to the new variant's max, if any
      }
      if (minus) minus.disabled = !available;
      if (plus) plus.disabled = !available;

      var lowStock = tracked && quantity > 0 && quantity <= 5;
      if (stockNote) stockNote.hidden = !lowStock;
      if (stockCount && lowStock) stockCount.textContent = quantity;
    });
  });
})();

// Product page accordion (Product Details / Ingredients / Shipping & Returns / etc): a plain
// expand/collapse toggle per row, same interaction as the Contact page's FAQ accordion.
(function () {
  var items = document.querySelectorAll('.product-accordion__item');
  if (!items.length) return;

  items.forEach(function (item) {
    var toggle = item.querySelector('.product-accordion__toggle');
    if (!toggle) return;
    toggle.addEventListener('click', function () {
      var open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      item.classList.toggle('is-open', !open);
    });
  });
})();

// Store only: upgrades the server-rendered list with Shopify's automatic recommendations.
// The section already renders a sensible list without JavaScript, so any failure here
// (offline, no recommendations, unexpected markup) simply leaves that list untouched.
(function () {
  var section = document.querySelector('[data-recommendations-url]');
  if (!section || !window.fetch || !window.DOMParser) return;

  fetch(section.dataset.recommendationsUrl)
    .then(function (response) {
      if (!response.ok) throw new Error('recommendations ' + response.status);
      return response.text();
    })
    .then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-recommendations-url]');
      if (!fresh || !fresh.querySelector('.product-card')) return;

      section.innerHTML = fresh.innerHTML;
      section.hidden = false;
      section.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-visible'); });
    })
    .catch(function () {});
})();

// Store only: reveals the *interactive app widget column* once (and only if) it has genuinely
// loaded with its own real styling - e.g. Judge.me's script fetching its stylesheet and drawing
// the real histogram/review list. The rating card next to it is always server-rendered straight
// from Shopify's standard review metafields (see product-reviews.liquid), so visitors are never
// left looking at a bare heading, and are never shown an app's raw unstyled internals if its
// script fails to load (an earlier version of this file force-revealed Judge.me's pre-rendered
// HTML after a timeout - that HTML has no styling without Judge.me's own stylesheet, which loads
// from the same script, so it just dumped unstyled text onto the page. Never do that again: only
// reveal what a script proves it has actually finished setting up itself.)
(function () {
  var widget = document.querySelector('[data-reviews-await] .reviews-widget');
  if (!widget) return;

  // Real content = visible text or media, ignoring the scripts and styles apps tuck into their blocks,
  // and ignoring Judge.me's own pre-rendered (but still invisible-until-its-script-runs) markup.
  function hasContent() {
    var copy = widget.cloneNode(true);
    Array.prototype.forEach.call(
      copy.querySelectorAll('script, style, noscript, template, .reviews-widget-hint, .jdgm-rev-widg'),
      function (n) { n.remove(); }
    );
    return (copy.textContent || '').trim().length > 0 || !!copy.querySelector('img, svg, iframe, canvas, video');
  }

  // Judge.me's widget specifically: only "loaded" once its own script has removed its own
  // temporary hiding style - i.e. it is actually displaying with its own real stylesheet, not
  // just present-but-invisible in the DOM.
  function judgeMeReady() {
    var el = widget.querySelector('.jdgm-rev-widg');
    return !!el && !widget.querySelector('.jdgm-temp-hiding-style') && getComputedStyle(el).display !== 'none';
  }

  function reveal() { widget.classList.add('is-populated'); }

  if (hasContent() || judgeMeReady()) { reveal(); return; }
  if (!window.MutationObserver) return;
  var observer = new MutationObserver(function () {
    if (hasContent() || judgeMeReady()) { observer.disconnect(); reveal(); }
  });
  observer.observe(widget, { childList: true, subtree: true, characterData: true, attributes: true });
})();

// Progressively enhances any <select data-custom-select> into a fully custom-styled dropdown
// (native <select> popups can't be styled and render inconsistently across browsers/OS).
//
// The real <select> stays in the DOM, visually hidden, and remains the actual source of truth:
// it still submits with its form, still works if JS fails to load (no-JS fallback), and every
// selection made through the custom UI is written back to it with a real 'change' (and 'blur')
// event dispatched — so any existing code listening on the select (form validation, navigation,
// etc.) keeps working completely unchanged.
//
// Handles: click + full keyboard (arrows/Home/End/Enter/Space/Escape/type-ahead), touch, closing
// on outside click/scroll/resize, only one dropdown open at a time, disabled options and disabled
// selects, and flipping the panel to open upward when there isn't room below.
(function () {
  'use strict';

  var current = null; // the one currently-open instance, if any

  function closeCurrent() {
    if (current) { current.close(); current = null; }
  }

  function enhance(select) {
    if (!select || select.dataset.customSelectReady) return;
    select.dataset.customSelectReady = 'true';

    var wrap = document.createElement('div');
    wrap.className = 'custom-select';

    var trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'custom-select__trigger';
    var triggerId = (select.id || 'custom-select') + '-trigger';
    var listboxId = (select.id || 'custom-select') + '-listbox';
    trigger.id = triggerId;
    trigger.setAttribute('aria-haspopup', 'listbox');
    trigger.setAttribute('aria-expanded', 'false');
    if (select.hasAttribute('aria-describedby')) {
      trigger.setAttribute('aria-describedby', select.getAttribute('aria-describedby'));
    }

    var valueEl = document.createElement('span');
    valueEl.className = 'custom-select__value';
    var chevron = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    chevron.setAttribute('class', 'custom-select__chevron');
    chevron.setAttribute('width', '11');
    chevron.setAttribute('height', '11');
    chevron.setAttribute('viewBox', '0 0 24 24');
    chevron.setAttribute('fill', 'none');
    chevron.setAttribute('stroke', 'currentColor');
    chevron.setAttribute('stroke-width', '2.4');
    chevron.setAttribute('stroke-linecap', 'round');
    chevron.setAttribute('stroke-linejoin', 'round');
    chevron.setAttribute('aria-hidden', 'true');
    var chevronPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    chevronPath.setAttribute('d', 'M6 9l6 6 6-6');
    chevron.appendChild(chevronPath);
    trigger.appendChild(valueEl);
    trigger.appendChild(chevron);

    var listbox = document.createElement('ul');
    listbox.className = 'custom-select__listbox';
    listbox.id = listboxId;
    listbox.setAttribute('role', 'listbox');
    listbox.tabIndex = -1;
    listbox.setAttribute('aria-labelledby', triggerId);
    listbox.hidden = true;

    var options = []; // { li, value, disabled }

    function buildOptions() {
      listbox.innerHTML = '';
      options = [];
      Array.prototype.forEach.call(select.options, function (opt, i) {
        var li = document.createElement('li');
        li.className = 'custom-select__option';
        li.id = listboxId + '-opt-' + i;
        li.setAttribute('role', 'option');
        li.textContent = opt.text;
        var isDisabled = opt.disabled;
        li.setAttribute('aria-disabled', isDisabled ? 'true' : 'false');
        li.setAttribute('aria-selected', opt.selected ? 'true' : 'false');
        listbox.appendChild(li);
        options.push({ li: li, value: opt.value, disabled: isDisabled, opt: opt });
      });
    }
    buildOptions();

    function syncTriggerLabel() {
      var i = select.selectedIndex;
      var opt = i > -1 ? select.options[i] : null;
      valueEl.textContent = opt ? opt.text : '';
      valueEl.classList.toggle('is-placeholder', !!(opt && opt.disabled));
      options.forEach(function (o) { o.li.setAttribute('aria-selected', o.opt.selected ? 'true' : 'false'); });
    }

    // Insert the new UI, move the real select inside (still submits with the form; hidden from
    // sighted/keyboard/AT users since the custom trigger now carries the interaction + a11y).
    select.parentNode.insertBefore(wrap, select);
    select.classList.add('custom-select__native');
    select.setAttribute('aria-hidden', 'true');
    select.tabIndex = -1;
    wrap.appendChild(select);
    wrap.appendChild(trigger);
    wrap.appendChild(listbox);
    select.customSelectTrigger = trigger; // lets other scripts (e.g. form validation) focus the right element

    // Repoint any <label for="{select.id}"> to the trigger, so clicking/tapping the label still
    // focuses the right (now-visible) control. Left alone, the label would keep targeting the
    // native select, which still works with no JS but is invisible once this enhancement runs.
    if (select.id) {
      var label = document.querySelector('label[for="' + select.id + '"]');
      if (label) label.setAttribute('for', trigger.id);
    }

    syncTriggerLabel();
    if (select.disabled) trigger.disabled = true;

    var activeIndex = -1;
    var typeahead = '';
    var typeaheadTimer = null;

    function selectableIndexes() {
      var out = [];
      options.forEach(function (o, i) { if (!o.disabled) out.push(i); });
      return out;
    }

    function setActive(index) {
      if (activeIndex > -1 && options[activeIndex]) options[activeIndex].li.classList.remove('is-active');
      activeIndex = index;
      if (index > -1 && options[index]) {
        var li = options[index].li;
        li.classList.add('is-active');
        trigger.setAttribute('aria-activedescendant', li.id);
        if (typeof li.scrollIntoView === 'function') li.scrollIntoView({ block: 'nearest' });
      } else {
        trigger.removeAttribute('aria-activedescendant');
      }
    }

    function isOpen() { return wrap.classList.contains('is-open'); }

    function open() {
      if (isOpen() || trigger.disabled) return;
      closeCurrent();
      current = { close: close };

      listbox.hidden = false;
      // Measure with the panel invisible-but-in-flow so opening never causes a visible flicker.
      listbox.style.visibility = 'hidden';
      listbox.style.maxHeight = '';
      var triggerRect = trigger.getBoundingClientRect();
      var viewportH = window.innerHeight || document.documentElement.clientHeight;
      var spaceBelow = viewportH - triggerRect.bottom;
      var spaceAbove = triggerRect.top;
      var neededHeight = listbox.scrollHeight;
      var margin = 10;
      var openUp = neededHeight + margin > spaceBelow && spaceAbove > spaceBelow;
      wrap.classList.toggle('is-open-up', openUp);
      var available = (openUp ? spaceAbove : spaceBelow) - margin;
      listbox.style.maxHeight = Math.max(120, Math.min(320, available)) + 'px';
      listbox.style.visibility = '';

      wrap.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');

      var selectedIndex = options.reduce(function (found, o, i) { return o.opt.selected ? i : found; }, -1);
      setActive(selectedIndex > -1 ? selectedIndex : (selectableIndexes()[0] != null ? selectableIndexes()[0] : -1));
    }

    function close() {
      if (!isOpen()) return;
      wrap.classList.remove('is-open', 'is-open-up');
      trigger.setAttribute('aria-expanded', 'false');
      trigger.removeAttribute('aria-activedescendant');
      if (activeIndex > -1 && options[activeIndex]) options[activeIndex].li.classList.remove('is-active');
      activeIndex = -1;
      listbox.hidden = true;
      if (current && current.close === close) current = null;
    }

    function commit(index) {
      var o = options[index];
      if (!o || o.disabled) return;
      select.value = o.value;
      syncTriggerLabel();
      select.dispatchEvent(new Event('change', { bubbles: true }));
      close();
      trigger.focus();
    }

    function moveActive(delta) {
      var idxs = selectableIndexes();
      if (!idxs.length) return;
      var pos = idxs.indexOf(activeIndex);
      if (pos === -1) pos = delta > 0 ? -1 : idxs.length;
      pos += delta;
      if (pos < 0) pos = 0;
      if (pos > idxs.length - 1) pos = idxs.length - 1;
      setActive(idxs[pos]);
    }

    function typeaheadJump(char) {
      window.clearTimeout(typeaheadTimer);
      typeahead += char.toLowerCase();
      typeaheadTimer = window.setTimeout(function () { typeahead = ''; }, 600);
      var match = options.findIndex(function (o) {
        return !o.disabled && o.li.textContent.toLowerCase().indexOf(typeahead) === 0;
      });
      if (match > -1) {
        if (isOpen()) setActive(match); else commit(match);
      }
    }

    trigger.addEventListener('click', function () {
      if (isOpen()) close(); else open();
    });

    trigger.addEventListener('blur', function () {
      // Real blur so any existing 'blur'-driven validation on the select keeps working.
      select.dispatchEvent(new Event('blur', { bubbles: true }));
      close();
    });

    trigger.addEventListener('keydown', function (e) {
      switch (e.key) {
        case 'ArrowDown':
          e.preventDefault();
          if (!isOpen()) open(); else moveActive(1);
          break;
        case 'ArrowUp':
          e.preventDefault();
          if (!isOpen()) open(); else moveActive(-1);
          break;
        case 'Home':
          if (isOpen()) { e.preventDefault(); setActive(selectableIndexes()[0]); }
          break;
        case 'End':
          if (isOpen()) { e.preventDefault(); var idxs = selectableIndexes(); setActive(idxs[idxs.length - 1]); }
          break;
        case 'Enter':
        case ' ':
          e.preventDefault();
          if (isOpen()) commit(activeIndex); else open();
          break;
        case 'Escape':
          if (isOpen()) { e.preventDefault(); close(); }
          break;
        case 'Tab':
          close();
          break;
        default:
          if (e.key.length === 1 && /\S/.test(e.key)) typeaheadJump(e.key);
      }
    });

    // Prevent the trigger from blurring on mousedown - without this, focus would shift away
    // from the trigger before the subsequent click fires, and the trigger's blur handler closes
    // the listbox first, so the option's click event lands on an already-hidden list (the option
    // never gets selected). This is the standard fix for that well-known custom-dropdown race.
    listbox.addEventListener('mousedown', function (e) { e.preventDefault(); });

    listbox.addEventListener('click', function (e) {
      var li = e.target.closest ? e.target.closest('.custom-select__option') : null;
      if (!li) return;
      var index = options.findIndex(function (o) { return o.li === li; });
      if (index > -1) commit(index);
    });

    // Keep the highlighted option visually in sync on hover, without moving focus.
    listbox.addEventListener('mousemove', function (e) {
      var li = e.target.closest ? e.target.closest('.custom-select__option') : null;
      if (!li) return;
      var index = options.findIndex(function (o) { return o.li === li; });
      if (index > -1 && !options[index].disabled && index !== activeIndex) setActive(index);
    });
  }

  function closeOnOutside(e) {
    if (!current) return;
    var openWrap = document.querySelector('.custom-select.is-open');
    if (openWrap && !openWrap.contains(e.target)) closeCurrent();
  }

  function closeOnScroll(e) {
    if (!current) return;
    var openWrap = document.querySelector('.custom-select.is-open');
    if (openWrap && e.target !== document && !openWrap.contains(e.target)) closeCurrent();
  }

  document.addEventListener('click', closeOnOutside);
  document.addEventListener('scroll', closeOnScroll, true);
  window.addEventListener('resize', closeCurrent);

  document.querySelectorAll('select[data-custom-select]').forEach(enhance);
})();

// Contact page: message character counter, FAQ accordion, and form validation.
//
// Validation runs the same way locally and on the real store: real-time, per-field errors shown
// right under the field, on blur and on submit, with focus sent to the first invalid field. HTML5
// `required`/`type=email` stay in the markup as a no-JS fallback (novalidate is only added here,
// once JS is confirmed running) and the real store additionally shows Shopify's own server-side
// error for a field (e.g. a spam check) if the page reloads with one — see contact-page.liquid.
//
// On a valid submit: locally (no backend) this fakes a short delay then shows success, since there
// is nothing to actually send it to. On the real store, once the fields check out, this gets out of
// the way and lets the real {% form 'contact' %} submit natively — Shopify's own hCaptcha and mail
// delivery are untouched by any of this.
(function () {
  'use strict';

  var page = document.querySelector('.contact-page');
  if (!page) return;

  var mockEl = document.querySelector('[data-cart-mock]'); // same local/store signal the cart uses

  // ---- message character counter -----------------------------------------------------------
  var message = page.querySelector('#contact-message');
  var counter = page.querySelector('[data-contact-counter]');
  if (message && counter) {
    var updateCount = function () { counter.textContent = message.value.length + '/' + (message.maxLength || 500); };
    message.addEventListener('input', updateCount);
    updateCount();
  }

  // ---- FAQ accordion -------------------------------------------------------------------------
  var faqItems = page.querySelectorAll('.contact-faq__item');
  faqItems.forEach(function (item) {
    var toggle = item.querySelector('.contact-faq__toggle');
    var panel = item.querySelector('.contact-faq__panel');
    if (!toggle || !panel) return;
    toggle.addEventListener('click', function () {
      var open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      item.classList.toggle('is-open', !open);
    });
  });

  // ---- form validation -----------------------------------------------------------------------
  var form = page.querySelector('.contact-form');
  if (!form) return;
  form.noValidate = true; // from here on JS owns the messaging; native validation was the no-JS fallback

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var fieldEls = {
    name: form.querySelector('#contact-name'),
    email: form.querySelector('#contact-email'),
    phone: form.querySelector('#contact-phone'),
    subject: form.querySelector('#contact-subject'),
    message: form.querySelector('#contact-message'),
  };
  var order = ['name', 'email', 'phone', 'subject', 'message'];
  var generalError = form.querySelector('[data-contact-general-error]');

  function wrapOf(name) { return form.querySelector('[data-field="' + name + '"]'); }
  function errorEl(name) { var w = wrapOf(name); return w && w.querySelector('.contact-field__error'); }

  function showError(name, msg) {
    var err = errorEl(name);
    var input = fieldEls[name];
    var wrap = wrapOf(name);
    if (err) { err.textContent = msg; err.hidden = false; }
    if (input) input.setAttribute('aria-invalid', 'true');
    if (wrap) wrap.classList.add('has-error');
  }
  function clearError(name) {
    var err = errorEl(name);
    var input = fieldEls[name];
    var wrap = wrapOf(name);
    if (err) { err.textContent = ''; err.hidden = true; }
    if (input) input.removeAttribute('aria-invalid');
    if (wrap) wrap.classList.remove('has-error');
  }

  // Returns true if the field is valid. Blank optional fields (phone) are always valid.
  function validateField(name) {
    var input = fieldEls[name];
    if (!input) return true;
    var val = (input.value || '').trim();

    if (name === 'name' && !val) { showError('name', 'Please enter your name.'); return false; }

    if (name === 'email') {
      if (!val) { showError('email', 'Please enter your email address.'); return false; }
      if (!EMAIL_RE.test(val)) { showError('email', 'Please enter a valid email address.'); return false; }
    }

    if (name === 'phone' && val) {
      var digits = val.replace(/\D/g, '');
      if (digits.length !== 10) { showError('phone', 'Please enter a valid 10-digit phone number.'); return false; }
    }

    if (name === 'subject' && !val) { showError('subject', 'Please select a subject.'); return false; }

    if (name === 'message') {
      if (!val) { showError('message', 'Please enter your message.'); return false; }
      if (val.length < 10) { showError('message', 'Please tell us a little more (at least 10 characters).'); return false; }
    }

    clearError(name);
    return true;
  }

  // Clear a field's error the moment it's corrected, rather than making someone resubmit to see it go.
  order.forEach(function (name) {
    var input = fieldEls[name];
    if (!input) return;
    var liveEvent = input.tagName === 'SELECT' ? 'change' : 'input';
    input.addEventListener(liveEvent, function () {
      if (wrapOf(name).classList.contains('has-error')) validateField(name);
    });
    input.addEventListener('blur', function () { validateField(name); });
  });

  form.addEventListener('submit', function (e) {
    var firstInvalid = null;
    order.forEach(function (name) {
      var ok = validateField(name);
      if (!ok && !firstInvalid) firstInvalid = fieldEls[name];
    });

    if (firstInvalid) {
      e.preventDefault();
      if (generalError) {
        generalError.textContent = 'Please fix the highlighted field' + (order.filter(function (n) { return wrapOf(n).classList.contains('has-error'); }).length > 1 ? 's' : '') + ' and try again.';
        generalError.hidden = false;
      }
      (firstInvalid.customSelectTrigger || firstInvalid).focus();
      return;
    }

    if (generalError) generalError.hidden = true;

    if (mockEl) {
      // Nothing to actually send it to locally — fake a short delay, then show success.
      e.preventDefault();
      var success = form.querySelector('[data-contact-success]');
      var btn = form.querySelector('.contact-submit');
      if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
      setTimeout(function () {
        if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); }
        form.reset();
        if (message && counter) counter.textContent = '0/500';
        order.forEach(clearError);
        if (success) success.hidden = false;
      }, 500);
    }
    // On the real store: fields are valid, so just let the native submit continue to Shopify.
  });
})();

// Newsletter signup - the footer's "Stay in the Loop" form (every page) and the Journal listing
// page's own "Stories worth bringing home" form both use this, via the shared .newsletter-form/
// .newsletter-field/.newsletter-field__error classes - one script handles both, rather than each
// having its own near-identical copy of the same validation.
//
// Validation itself mirrors contact-page.js exactly: real-time, per-field error shown right under the
// input, on blur and on submit. The real store's {% form 'customer' %} (see sections/footer.liquid,
// sections/main-blog.liquid) is what actually creates/updates the subscriber - Shopify sets
// accepts_marketing itself from that form, nothing here touches that part. This only owns the
// messaging around it, plus the "subscribed" toast.
(function () {
  'use strict';

  var mockEl = document.querySelector('[data-cart-mock]'); // same local/store signal the cart & contact page use
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var PENDING_KEY = 'hm-newsletter-pending';

  // Shopify's {% form 'customer' %} doesn't redirect-after-post - it re-renders this same page
  // directly as the POST response, with posted_successfully? baked into that one response. Hitting
  // refresh re-requests (or the browser re-serves) that exact response, so the success signal below
  // can still be sitting right there in the HTML on a plain reload, long after the actual submit -
  // "page just reloaded" and "I just subscribed" otherwise look identical from the signal alone.
  // sessionStorage is the fix: set right before a real submit leaves the page, read (and immediately
  // cleared) on load. Only a load that follows an actual submit from *this tab* has it set, so a
  // later plain refresh - which sets nothing new - correctly shows nothing. Wrapped in try/catch, same
  // as wishlist.js's own storage handling - if storage is blocked, this just falls back to the old
  // signal-only behaviour (the refresh-replay bug) rather than losing the toast on a real subscribe too.
  function markPending() {
    try { sessionStorage.setItem(PENDING_KEY, '1'); } catch (err) { /* ignore - see above */ }
  }
  function consumePending() {
    try {
      var was = sessionStorage.getItem(PENDING_KEY) === '1';
      sessionStorage.removeItem(PENDING_KEY);
      return was;
    } catch (err) {
      return true; // storage unavailable - can't correlate, so don't suppress a real subscribe's toast
    }
  }

  // ---- toast --------------------------------------------------------------------------------
  var toastTimer = 0;
  function showToast(message) {
    var toast = document.querySelector('[data-newsletter-toast]');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'newsletter-toast';
      toast.setAttribute('data-newsletter-toast', '');
      toast.setAttribute('role', 'status');
      toast.hidden = true;
      document.body.appendChild(toast);
    }
    clearTimeout(toastTimer);
    toast.textContent = message;
    toast.hidden = false;
    // Same two-step reason as every other toggle+transition in this theme (cart-drawer.js, search-
    // overlay.js, …) - flipping hidden and adding the class in the same frame means the browser never
    // paints the "before" state, so there's nothing for the transition to animate from.
    requestAnimationFrame(function () { toast.classList.add('is-visible'); });
    toastTimer = setTimeout(function () {
      toast.classList.remove('is-visible');
      setTimeout(function () { toast.hidden = true; }, 450);
    }, 4000);
  }

  // ---- one form instance ----------------------------------------------------------------------
  function wireForm(form) {
    form.noValidate = true; // JS owns the messaging from here; required/type=email stay as the no-JS fallback

    var field = form.querySelector('[data-field="email"]');
    var input = field && field.querySelector('input[type="email"]');
    var error = form.querySelector('.newsletter-field__error');
    if (!field || !input || !error) return;

    function showError(msg) {
      error.textContent = msg;
      error.hidden = false;
      field.classList.add('has-error');
      input.setAttribute('aria-invalid', 'true');
    }
    function clearError() {
      error.textContent = '';
      error.hidden = true;
      field.classList.remove('has-error');
      input.removeAttribute('aria-invalid');
    }
    function validate() {
      var val = (input.value || '').trim();
      if (!val) { showError('Please enter your email address.'); return false; }
      if (!EMAIL_RE.test(val)) { showError('Please enter a valid email address.'); return false; }
      clearError();
      return true;
    }

    // Clear the error the moment it's fixed, rather than making someone resubmit to see it go.
    input.addEventListener('input', function () { if (field.classList.contains('has-error')) validate(); });
    input.addEventListener('blur', validate);

    var submitBtn = form.querySelector('button[type="submit"]');

    form.addEventListener('submit', function (e) {
      if (!validate()) { e.preventDefault(); input.focus(); return; }

      // Guards against a double-click firing this twice - on the real store that would otherwise be
      // two full-page POSTs racing each other; locally it's harmless either way (synchronous, nothing
      // to race), but disabling here too keeps the one code path consistent rather than only doing
      // this for one of the two cases.
      if (submitBtn) submitBtn.disabled = true;

      if (mockEl) {
        // Local prototype - no backend to actually post to. Fake the same outcome a real successful
        // {% form 'customer' %} round-trip would leave the page in: toast, cleared field.
        e.preventDefault();
        showToast('Thanks for subscribing!');
        form.reset();
        clearError();
        if (submitBtn) submitBtn.disabled = false;
      } else {
        // Real store: about to actually leave the page on a genuine submit - mark it so the success
        // signal is trusted exactly once, when the response to *this* submit comes back.
        markPending();
      }
      // Field is valid, so get out of the way and let the native submit continue - Shopify's own
      // customer-creation and accepts_marketing handling are untouched by any of this. The disabled
      // button stays disabled - the page is about to navigate away regardless, and a fresh reload
      // resets it either way (success or back to this same, re-enabled, form).
    });
  }

  document.querySelectorAll('.newsletter-form').forEach(wireForm);

  // ---- success toast after a real submit (full-page reload, see sections/footer.liquid /
  // sections/main-blog.liquid) - querySelector (not querySelectorAll) deliberately: if more than one
  // newsletter-form happens to report posted_successfully? on the same reload (Shopify doesn't
  // distinguish same-type forms on one page from each other), this still only shows the toast once,
  // which is correct either way - whichever form triggered it, the same subscription just happened.
  var signal = document.querySelector('[data-newsletter-success-signal]');
  if (signal && signal.textContent && consumePending()) {
    showToast(signal.textContent);
  }
  if (signal) {
    // Removed regardless of whether the toast fired - if this exact page gets restored from the
    // browser's back/forward cache (bfcache) rather than freshly reloaded, whatever the DOM looked
    // like at the moment it was cached is what comes back verbatim. Removing the signal now means
    // that cached snapshot no longer has anything left to even consider re-triggering from.
    signal.parentNode.removeChild(signal);
  }
})();

// Journal article comment form: real-time, per-field validation matching the Contact page's own
// form exactly - same architecture, same conventions, just three fields (name/email/comment).
//
// Validation is real-time: on blur and on submit, with focus sent to the first invalid field and
// errors cleared live as they're fixed. HTML5 required/type=email stay in the markup as a no-JS
// fallback (novalidate is only added here, once JS is confirmed running).
//
// Unlike the Contact form, there's no local-mock path here - a blog article only exists on the
// real store, so a valid submit always just lets Shopify's own {% form 'new_comment' %} go through
// natively (hCaptcha, moderation queue, etc. are all untouched by any of this).
//
// Because this is a full-page form (no JS interception of a valid submit), the page can also
// reload with a *server-side* error already rendered (see main-article.liquid: the field error
// spans and the general error paragraph are populated from `form.errors` before this script ever
// runs). On load, this syncs that server-rendered state into the same has-error/aria-invalid
// styling a client-side failure would produce, and scrolls/focuses the first invalid field so a
// full-page reload doesn't leave someone hunting for what went wrong.
(function () {
  'use strict';

  var form = document.querySelector('.journal-comment-form__form');
  if (!form) return;
  form.noValidate = true; // from here on JS owns the messaging; native validation was the no-JS fallback

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var fieldEls = {
    author: form.querySelector('#CommentAuthor'),
    email: form.querySelector('#CommentEmail'),
    body: form.querySelector('#CommentBody'),
  };
  var order = ['author', 'email', 'body'];
  var generalError = form.querySelector('[data-comment-general-error]');

  function wrapOf(name) { return form.querySelector('[data-field="' + name + '"]'); }
  function errorEl(name) { var w = wrapOf(name); return w && w.querySelector('.journal-comment-form__error'); }

  function showError(name, msg) {
    var err = errorEl(name);
    var input = fieldEls[name];
    var wrap = wrapOf(name);
    if (err) { err.textContent = msg; err.hidden = false; }
    if (input) input.setAttribute('aria-invalid', 'true');
    if (wrap) wrap.classList.add('has-error');
  }
  function clearError(name) {
    var err = errorEl(name);
    var input = fieldEls[name];
    var wrap = wrapOf(name);
    if (err) { err.textContent = ''; err.hidden = true; }
    if (input) input.removeAttribute('aria-invalid');
    if (wrap) wrap.classList.remove('has-error');
  }

  function validateField(name) {
    var input = fieldEls[name];
    if (!input) return true;
    var val = (input.value || '').trim();

    if (name === 'author' && !val) { showError('author', 'Please enter your name.'); return false; }

    if (name === 'email') {
      if (!val) { showError('email', 'Please enter your email address.'); return false; }
      if (!EMAIL_RE.test(val)) { showError('email', 'Please enter a valid email address.'); return false; }
    }

    if (name === 'body') {
      if (!val) { showError('body', 'Please write a comment.'); return false; }
      if (val.length < 3) { showError('body', 'Please write a little more.'); return false; }
    }

    clearError(name);
    return true;
  }

  // Clear a field's error the moment it's corrected, rather than making someone resubmit to see it go.
  order.forEach(function (name) {
    var input = fieldEls[name];
    if (!input) return;
    input.addEventListener('input', function () {
      if (wrapOf(name).classList.contains('has-error')) validateField(name);
    });
    input.addEventListener('blur', function () { validateField(name); });
  });

  form.addEventListener('submit', function (e) {
    var firstInvalid = null;
    order.forEach(function (name) {
      var ok = validateField(name);
      if (!ok && !firstInvalid) firstInvalid = fieldEls[name];
    });

    if (firstInvalid) {
      e.preventDefault();
      if (generalError) {
        var invalidCount = order.filter(function (n) { return wrapOf(n).classList.contains('has-error'); }).length;
        generalError.textContent = 'Please fix the highlighted field' + (invalidCount > 1 ? 's' : '') + ' and try again.';
        generalError.hidden = false;
      }
      firstInvalid.focus();
      return;
    }

    if (generalError) generalError.hidden = true;
    // Fields are valid - let the native submit continue to Shopify (hCaptcha, moderation, etc).
  });

  // Sync any server-rendered error (a full-page reload after Shopify itself rejected the
  // submission) into the same has-error styling, and bring it into view - otherwise a reload
  // could land with an error sitting below the fold, easy to miss entirely. Two distinct error
  // surfaces to check: the per-field spans above, and Shopify's own catch-all paragraph (e.g. an
  // hCaptcha rejection isn't tied to any one field, see main-article.liquid's `default_errors`).
  var serverGeneralError = form.querySelector('.form-errors');
  var serverInvalid = null;
  order.forEach(function (name) {
    var err = errorEl(name);
    if (err && !err.hidden && err.textContent.trim()) {
      wrapOf(name).classList.add('has-error');
      fieldEls[name].setAttribute('aria-invalid', 'true');
      if (!serverInvalid) serverInvalid = fieldEls[name];
    }
  });
  if (serverInvalid) {
    serverInvalid.scrollIntoView({ block: 'center' });
    serverInvalid.focus();
  } else if (serverGeneralError) {
    serverGeneralError.scrollIntoView({ block: 'center' });
  } else {
    var success = form.querySelector('[data-comment-success]');
    if (success) success.scrollIntoView({ block: 'center' });
  }
})();

// Custom video player modal — used by the Our Story "journey" section.
//
// Built from scratch instead of native <video controls> because native controls render completely
// differently across Chrome/Firefox/Safari/Edge (and iOS forces its own chrome), which is exactly
// what we don't want. Everything here — seek bar, play/pause, volume, fullscreen — is our own UI
// driven by the video element's real state, so it looks and behaves the same everywhere.
//
// Deliberately separate from lightbox.js (that one is a pan/zoom *image* viewer). Reuses the same
// scroll-lock convention (`hm-lb-lock` on <html>, `inert` on background siblings).
(function () {
  'use strict';

  var triggers = document.querySelectorAll('[data-video-trigger]');
  if (!triggers.length) return;

  var reduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var isCoarsePointer = window.matchMedia ? window.matchMedia('(pointer: coarse)').matches : false;

  var ICON = {
    play: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M19.2659 13.5161C19.4974 13.337 19.6848 13.1072 19.8137 12.8444C19.9426 12.5816 20.0096 12.2928 20.0096 12.0001C20.0096 11.7074 19.9426 11.4186 19.8137 11.1558C19.6848 10.893 19.4974 10.6633 19.2659 10.4841C16.2681 8.16528 12.9211 6.33718 9.34993 5.06811L8.69693 4.83611C7.44893 4.39311 6.12993 5.23711 5.96093 6.52611C5.48893 10.1602 5.48893 13.84 5.96093 17.4741C6.13093 18.7631 7.44893 19.6071 8.69693 19.1641L9.34993 18.9321C12.9211 17.663 16.2681 15.8349 19.2659 13.5161Z"/></svg>',
    pause: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M17.276 5.46991C17.711 5.62991 18 6.04491 18 6.50891V17.4899C18 17.9539 17.71 18.3689 17.276 18.5289C16.4523 18.8316 15.5477 18.8316 14.724 18.5289C14.5119 18.4503 14.329 18.3087 14.1996 18.1232C14.0702 17.9377 14.0006 17.7171 14 17.4909V6.50991C14 6.04591 14.29 5.63091 14.724 5.46991C15.5477 5.16726 16.4523 5.16726 17.276 5.46991ZM9.276 5.46991C9.711 5.62991 10 6.04491 10 6.50891V17.4899C10 17.9539 9.71 18.3689 9.276 18.5289C8.45225 18.8316 7.54775 18.8316 6.724 18.5289C6.51194 18.4503 6.32897 18.3087 6.19958 18.1232C6.07019 17.9377 6.00056 17.7171 6 17.4909V6.50991C6 6.04591 6.29 5.63091 6.724 5.46991C7.54775 5.16726 8.45225 5.16726 9.276 5.46991Z"/></svg>',
    volumeHigh: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M4 9v6h4l5 4V5L8 9H4Z"/><path d="M16.5 9a4.5 4.5 0 0 1 0 6"/><path d="M19 6.5a8 8 0 0 1 0 11"/></svg>',
    volumeLow: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M4 9v6h4l5 4V5L8 9H4Z"/><path d="M16.5 9a4.5 4.5 0 0 1 0 6"/></svg>',
    muted: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M4 9v6h4l5 4V5L8 9H4Z"/><path d="M16 9l5 6M21 9l-5 6"/></svg>',
    // Design's own maximize.svg / minimize.svg (Design/icons/) - currentColor in place of their
    // pasted black fill/stroke so they inherit the player's own (light-on-dark) colour like every
    // other icon here, otherwise a literal black glyph would be near-invisible on this dark button.
    fsEnter: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 3H6C4.34315 3 3 4.34315 3 6V9M15 3H18C19.6568 3 21 4.34315 21 6V9M21 15V18C21 19.6568 19.6568 21 18 21H15M3 15V18C3 19.6568 4.34315 21 6 21H9"/></svg>',
    fsExit: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 3V6C9 7.65685 7.65685 9 6 9H3M15 3V6C15 7.65685 16.3432 9 18 9H21M21 15H18C16.3432 15 15 16.3432 15 18V21M3 15H6C7.65685 15 9 16.3432 9 18V21"/></svg>',
    close: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    retry: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M4 4v6h6M20 20v-6h-6"/><path d="M5.5 15a8 8 0 0 0 13.9 2.5M18.5 9A8 8 0 0 0 4.6 6.5"/></svg>',
  };

  var root, stage, player, video, bigBtn, playBtn, muteBtn, fsBtn, closeBtn;
  var zoomToast, zoomToastTimer;
  var progress, progressPlayed, progressBuffered, progressHandle, progressTooltip, curTimeEl, durTimeEl;
  var volumeWrap, volumeTrack, volumeFill, volumeHandle;
  var spinner, errorBox, retryBtn;
  var opener = null;
  var hideTimer = null;
  var scrubbing = false;
  var wasPlayingBeforeScrub = false;
  var volumeDragging = false;
  var currentSrc = '';
  var currentFallback = '';
  var currentHlsLib = '';
  var hasEverPlayed = false;
  var volumeControllable = true; // iOS ignores video.volume entirely — detected once the element exists

  function fmt(t) {
    if (!isFinite(t) || t < 0) t = 0;
    var h = Math.floor(t / 3600), m = Math.floor((t % 3600) / 60), s = Math.floor(t % 60);
    var mm = h ? String(m).padStart(2, '0') : String(m);
    var ss = String(s).padStart(2, '0');
    return h ? h + ':' + mm + ':' + ss : mm + ':' + ss;
  }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }

  // ---- build (once) ----------------------------------------------------------------------
  function build() {
    if (root) return;
    root = document.createElement('div');
    root.className = 'hm-video-modal';
    root.hidden = true;
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-modal', 'true');
    root.setAttribute('aria-label', 'Video player');
    root.innerHTML =
      '<div class="hm-video-modal__backdrop"></div>' +
      '<div class="hm-video-modal__stage">' +
      '  <div class="hm-player" data-state="loading">' +
      '    <video class="hm-player__video" playsinline webkit-playsinline preload="metadata" x-webkit-airplay="allow"></video>' +
      '    <button type="button" class="hm-player__bigbtn" aria-label="Play">' + ICON.play + '</button>' +
      '    <div class="hm-player__zoomtoast" aria-hidden="true"></div>' +
      '    <div class="hm-player__spinner" aria-hidden="true"></div>' +
      '    <div class="hm-player__error" hidden>' +
      '      <p>This video couldn’t be played.</p>' +
      '      <button type="button" class="hm-player__retry">' + ICON.retry + ' Try again</button>' +
      '    </div>' +
      '    <div class="hm-player__controls">' +
      '      <div class="hm-player__progress" role="slider" tabindex="0" aria-label="Seek" aria-valuemin="0" aria-valuemax="100" aria-valuenow="0">' +
      '        <div class="hm-player__progress-track">' +
      '          <div class="hm-player__progress-buffered"></div>' +
      '          <div class="hm-player__progress-played"></div>' +
      '        </div>' +
      '        <div class="hm-player__progress-handle"></div>' +
      '        <div class="hm-player__progress-tooltip" hidden>0:00</div>' +
      '      </div>' +
      '      <div class="hm-player__row">' +
      '        <button type="button" class="hm-player__btn hm-player__play" aria-label="Play">' + ICON.play + '</button>' +
      '        <div class="hm-player__volume">' +
      '          <button type="button" class="hm-player__btn hm-player__mute" aria-label="Mute">' + ICON.volumeHigh + '</button>' +
      '          <div class="hm-player__volume-slider" role="slider" tabindex="0" aria-label="Volume" aria-valuemin="0" aria-valuemax="100" aria-valuenow="100">' +
      '            <div class="hm-player__volume-track">' +
      '              <div class="hm-player__volume-fill"></div>' +
      '              <div class="hm-player__volume-handle"></div>' +
      '            </div>' +
      '          </div>' +
      '        </div>' +
      '        <span class="hm-player__time"><span class="hm-player__time-cur">0:00</span> <span aria-hidden="true">/</span> <span class="hm-player__time-dur">0:00</span></span>' +
      '        <span class="hm-player__spacer"></span>' +
      '        <button type="button" class="hm-player__btn hm-player__fs" aria-label="Fullscreen">' + ICON.fsEnter + '</button>' +
      '      </div>' +
      '    </div>' +
      '  </div>' +
      '</div>' +
      '<button type="button" class="hm-video-modal__close" aria-label="Close video">' + ICON.close + '</button>';
    document.body.appendChild(root);

    stage = root.querySelector('.hm-video-modal__stage');
    player = root.querySelector('.hm-player');
    video = root.querySelector('.hm-player__video');
    bigBtn = root.querySelector('.hm-player__bigbtn');
    zoomToast = root.querySelector('.hm-player__zoomtoast');
    spinner = root.querySelector('.hm-player__spinner');
    errorBox = root.querySelector('.hm-player__error');
    retryBtn = root.querySelector('.hm-player__retry');
    progress = root.querySelector('.hm-player__progress');
    progressPlayed = root.querySelector('.hm-player__progress-played');
    progressBuffered = root.querySelector('.hm-player__progress-buffered');
    progressHandle = root.querySelector('.hm-player__progress-handle');
    progressTooltip = root.querySelector('.hm-player__progress-tooltip');
    playBtn = root.querySelector('.hm-player__play');
    volumeWrap = root.querySelector('.hm-player__volume');
    muteBtn = root.querySelector('.hm-player__mute');
    var volumeSlider = root.querySelector('.hm-player__volume-slider');
    volumeTrack = root.querySelector('.hm-player__volume-track');
    volumeFill = root.querySelector('.hm-player__volume-fill');
    volumeHandle = root.querySelector('.hm-player__volume-handle');
    fsBtn = root.querySelector('.hm-player__fs');
    closeBtn = root.querySelector('.hm-video-modal__close');
    curTimeEl = root.querySelector('.hm-player__time-cur');
    durTimeEl = root.querySelector('.hm-player__time-dur');

    // iOS refuses to let JS control volume (only the hardware buttons can) — detect it once and hide
    // the slider entirely rather than show a control that visibly does nothing when dragged.
    var original = video.volume;
    var probeTarget = original === 0.5 ? 0.6 : 0.5;
    video.volume = probeTarget;
    volumeControllable = Math.abs(video.volume - probeTarget) < 0.01;
    video.volume = original;
    if (!volumeControllable) volumeWrap.classList.add('is-uncontrollable');

    closeBtn.addEventListener('click', close);
    root.querySelector('.hm-video-modal__backdrop').addEventListener('click', close);
    retryBtn.addEventListener('click', function () { loadAndPlay(currentSrc, currentFallback, currentHlsLib); });

    bigBtn.addEventListener('click', function () {
      if (suppressNextBigBtnClick) { suppressNextBigBtnClick = false; return; }
      togglePlay();
    });
    bigBtn.addEventListener('animationend', function () {
      bigBtn.classList.remove('is-pulsing');
      // Safety-net re-sync, for the rare case the state kept changing during the 0.65s flash (a fast
      // double-tap, or the video stalling/erroring mid-pulse) - pulseBigBtn already set the right icon
      // up front now, so in the ordinary case setBigBtnIcon below is already a no-op (see its own
      // comment for why that specifically matters here, right as this fires). Opacity's own equivalent
      // of this same "ends up fine, just not literally changing" settling is the transition on the
      // base .hm-player__bigbtn rule, paired with keeping opacity out of the pulse's own keyframes
      // entirely (see @keyframes hm-bigbtn-pulse) - between the two, nothing about this button's
      // *content* needs to touch the DOM, nor does its *visibility* need to visibly move, on the
      // overwhelmingly common path where nothing about the state actually changed during the flash.
      setBigBtnIcon(!(video.paused || video.ended));
    });
    playBtn.addEventListener('click', togglePlay);
    muteBtn.addEventListener('click', function () { video.muted = !video.muted; if (!video.muted && video.volume === 0) video.volume = 1; });
    fsBtn.addEventListener('click', toggleFullscreen);

    // ---- video element events ------------------------------------------------------------
    video.addEventListener('loadedmetadata', function () {
      durTimeEl.textContent = fmt(video.duration);
      progress.setAttribute('aria-valuemax', Math.round(video.duration));
      player.dataset.state = 'ready';
    });
    video.addEventListener('canplay', function () { player.dataset.state = 'ready'; });
    // The native `waiting` event fires both for the very first load *and* for a stall mid-playback —
    // the browser makes no distinction. But the two need different UI: before the first frame has ever
    // rendered, nothing (seek bar, pause, timer, fullscreen) is meaningful yet, only the spinner; once
    // playback has genuinely started at least once, a later stall should keep those controls up so the
    // person can still pause or seek away while it buffers, same as YouTube/Vimeo/Netflix all do.
    video.addEventListener('waiting', function () { player.dataset.state = hasEverPlayed ? 'buffering' : 'loading'; });
    video.addEventListener('playing', function () { hasEverPlayed = true; player.dataset.state = 'ready'; });
    video.addEventListener('error', function () { player.dataset.state = 'error'; });

    video.addEventListener('play', function () {
      player.classList.add('is-playing');
      updatePlayIcons(true);
      showControls();
      if (stopWatchdog) stopWatchdog();
      stopWatchdog = startFrameWatchdog();
      if ('mediaSession' in navigator) navigator.mediaSession.playbackState = 'playing';
    });
    video.addEventListener('pause', function () {
      player.classList.remove('is-playing');
      updatePlayIcons(false);
      showControls();
      if (stopWatchdog) { stopWatchdog(); stopWatchdog = null; }
      if ('mediaSession' in navigator) navigator.mediaSession.playbackState = 'paused';
    });
    video.addEventListener('ended', function () {
      player.classList.remove('is-playing');
      updatePlayIcons(false);
      player.dataset.state = 'ended';
      showControls();
      if (stopWatchdog) { stopWatchdog(); stopWatchdog = null; }
      if ('mediaSession' in navigator) navigator.mediaSession.playbackState = 'none';
    });
    video.addEventListener('volumechange', function () {
      var isMuted = video.muted || video.volume === 0;
      muteBtn.innerHTML = isMuted ? ICON.muted : (video.volume < 0.5 ? ICON.volumeLow : ICON.volumeHigh);
      muteBtn.setAttribute('aria-label', isMuted ? 'Unmute' : 'Mute');
      // Unlike the seek bar, volume has no "committed vs. live preview" distinction — every value
      // during a drag *is* the real value immediately, so (unlike renderTime during a scrub) this
      // must never skip updating while dragging, or the fill/handle just sit frozen mid-drag.
      renderVolume();
    });
    video.addEventListener('timeupdate', function () { if (!scrubbing) renderTime(video.currentTime); });
    video.addEventListener('progress', updateBuffered);

    wireProgressBar();
    wireVolumeSlider(volumeSlider);
    wirePinchToFill();

    // ---- auto-hide controls during playback -----------------------------------------------
    // On touch, the very tap that first reveals the controls also reveals the centre play/pause
    // button (see .controls-visible in our-story.css) sitting right under a thumb that tapped
    // anywhere near the middle of the screen - without this guard, the browser's own click synthesized
    // from that same tap can land on the button the instant it becomes interactive, pausing a video
    // someone only meant to glance at the controls of. suppressNextBigBtnClick (consumed the moment
    // the very next click fires, with a short timeout as a backstop in case no click follows at all,
    // e.g. the touch turned into a drag instead) makes that one specific click a no-op, the same way
    // YouTube's own mobile player treats "reveal" and "press" as two separate gestures, never one.
    var suppressNextBigBtnClick = false;
    var suppressBigBtnTimer = null;
    // Captured at the *start* of a touch, before showControls() below has a chance to change it - by
    // the time video's own click handler further down runs, showControls() has already fired (so
    // root.classList itself can no longer tell the two cases apart), but this can still tell it
    // whether that tap's real intent was to reveal the controls (they were hidden) or to put them
    // away again (they were already up) - see the click handler for why that distinction matters.
    //
    // capturedThisGesture guards against a real gotcha: pointerdown *and* touchstart both fire for
    // one physical touch (not an either/or - browsers send both, for exactly this kind of broad
    // compatibility), so without it this ran twice per tap. The first run would reveal the controls,
    // then the second (now finding them already visible, because the first run had just shown them)
    // would overwrite controlsWereVisibleAtTapStart back to true right before the click handler ever
    // got to read it - every single reveal-tap misread itself as a hide-tap a moment later. Capturing
    // once per gesture (reset on release, below) instead of once per *event* fixes that at the root.
    var capturedThisGesture = false;
    var controlsWereVisibleAtTapStart = false;
    ['pointermove', 'pointerdown', 'touchstart'].forEach(function (evt) {
      stage.addEventListener(evt, function () {
        if ((evt === 'pointerdown' || evt === 'touchstart') && !capturedThisGesture) {
          capturedThisGesture = true;
          var wasHidden = !root.classList.contains('controls-visible');
          controlsWereVisibleAtTapStart = !wasHidden;
          if (wasHidden && isCoarsePointer) {
            suppressNextBigBtnClick = true;
            clearTimeout(suppressBigBtnTimer);
            suppressBigBtnTimer = setTimeout(function () { suppressNextBigBtnClick = false; }, 500);
          }
        }
        showControls();
      }, { passive: true });
    });
    ['pointerup', 'pointercancel', 'touchend'].forEach(function (evt) {
      stage.addEventListener(evt, function () { capturedThisGesture = false; }, { passive: true });
    });
    // Desktop: a tap on the video itself (not a control) toggles play — a mouse already has hover to
    // reveal the controls first, so there's no ambiguity about what a click on the video means.
    video.addEventListener('click', function () {
      if (!isCoarsePointer) { togglePlay(); return; }
      // Touch: the very first tap on a hidden-controls video is the *only* way to even see the
      // play/pause button, so treating that same tap as an instant toggle too meant a tap to reveal
      // controls doubled as a coin-flip pause, right as someone was trying to get a look at them -
      // that's still true here, which is exactly why this never calls togglePlay() directly. What's
      // new is the other direction: tapping the video again while its controls are *already* showing
      // (and nothing is about to auto-hide them on its own, i.e. paused never counts) now puts them
      // away immediately, the same "tap to reveal, tap again to dismiss" toggle YouTube's own mobile
      // player uses - scoped to the video element alone so it can never fire from tapping an actual
      // control (a button, the seek bar, the volume slider), only the video itself.
      if (controlsWereVisibleAtTapStart && !video.paused && !video.ended) {
        root.classList.remove('controls-visible');
        clearTimeout(hideTimer);
      }
    });
    // A double-click/double-tap toggles fullscreen — both common conventions. A dblclick is preceded
    // by two ordinary click events, so naively wiring both would toggle play twice AND fullscreen on
    // a double-click — but since togglePlay is a genuine toggle, those two clicks cancel each other
    // out on their own (net: no play-state change) on desktop, and touch never calls togglePlay from
    // a click at all (above), so there's nothing to cancel out there either. That also means a single
    // click stays instant on desktop — delaying every click to wait out a possible second one would
    // make normal clicking feel laggy for the (vastly more common) single-click case.
    video.addEventListener('dblclick', toggleFullscreen);

    // ---- back button closes the modal instead of leaving the page -------------------------
    // Fires both for the throwaway entry open() pushes (the back button/gesture case this exists
    // for) and for ordinary page-to-page back navigation elsewhere on the site - the root.hidden
    // check is what keeps this a no-op the rest of the time, same guard close() itself always starts
    // with. See the comments on history.pushState (in open()) and history.back() (in close()) for the
    // full back-and-forth between the two.
    window.addEventListener('popstate', function () {
      if (root && !root.hidden) close();
    });

    // ---- keyboard shortcuts, scoped to while the modal is open ----------------------------
    document.addEventListener('keydown', function (e) {
      if (root.hidden) return;
      if (e.key === 'Escape') { close(); return; }
      var tag = document.activeElement && document.activeElement.tagName;
      if (tag === 'INPUT' || tag === 'TEXTAREA') return;
      // A focused <button> (Close, Retry, the control-bar buttons…) should handle its own Space/Enter
      // activation natively — the global "Space = play/pause" shortcut only applies when focus is
      // elsewhere (the video/stage itself), otherwise tabbing to Close and pressing Space would
      // toggle playback instead of closing.
      if (e.key === ' ' && tag === 'BUTTON') return;
      if (e.key === ' ' || e.key === 'k' || e.key === 'K') { e.preventDefault(); togglePlay(); showControls(); }
      else if (e.key === 'm' || e.key === 'M') { video.muted = !video.muted; }
      else if (e.key === 'f' || e.key === 'F') { toggleFullscreen(); }
      else if (e.key === 'ArrowRight') { video.currentTime = clamp(video.currentTime + 5, 0, video.duration || 0); showControls(); }
      else if (e.key === 'ArrowLeft') { video.currentTime = clamp(video.currentTime - 5, 0, video.duration || 0); showControls(); }
    });

    // ---- fullscreen state sync (all vendor-prefixed events) -------------------------------
    // Orientation locking lives here rather than inside toggleFullscreen() itself, so it stays
    // correct no matter *how* fullscreen was entered or left - the button, the "f" keyboard shortcut,
    // the browser's own fullscreen-exit UI, the Escape key - this fires for all of them alike, since
    // it's reacting to the real resulting state rather than assuming its own call caused it. Only
    // Chromium-family browsers support screen.orientation.lock() at all (iOS Safari does not) - there,
    // entering fullscreen alone does not rotate the device, so this is the only thing that actually
    // turns the player sideways. iOS instead gets this for free from its own native fullscreen video
    // view (see the webkitEnterFullscreen() branch in toggleFullscreen() below), which rotates on its
    // own without any orientation API at all, so there's nothing to do for it here.
    ['fullscreenchange', 'webkitfullscreenchange'].forEach(function (evt) {
      document.addEventListener(evt, function () {
        var isFs = !!(document.fullscreenElement || document.webkitFullscreenElement);
        fsBtn.innerHTML = isFs ? ICON.fsExit : ICON.fsEnter;
        fsBtn.setAttribute('aria-label', isFs ? 'Exit fullscreen' : 'Fullscreen');
        if (screen.orientation && screen.orientation.lock) {
          if (isFs) {
            screen.orientation.lock('landscape').catch(function () {}); // not every device/browser allows this - fine either way
          } else if (screen.orientation.unlock) {
            try { screen.orientation.unlock(); } catch (err) {}
          }
        }
        if (!isFs) {
          player.classList.remove('is-filled'); // pinch-to-fill (see below) never carries over into the normal view
          zoomToast.classList.remove('is-visible'); // ...and nothing left over to "undo" once it's gone either
        }
      });
    });
    // iOS Safari's own fullscreen video player fires this on the <video> itself.
    video.addEventListener('webkitendfullscreen', function () { showControls(); });

    // Browsers throttle actual video *frame* decoding when a tab/window loses visibility, to save
    // power — but keep the audio track and the playback clock running normally. Coming back looks
    // exactly like "audio and the progress bar are fine, but the picture is frozen," because the last
    // frame decoded before visibility was lost is just still sitting there. This isn't specific to
    // switching browser tabs — switching away from and back to a macOS Space (or minimizing/restoring
    // the window) triggers the same visibility change. The fix is a tiny, imperceptible backward-then-
    // forward seek the instant visibility returns: it doesn't touch playback position in any way a
    // person would notice, but it forces the decoder to flush and render a genuinely fresh frame
    // instead of trusting the stale one still on screen. hls.js also gets nudged to resume loading,
    // since its own buffering can stall the same way while backgrounded. Cheap, and correct whenever
    // it does fire — but see the frame watchdog below for why it can't be the only mechanism here.
    document.addEventListener('visibilitychange', function () {
      if (document.hidden || root.hidden || video.paused || !video.duration) return;
      nudgeFrame();
    });
  }

  // Declares this as genuine, active media playback rather than "just another background tab" —
  // browsers use this same signal to decide how aggressively to throttle a page, on top of giving
  // real OS-level integration for free (play/pause/seek from the Mac media widget, lock screen,
  // keyboard media keys — this is also literally why YouTube gets those). Wired once per open(), since
  // the title can change between videos; action handlers are only meaningful while this video is the
  // one actually open, so they're set here too rather than once globally.
  var mediaSessionReady = false;
  function setupMediaSession() {
    if (!('mediaSession' in navigator)) return;
    if (window.MediaMetadata) {
      navigator.mediaSession.metadata = new MediaMetadata({ title: currentTitle || 'Video' });
    }
    if (mediaSessionReady) return;
    mediaSessionReady = true;
    navigator.mediaSession.setActionHandler('play', function () { video.play().catch(function () {}); });
    navigator.mediaSession.setActionHandler('pause', function () { video.pause(); });
    navigator.mediaSession.setActionHandler('seekbackward', function () { video.currentTime = Math.max(0, video.currentTime - 10); });
    navigator.mediaSession.setActionHandler('seekforward', function () { video.currentTime = Math.min(video.duration || 0, video.currentTime + 10); });
    navigator.mediaSession.setActionHandler('seekto', function (details) {
      if (details.seekTime != null) video.currentTime = details.seekTime;
    });
  }

  // Re-entrancy guard: without it, two nudges landing close together (the watchdog's own interval
  // firing, right as visibilitychange's explicit one also does - see both call sites) each capture
  // their *own* currentTime and queue their *own* pair of rAF callbacks to restore it. Those don't
  // cancel each other - they all genuinely run, each one jumping currentTime to whatever moment
  // *it* happened to capture, in whatever order they land. One nudge is an imperceptible blip; two
  // or more stacked is a visible stutter of the picture hopping between a couple of near-identical
  // timestamps for a beat before finally settling - exactly what a cascade of these looks like.
  var nudging = false;
  // Shared with the watchdog below (its own onFrame updates this too) rather than each tracking "when
  // was this last handled" separately - a nudge triggered from *either* place (visibilitychange firing
  // right on return, or the watchdog's own interval) counts as having just dealt with it either way, so
  // the other one doesn't also think it independently still needs to, right on top of it.
  var lastFrameSeenAt = performance.now();
  function nudgeFrame() {
    if (nudging) return;
    nudging = true;
    // rAF (which is what actually clears this below) does not run at all while the tab is hidden - if
    // a nudge somehow starts right as visibility is lost, this flag would otherwise stay stuck "true"
    // until the tab is foregrounded again, which would then wrongly block the one nudge that matters
    // most: visibilitychange's own, firing right at that exact moment. A short timeout backstop clears
    // it regardless, well past how long two ordinary (visible-tab) rAF ticks ever actually take.
    var backstop = setTimeout(function () { nudging = false; }, 500);
    if (hls) hls.startLoad();
    var t = video.currentTime;
    video.currentTime = Math.max(0, t - 0.08);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        video.currentTime = t;
        lastFrameSeenAt = performance.now();
        clearTimeout(backstop);
        nudging = false;
      });
    });
  }

  // The Page Visibility API (`visibilitychange`, above) only covers a tab being switched away from or
  // a window being minimized. Switching to a different macOS Space does not reliably fire it at all —
  // that's detected by a lower-level, OS-facing "is this window actually occluded on screen" check
  // that Chromium uses to throttle video decoding independently, with no corresponding DOM event. So
  // rather than continue trying to guess which specific event might correspond to "the picture could
  // be stale now", this watches for the *symptom itself*: requestVideoFrameCallback reports exactly
  // when a frame is actually presented, so if a couple of seconds pass with the video genuinely
  // playing (not paused, not seeking) and no new frame has been presented, that alone is reason
  // enough to nudge it — regardless of what caused it, tab switch, Space switch, minimized window, or
  // anything else not yet seen. Browsers without requestVideoFrameCallback (Firefox, at the time of
  // writing) simply don't get this specific watchdog; the visibilitychange nudge above still applies
  // to them wherever it does fire.
  function startFrameWatchdog() {
    if (!video.requestVideoFrameCallback) return;
    var watchdog = null;

    function onFrame() {
      lastFrameSeenAt = performance.now();
      if (!video.paused) video.requestVideoFrameCallback(onFrame);
    }
    video.requestVideoFrameCallback(onFrame);

    watchdog = setInterval(function () {
      if (video.paused || video.seeking || !video.duration) return;
      // document.hidden *does* miss the macOS-Space-switch case this watchdog exists for (see the
      // comment above) - but for the much more common case it doesn't miss (an actual backgrounded
      // tab, or a minimized window), rAF stops running entirely while hidden, so nudgeFrame()'s own
      // restore-the-frame step can't complete until the tab is foregrounded again. A still-hidden tab
      // staying "stale" past 2500ms would otherwise just keep tripping this same check every 2s for
      // as long as it stays hidden, each call starting (but, stuck behind paused rAF, not finishing)
      // its own nudge - several of those piling up and then all finally landing back to back the
      // moment the tab *is* foregrounded is what actually produced the reported stutter: several
      // competing seeks, each to a slightly different captured timestamp, racing to resolve at once
      // right as playback resumed. Skipping the check entirely while hidden leaves exactly one nudge
      // to do this job - the explicit, deliberate one visibilitychange fires on return (see above) -
      // and nothing queued up behind it to collide with.
      if (document.hidden) return;
      if (performance.now() - lastFrameSeenAt > 2500) nudgeFrame();
    }, 2000);

    return function stop() { clearInterval(watchdog); };
  }

  // The control-row play/pause button always shows "what clicking it does next" (the standard
  // toggle-button convention). The big centre button used to only ever be meaningfully *visible*
  // while paused/ended (a "resume" invitation, always a play triangle for that) - now that tapping
  // the video on touch also reveals it *while playing* (see .controls-visible in our-story.css, and
  // the tap-to-reveal wiring below), it needs to track real playback state too, the same as the
  // row's own button, so a thumb reaching for it mid-playback sees "pause" rather than a stale
  // "play" triangle sitting on a video that's already playing. The `is-pulsing` guard leaves the
  // brief click-confirmation flash (see pulseBigBtn) alone while it's actually mid-animation - that
  // one deliberately shows "what was just tapped", not current state, and settles back to this
  // same current-state icon on its own once the flash finishes (see the animationend handler below).
  function updatePlayIcons(isPlaying) {
    playBtn.innerHTML = isPlaying ? ICON.pause : ICON.play;
    playBtn.setAttribute('aria-label', isPlaying ? 'Pause' : 'Play');
    if (!bigBtn.classList.contains('is-pulsing')) setBigBtnIcon(isPlaying);
  }

  // Tracks which icon is logically showing (null until first set) so every call site below can skip
  // actually touching the DOM when nothing would change - comparing against bigBtn.innerHTML itself
  // instead would be unreliable (the string the browser hands back from reading it is a *serialized*
  // re-rendering of the markup, not necessarily identical byte-for-byte to the literal ICON.* string
  // that was assigned). A real write replaces the whole SVG subtree, which briefly flashed as an
  // actual re-render even when the icon was already correct - most visible right as the pulse
  // animation ends, since that's the one moment multiple of these call sites could plausibly fire
  // back to back for the same tap.
  var bigBtnShowsPlaying = null;
  function setBigBtnIcon(isPlaying) {
    if (bigBtnShowsPlaying === isPlaying) return;
    bigBtnShowsPlaying = isPlaying;
    bigBtn.innerHTML = isPlaying ? ICON.pause : ICON.play;
    bigBtn.setAttribute('aria-label', isPlaying ? 'Pause' : 'Play');
  }

  // YouTube-style feedback: a click pops the big centre icon in with a quick scale+fade flourish,
  // which then settles back down on its own — never tied to hover/cursor movement, and never
  // lingering. The icon itself shows the *correct, current* state immediately (paused → play icon,
  // playing → pause icon - same convention as updatePlayIcons above), not a delayed "what you just
  // tapped" flash - an earlier version deliberately showed the opposite-of-resting icon for the whole
  // 0.65s animation before correcting itself, which read as the button being slow/stuck on the wrong
  // icon for a beat (most noticeable pausing: a pause icon lingering for over half a second on a
  // video that had, in fact, already stopped). The animation (the pop+fade itself) still plays in
  // full either way; only the *content* shown during it needed to stop being delayed.
  function pulseBigBtn(isPlayingNow) {
    setBigBtnIcon(isPlayingNow);
    bigBtn.classList.remove('is-pulsing');
    void bigBtn.offsetWidth; // restart the animation even on rapid repeated clicks
    bigBtn.classList.add('is-pulsing');
  }

  // Visuals only — never touches video.currentTime. Used both by real playback (timeupdate) and by
  // a live scrub drag, which is exactly why seeking and "what the bar looks like" have to be separate.
  function renderTime(t) {
    var d = video.duration || 0;
    var pct = d ? clamp((t / d) * 100, 0, 100) : 0;
    progressPlayed.style.width = pct + '%';
    progressHandle.style.left = pct + '%';
    curTimeEl.textContent = fmt(t);
    progress.setAttribute('aria-valuenow', Math.round(t));
    progress.setAttribute('aria-valuetext', fmt(t) + ' of ' + fmt(d));
  }

  function updateBuffered() {
    if (!video.duration || !video.buffered.length) return;
    var end = video.buffered.end(video.buffered.length - 1);
    progressBuffered.style.width = clamp((end / video.duration) * 100, 0, 100) + '%';
  }

  function togglePlay() {
    var willPlay = video.paused || video.ended;
    pulseBigBtn(willPlay);
    if (willPlay) video.play().catch(function () { /* blocked — resting "resume" icon stays visible either way */ });
    else video.pause();
  }

  function showControls() {
    root.classList.add('controls-visible');
    clearTimeout(hideTimer);
    if (!video.paused && !video.ended && !scrubbing && !volumeDragging) {
      hideTimer = setTimeout(function () { root.classList.remove('controls-visible'); }, isCoarsePointer ? 2600 : 2200);
    }
  }

  // ---- seek bar --------------------------------------------------------------------------
  // The one rule that matters here: video.currentTime is only ever assigned ONCE, on release.
  // Earlier this set currentTime on every pointermove — for a large remote file that queues up a
  // seek/byte-range-fetch per move event, and whichever one lands *last* isn't guaranteed to be the
  // one matching where the pointer actually let go, so playback could visibly resume from a slightly
  // different spot than where it was dropped. Tracking the drag purely as a visual position (plus a
  // YouTube-style floating time tooltip) and committing exactly one real seek on pointerup removes
  // that race entirely, and matches how every mainstream player scrubs a long video.
  function wireProgressBar() {
    function ratioFromEvent(e) {
      var r = progress.getBoundingClientRect();
      return clamp((e.clientX - r.left) / r.width, 0, 1);
    }
    function positionTooltip(ratio) {
      progressTooltip.style.left = (ratio * 100) + '%';
    }
    function showTooltipAt(ratio) {
      if (!video.duration) return;
      progressTooltip.textContent = fmt(ratio * video.duration);
      positionTooltip(ratio);
      progressTooltip.hidden = false;
    }
    function setVisual(ratio) {
      var pct = clamp(ratio * 100, 0, 100);
      progressPlayed.style.width = pct + '%';
      progressHandle.style.left = pct + '%';
      if (video.duration) curTimeEl.textContent = fmt(ratio * video.duration);
    }

    progress.addEventListener('pointerdown', function (e) {
      if (!video.duration) return;
      scrubbing = true;
      wasPlayingBeforeScrub = !video.paused;
      video.pause();
      progress.setPointerCapture(e.pointerId);
      progress.classList.add('is-scrubbing');
      var ratio = ratioFromEvent(e);
      setVisual(ratio);
      showTooltipAt(ratio);
      showControls();
    });
    progress.addEventListener('pointermove', function (e) {
      if (scrubbing) {
        var ratio = ratioFromEvent(e);
        setVisual(ratio);
        showTooltipAt(ratio);
      } else if (e.pointerType === 'mouse' && video.duration) {
        // Hover preview only — the real played-bar/handle stay exactly where actual playback is;
        // only the floating tooltip follows the cursor, same as YouTube's scrub-preview.
        showTooltipAt(ratioFromEvent(e));
      }
    });
    progress.addEventListener('pointerleave', function () {
      if (!scrubbing) progressTooltip.hidden = true;
    });
    // Defensive: verify the seek actually landed near the target instead of trusting it silently —
    // seen occasionally, where the assignment appeared to take but currentTime settled back near 0
    // shortly after anyway. A fixed timeout here was the wrong tool for this: seeking into a part of
    // a large 1080p file that isn't buffered yet can legitimately take anywhere from instant to a
    // couple of seconds depending on the network, and a timeout tuned for the fast case fires (and
    // "verifies") before a slow one has actually finished — reading a stale currentTime and either
    // declaring success too early or retrying while the first attempt was still genuinely in flight.
    // The browser's own `seeked` event doesn't have that problem: it only fires once the seek has
    // truly completed, however long that took, so waiting for it (with a generous timeout as a safety
    // net in case it never fires) tracks reality instead of guessing at it. Playback only resumes once
    // that's confirmed, so a retry — up to a few, now, since a flaky connection may need more than one
    // — only ever re-seeks a video that's still genuinely paused, never one already playing again.
    function seekAndResume(target, shouldResume) {
      var attempts = 0;
      var maxAttempts = 3;
      var done = false;
      var fallbackTimer = null;

      function finish() {
        if (done) return;
        done = true;
        video.removeEventListener('seeked', onSeeked);
        clearTimeout(fallbackTimer);
        if (shouldResume) video.play().catch(function () {});
      }
      function landedNearTarget() {
        return video.duration && Math.abs(video.currentTime - target) <= 2;
      }
      function attempt() {
        attempts++;
        video.currentTime = target;
        clearTimeout(fallbackTimer);
        fallbackTimer = setTimeout(function () {
          // 'seeked' hasn't fired within a generous window — check directly rather than wait forever.
          if (landedNearTarget() || attempts >= maxAttempts) finish();
          else attempt();
        }, 1500);
      }
      function onSeeked() {
        if (landedNearTarget() || attempts >= maxAttempts) finish();
        else attempt(); // the browser says it seeked, but not to where we asked — try again
      }
      video.addEventListener('seeked', onSeeked);
      attempt();
    }
    function endScrub(e) {
      if (!scrubbing) return;
      scrubbing = false;
      progress.classList.remove('is-scrubbing');
      try { progress.releasePointerCapture(e.pointerId); } catch (err) {}
      progressTooltip.hidden = true;
      seekAndResume(ratioFromEvent(e) * video.duration, wasPlayingBeforeScrub);
    }
    progress.addEventListener('pointerup', endScrub);
    progress.addEventListener('pointercancel', function (e) {
      // Aborted, not released — snap the visuals back to reality instead of committing a seek.
      if (!scrubbing) return;
      scrubbing = false;
      progress.classList.remove('is-scrubbing');
      try { progress.releasePointerCapture(e.pointerId); } catch (err) {}
      progressTooltip.hidden = true;
      renderTime(video.currentTime);
      if (wasPlayingBeforeScrub) video.play().catch(function () {});
    });
    progress.addEventListener('keydown', function (e) {
      if (!video.duration) return;
      var step = video.duration * 0.02;
      if (e.key === 'ArrowRight') { video.currentTime = clamp(video.currentTime + step, 0, video.duration); showControls(); }
      else if (e.key === 'ArrowLeft') { video.currentTime = clamp(video.currentTime - step, 0, video.duration); showControls(); }
      else if (e.key === 'Home') { video.currentTime = 0; }
      else if (e.key === 'End') { video.currentTime = video.duration; }
      else return;
      e.preventDefault();
      e.stopPropagation(); // the slider owns arrow keys while it's focused — don't let the global 5s-skip shortcut also fire
    });
  }

  // ---- volume slider (desktop-only; hidden on iOS and on touch, see CSS) -----------------
  function renderVolume() {
    var pct = video.muted ? 0 : clamp(video.volume * 100, 0, 100);
    volumeFill.style.width = pct + '%';
    volumeHandle.style.left = pct + '%';
    volumeWrap.querySelector('.hm-player__volume-slider').setAttribute('aria-valuenow', Math.round(pct));
  }
  function wireVolumeSlider(slider) {
    function ratioFromEvent(e) {
      var r = volumeTrack.getBoundingClientRect();
      return clamp((e.clientX - r.left) / r.width, 0, 1);
    }
    function apply(ratio) {
      video.muted = false;
      video.volume = ratio;
      renderVolume(); // don't wait on the volumechange round-trip — reflect it immediately, every time
    }
    slider.addEventListener('pointerdown', function (e) {
      if (!volumeControllable) return;
      volumeDragging = true;
      slider.setPointerCapture(e.pointerId);
      apply(ratioFromEvent(e));
    });
    slider.addEventListener('pointermove', function (e) {
      if (!volumeDragging) return;
      apply(ratioFromEvent(e));
    });
    function endDrag(e) {
      if (!volumeDragging) return;
      volumeDragging = false;
      try { slider.releasePointerCapture(e.pointerId); } catch (err) {}
      // A mouse/touch drag leaves the slider focused (it's tabindex="0", for real keyboard users),
      // and the reveal-on-hover CSS also matches :focus-within so Tab navigation can see it without
      // hovering — but that same rule then keeps it pinned open after a *mouse* drag ends and the
      // pointer moves away, since focus outlives the gesture. Blurring here only fires for a pointer
      // interaction (keyboard users never reach this handler), so real Tab-focus reveal is untouched.
      slider.blur();
    }
    slider.addEventListener('pointerup', endDrag);
    slider.addEventListener('pointercancel', endDrag);
    slider.addEventListener('keydown', function (e) {
      if (!volumeControllable) return;
      if (e.key === 'ArrowRight' || e.key === 'ArrowUp') { apply(clamp(video.volume + 0.1, 0, 1)); }
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') { apply(clamp(video.volume - 0.1, 0, 1)); }
      else return;
      e.preventDefault();
      e.stopPropagation();
    });
  }

  // ---- fullscreen (with iOS Safari fallback) -----------------------------------------------
  function toggleFullscreen() {
    var isFs = document.fullscreenElement || document.webkitFullscreenElement;
    if (isFs) {
      if (document.exitFullscreen) document.exitFullscreen();
      else if (document.webkitExitFullscreen) document.webkitExitFullscreen();
      return;
    }
    if (stage.requestFullscreen) stage.requestFullscreen().catch(function () {});
    else if (stage.webkitRequestFullscreen) stage.webkitRequestFullscreen();
    else if (video.webkitEnterFullscreen) video.webkitEnterFullscreen(); // iPhone Safari: no container fullscreen API at all
  }

  function isLandscapeFullscreen() {
    var isFs = !!(document.fullscreenElement || document.webkitFullscreenElement);
    return isFs && window.innerWidth > window.innerHeight;
  }

  // ---- pinch-to-fill (landscape fullscreen only) ------------------------------------------
  // The gesture most people already know from their phone's own photo viewer or YouTube's app: pinch
  // outward on a fullscreen, landscape video to crop it edge-to-edge - covering the notch/camera
  // cutout area too, not just avoiding it - pinch back in to return to the normal, fully-visible
  // letterboxed view (see .hm-player.is-filled in our-story.css for the actual crop). Scoped tightly
  // to fullscreen + landscape: the same two-finger gesture anywhere else would only fight the page's
  // own pinch-to-zoom for no benefit, since there's no notch/cutout to reach around outside of a
  // genuine fullscreen video in the first place.
  function wirePinchToFill() {
    var points = {};
    var active = false;
    var startDist = 0;
    var lastDist = 0;

    function dist() {
      var ids = Object.keys(points);
      if (ids.length < 2) return 0;
      var a = points[ids[0]], b = points[ids[1]];
      return Math.hypot(a.x - b.x, a.y - b.y);
    }

    stage.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'touch') return;
      points[e.pointerId] = { x: e.clientX, y: e.clientY };
      // Only arms once a genuine *second* finger joins, and only while actually in landscape
      // fullscreen - checked here, at the moment the gesture starts, rather than continuously, so a
      // device rotation or fullscreen exit mid-gesture can't retroactively change what's already
      // in progress.
      if (Object.keys(points).length === 2 && isLandscapeFullscreen()) {
        startDist = dist();
        lastDist = startDist;
        active = true;
      }
    });
    stage.addEventListener('pointermove', function (e) {
      if (points[e.pointerId] === undefined) return;
      points[e.pointerId] = { x: e.clientX, y: e.clientY };
      if (active) lastDist = dist();
    });
    function release(e) {
      if (points[e.pointerId] === undefined) return;
      delete points[e.pointerId];
      if (!active || Object.keys(points).length >= 2) return; // still 2+ fingers down - gesture continues
      active = false;
      var ratio = startDist ? lastDist / startDist : 1;
      // A dead zone either side of 1 - a short, deliberate pinch commits to one state or the other;
      // two fingers that barely moved (just resting on the screen, or a tiny accidental drift) leave
      // whichever state the player was already in alone, rather than flipping it on noise - and, since
      // nothing actually changed, there's nothing worth confirming with a toast either.
      if (ratio > 1.15 && !player.classList.contains('is-filled')) {
        player.classList.add('is-filled');
        showZoomToast(true);
      } else if (ratio < 0.87 && player.classList.contains('is-filled')) {
        player.classList.remove('is-filled');
        showZoomToast(false);
      }
    }
    stage.addEventListener('pointerup', release);
    stage.addEventListener('pointercancel', release);
  }

  // Brief YouTube-style confirmation of the new fit - pops in near the top, holds, fades on its own,
  // never something a person has to dismiss. Text-only, deliberately: an icon here would just be
  // repeating the fullscreen button's own maximize/minimize icon a second time on the same screen.
  function showZoomToast(isFilled) {
    zoomToast.textContent = isFilled ? 'Fit Screen' : 'Normal Size';
    zoomToast.classList.remove('is-visible');
    void zoomToast.offsetWidth; // restart the fade even on a rapid back-and-forth pinch
    zoomToast.classList.add('is-visible');
    clearTimeout(zoomToastTimer);
    zoomToastTimer = setTimeout(function () { zoomToast.classList.remove('is-visible'); }, 1100);
  }

  // ---- adaptive playback (real ABR, not a one-time guess) --------------------------------
  // The video is hosted as an HLS stream with multiple renditions (see the section settings) — this
  // is what actually answers "what if the network drops mid-playback": hls.js (or Safari's native
  // HLS decoder) continuously measures real throughput and switches renditions *during* playback, so
  // a connection that degrades after starting in 1080p drops to a lower rendition instead of just
  // stalling on a file it already committed to. A plain <video src="single-file.mp4"> — what this
  // used to be — cannot do that: once picked, there is no going back down mid-playback, only more
  // buffering. The plain-mp4 fallback below is only for the (rare, older) browser that can support
  // neither native HLS nor hls.js at all.
  var hls = null;
  var stopWatchdog = null;
  var currentTitle = '';
  var hlsLibPromise = null;

  function loadHlsLibrary(url) {
    if (window.Hls) return Promise.resolve(window.Hls);
    if (hlsLibPromise) return hlsLibPromise;
    hlsLibPromise = new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = url;
      s.async = true;
      s.onload = function () { window.Hls ? resolve(window.Hls) : reject(new Error('hls.js loaded but window.Hls is missing')); };
      s.onerror = function () { reject(new Error('hls.js failed to load')); };
      document.head.appendChild(s);
    });
    return hlsLibPromise;
  }

  function destroyHls() {
    if (hls) { hls.destroy(); hls = null; }
  }

  // ---- open / close --------------------------------------------------------------------
  function loadAndPlay(hlsUrl, fallbackUrl, hlsLibUrl) {
    player.dataset.state = 'loading';
    hasEverPlayed = false;
    errorBox.hidden = true;
    destroyHls();

    function playFallback() {
      video.src = fallbackUrl || hlsUrl;
      video.load();
      video.play().catch(function () {});
    }
    function playViaHlsJs(Hls) {
      if (!Hls.isSupported()) { playFallback(); return; }
      hls = new Hls({ capLevelToPlayerSize: true }); // never fetch a rendition bigger than the video is actually rendered at
      hls.on(Hls.Events.ERROR, function (event, data) {
        if (!data.fatal) return; // hls.js already retries non-fatal errors (a dropped segment, etc.) on its own
        if (data.type === Hls.ErrorTypes.NETWORK_ERROR) hls.startLoad();
        else if (data.type === Hls.ErrorTypes.MEDIA_ERROR) hls.recoverMediaError();
        else { destroyHls(); playFallback(); } // unrecoverable — fall back rather than leave a dead player
      });
      hls.loadSource(hlsUrl);
      hls.attachMedia(video);
      video.play().catch(function () {});
    }

    if (!hlsUrl) {
      playFallback();
    } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
      // Safari/iOS decode HLS natively — better than hls.js there, not worse.
      video.src = hlsUrl;
      video.load();
      video.play().catch(function () {});
    } else if (window.Hls) {
      playViaHlsJs(window.Hls);
    } else if (hlsLibUrl) {
      loadHlsLibrary(hlsLibUrl).then(playViaHlsJs).catch(playFallback);
    } else {
      playFallback();
    }
    renderVolume();
  }

  function open(hlsUrl, fallbackUrl, hlsLibUrl, title) {
    build();
    opener = document.activeElement;
    currentSrc = hlsUrl;
    currentFallback = fallbackUrl;
    currentHlsLib = hlsLibUrl;
    currentTitle = title || '';
    if (title) root.setAttribute('aria-label', title);
    setupMediaSession();

    var sbw = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.setProperty('--hm-lb-sbw', sbw + 'px');
    document.documentElement.classList.add('hm-lb-lock');
    Array.prototype.forEach.call(document.body.children, function (el) {
      if (el !== root && !el.hasAttribute('inert')) { el.setAttribute('inert', ''); el.dataset.videoInert = '1'; }
    });

    root.hidden = false;
    root.getBoundingClientRect();
    root.classList.add('is-open', 'controls-visible');
    loadAndPlay(hlsUrl, fallbackUrl, hlsLibUrl);
    closeBtn.focus({ preventScroll: true });

    // A phone's back button/gesture is, by default, "leave this page" - exactly wrong for a modal
    // sitting on top of it. Pushing a throwaway history entry (same URL - nothing about the address
    // bar changes) means the browser's *first* back press only pops that, which popstate below turns
    // into closing the modal instead of actually navigating anywhere; the page underneath is still
    // sitting right there, completely unaffected, for a genuine second back press to leave normally.
    history.pushState({ hmVideoModalOpen: true }, '', location.href);
  }

  function close() {
    if (!root || root.hidden) return;
    clearTimeout(hideTimer);
    root.classList.remove('is-open');
    if (document.fullscreenElement || document.webkitFullscreenElement) {
      (document.exitFullscreen || document.webkitExitFullscreen || function () {}).call(document);
    }
    var finish = function () {
      video.pause();
      destroyHls();
      video.removeAttribute('src');
      video.load();
      if ('mediaSession' in navigator) {
        navigator.mediaSession.playbackState = 'none';
        navigator.mediaSession.metadata = null;
      }
      root.hidden = true;
      document.documentElement.classList.remove('hm-lb-lock');
      Array.prototype.forEach.call(document.body.children, function (el) {
        if (el.dataset.videoInert) { el.removeAttribute('inert'); delete el.dataset.videoInert; }
      });
      if (opener && opener.focus) opener.focus({ preventScroll: true });
    };
    if (reduce.matches) finish();
    else setTimeout(finish, 260); // matches the CSS close transition

    // Closed by anything *other* than the back button (the X, the backdrop, Escape, a trigger
    // re-click…) - the throwaway history entry open() pushed is still sitting there on top, so this
    // consumes it to match: one logical "close" should only ever cost one logical "back" to undo,
    // never two. history.state no longer carries the marker once the back button itself was what got
    // here instead (popstate already popped it before this function even ran) - that's what stops
    // this same line from firing a *second* back and eating a step of real page history too.
    if (history.state && history.state.hmVideoModalOpen) history.back();
  }

  // The HLS URL may arrive base64-encoded (data-video-src-b64) rather than plain (data-video-src) —
  // see store/sections/our-story.liquid for why: Shopify's own Liquid rendering silently rewrites a
  // literal ".m3u8" URL in the output into a broken relative path, and base64 keeps that substring
  // out of the rendered HTML entirely so there's nothing for it to catch.
  function readVideoSrc(trigger) {
    var b64 = trigger.getAttribute('data-video-src-b64');
    if (b64) { try { return atob(b64); } catch (err) {} }
    return trigger.getAttribute('data-video-src');
  }

  triggers.forEach(function (trigger) {
    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      open(
        readVideoSrc(trigger),
        trigger.getAttribute('data-video-fallback'),
        trigger.getAttribute('data-video-hls-lib'),
        trigger.getAttribute('data-video-title')
      );
    });
  });
})();

(function () {
  var select = document.querySelector('[data-collection-sort]');
  if (!select) return;

  select.addEventListener('change', function () {
    var base = select.getAttribute('data-base-url') || window.location.pathname;
    var url = base + '?sort_by=' + encodeURIComponent(select.value);
    window.location.href = url;
  });
})();

// Tabs on the full search results page (sections/main-search.liquid) - lets someone narrow a mixed
// Products/Collections/Pages/Journal results page down to just one type. Only present at all when the
// page actually rendered a tab bar (main-search.liquid only renders one when 2+ types have a match -
// with just one type there's nothing to switch between, so this is a safe no-op everywhere else,
// including every other page on the site).
//
// Deliberately shows/hides one already-rendered set of sections rather than keeping separate markup
// per tab - there's only ever one DOM to keep in sync this way, and it's a handful of elements.
(function () {
  'use strict';

  var tabsEl = document.querySelector('[data-search-tabs]');
  if (!tabsEl) return;

  var sections = Array.prototype.slice.call(document.querySelectorAll('[data-search-type]'));
  var tabs = Array.prototype.slice.call(tabsEl.querySelectorAll('[data-search-tab]'));
  // Pagination only ever covers products/pages/articles (search.results) - collections are a separate,
  // unpaginated match (see main-search.liquid) - so it has nothing to show while that tab's selected.
  var paginatedEl = document.querySelector('[data-search-paginated]');

  function select(type) {
    sections.forEach(function (s) {
      s.hidden = type !== 'all' && s.getAttribute('data-search-type') !== type;
    });
    if (paginatedEl) paginatedEl.hidden = type === 'collections';
    tabs.forEach(function (btn) {
      var active = btn.getAttribute('data-search-tab') === type;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-selected', active ? 'true' : 'false');
    });
  }

  tabsEl.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-search-tab]');
    if (!btn || btn.classList.contains('is-active')) return;
    select(btn.getAttribute('data-search-tab'));
  });

  // Left/Right arrow keys move between tabs when one is focused - the standard ARIA tablist keyboard
  // pattern, since these carry role="tab" (see main-search.liquid).
  tabsEl.addEventListener('keydown', function (e) {
    if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
    var current = tabs.indexOf(document.activeElement);
    if (current === -1) return;
    e.preventDefault();
    var next = e.key === 'ArrowRight' ? (current + 1) % tabs.length : (current - 1 + tabs.length) % tabs.length;
    tabs[next].focus();
    select(tabs[next].getAttribute('data-search-tab'));
  });
})();

// Themed clear ("x") button for the search results page's own query box (sections/main-search.liquid)
// - replaces the browser's native type="search" cancel button (a default grey icon with no theming,
// and one Firefox doesn't even render at all) with one that matches the rest of the site and actually
// works the same way everywhere. Page-specific, like collection-sort.js - a safe no-op anywhere else.
(function () {
  'use strict';

  var input = document.querySelector('[data-search-page-input]');
  var clearBtn = document.querySelector('[data-search-page-clear]');
  if (!input || !clearBtn) return;

  function sync() {
    clearBtn.hidden = input.value.length === 0;
  }

  input.addEventListener('input', sync);
  clearBtn.addEventListener('click', function () {
    input.value = '';
    input.focus();
    sync();
  });
})();
